import {
    Autocomplete, Box, Button, Checkbox, Chip, CircularProgress, Dialog, DialogContent, DialogTitle, FormControlLabel, FormHelperText, Grid,
    IconButton, InputAdornment, Radio, RadioGroup, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,Divider, Popover,
    TextField, Tooltip, Typography
} from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import AddBoxIcon from '@mui/icons-material/AddBox';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import EditIcon from '@mui/icons-material/Edit';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import RefreshIcon from '@mui/icons-material/Refresh';
import './commonBilling.css'
import CommonValidation from '../../../../Components/CommonFunctions/CommonValidation';
import { CurrencySymbol, TXN_MSG_MAX, TXN_MSG_MAX_LEN } from '../../../../Utility/Constants';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import { Colors } from '../../../../Styles/Colors';
import { DateTimePicker, LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { clearCachevalue, getCachevalue, localGetItem } from '../../../../Utility/Services/CacheProviderService';
import DescriptionIcon from '@mui/icons-material/Description';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { DateTime } from 'luxon';
import { AmountFormat, CheckAccessFunc, CheckCashCounterAccess,checkTransationMandatory, formatDate, formatDateAndTime, GetInvestigationName } from '../../../../Components/CommonFunctions/CommonFunctions';
import dayjs from 'dayjs';
import { BillSuccessPoPUp, ConfirmPopup, ReasonPopup, ReasonPopupWithRefund } from '../../../../Components/Common Components/CommonComponents';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import Loader from '../../../../Components/Loader';
import CommentIcon from '@mui/icons-material/Comment';

const COMMON_STYLES = {
    HEIGHT: '4.5dvh',
    FONT_SIZE_XS: '0.7rem',
    FONT_SIZE_SM: '0.8rem',
    FONT_SIZE_MD: '0.85rem',
    FONT_SIZE_L: '0.9rem',
    FONT_WEIGHT: 600
}

const MODULE_NAME = {
    LAB: 'LAB',
    RAD: 'RAD',
    OP: 'OP',
    LABORATORY_LOW: 'Laboratory',
    RADIOLOGY_LOW: 'Radiology',
    FRONT_OFFICE: 'front_office',
    RADIOLOGY_UPPER: 'RADIOLOGY',
    LABORATORY_UPPER: 'LABORATORY',
    DOCTOR: 'Doctor',
}
const Billling = (props) => {
    const [isLoader, setIsLoader] = useState(false)
    const [hasMembershipCard, setHasMembershipCard] = useState(false)   
    const [dialogOpen, setDialogOpen] = useState(false)
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [billing, setBilling] = useState({
        billingList: [],
        dupBillList: '[]',
        billDocSugg: [],
        tempPackSugg: [],
        serviceSugg: [],
        selected_bill_doc: null,
        selected_bill_doc_id: null,
        selected_service: null,
        selected_temp_pack: null,
        service_data: {
            rate_per_unit: '', unit: 1, unit_type: 'Nos', total_amt: '', total_with_discount: '',
            doctor_amt: '', doctor_percent: '', old_doctor_amt: '', new_doctor_amt: '',
            hospital_amt: '', hospital_percent: '', old_hospital_amt: '', new_hospital_amt: '',
            interval_time: '', interval_amount: '', service_name: '', service_head_name: '',
            service_code: '', service_head_code: '', edit_unit: false, edit_amount: false,
            edit_discount: false, doctor_name: '', doctor_id: '', start_time: '',
            end_time: '', doc_discount_amt: '', doc_discount_percent: '',
            hos_discount_amt: '', hos_discount_percent: '', concession_amt: '',
            concession_percent: '', gst_percent: 0, hours: '', minutes: '',
            concession_comments: '', service_details_id: '', doctor_id: '',
            review_days: '', review_count: '', charge_id: '',
            gst_amount: '', sgst_amount: '', cgst_amount: '', igst_amount: '',
            taxable_amount: '', sub_total_amount: '', round_off: '',
            received_amount: '', net_amount: '', concession_percent_w_r: '',
            doc_discount_percent_w_r: '', hos_discount_percent_w_r: '',
            doctor_percent_w_r: '', hospital_percent_w_r: '',
            module_type: '', start_date: new Date(), end_date: null, is_hospital: false,
            service_head_id: null, doctor_id: '', op_order_number: '',
            id: null
        },
        overall_data: {
            sub_total: '',
            round_off: '', payable_amt: '', taxable_amount: '',
            gst_amount: '', sgst_amount: '', cgst_amount: '', net_amount: '',
            concession_applicable: '', actual_sub_total_amount: ''
        },
        isCash: false, isCard: false, isUPI: false, isCheque: false, isBank: false,
        cash_amt: '', card_amt: '', card_no: '', bank_amt: '', bank_no: '', upi_amt: '',
        upi_no: '', cheque_amt: '', cheque_no: '',
        isEdit: false, selectedIndex: null, startTimeOpen: false, endTimeOpen: false,
        checkAll: true, checkOP: true, checkLab: true, checkPharmacy: true,
        checkRadiology: true, checkCanteen: true,
        patientData: {}, openDeletePopup: false, deleted_service: null, cancelled_ids: [],
        deletedIndex: null, deleteRadio: 'remove', cancel_reason: '', insuranceData: [],selectedInsurance:null,policyno:'',
        corporateData: [], creditType: false, selectedCorporate: null, patientCreditType: 'patientcredit',
        employeeNo: '', bill_id: null, selectDoc: true, concessionReason: '', reasonPopup: false,
        postLoad: false, openCancelPopup: false, received_amount: 0, selectedCorportateId: null,
        dupBillDocSugg: '[]', fromTemplate: false, corporateServiceList: [], selectedCorporateService: null,
        overallDiscount: { discount_amount: '', discount_percentage: '', discount_percentage_w_r: '' },
        tempBillData: null, triggerReject: false, selectedSubIndex: null, selectedServiceIndex: null, tempoverallDis: '', temptotalConc: 0, dupPatientData : {},
        credit_due_date: null, creditDueOpen: false,
    })
    let loggedInUserInfo = JSON.parse(localGetItem('loggedInUserInfo'))
    let autoFetchAmount = localGetItem('auto_fetch_bill_amount_to_payment')
    const currentPath = window.location.pathname;
    const [loginInfo, setLoginInfo] = useState(loggedInUserInfo)
    const [popupValues, setPopupValues] = useState({})
    const [openPopup, setOpenPopup] = useState(null)
    const [selectedRadio, setSelectedRadio] = useState('input')
    const [appontimentId, setAppointmentId] = useState(null)
    const [IsWarning, setIsWarning] = useState(false);
    const [isDelete, setIsDelete] = useState(false);
    const [tempDup, settempDup] = useState([]);
    const [overallDiscount, setOverallDiscount] = useState({ discount_amount: '', discount_percentage: '', discount_comments: '' })
    const [hasDuplicate, setHasDuplicate] = useState(false)
    const [annualFeeAlert, setAnnualFeeAlert] = useState(false)
    const [annualFeeList, setAnnualFeeList] = useState([])
    const [requestState, setRequestState] = useState({
        approverList: [],
        selectedApprover: null,
        remarks: '',
        hasConcession: false,
        fromApprover: false,
        fromPendingList: false,
        selectedApproverId: null,
        modifyApprover: false,
        pending_list_id: null,
        requested_from: '',
        rejected_remarks: "",
        fromBillConvert: false,
        pendingCancel: false,
        totalConcession: 0,
        RequestComments: ""
    })
    const [message, setMessage] = useState({
        isErrorMsgText: '',
        successMsgText: '',
        isErrorMsg: false,
        successMsg: false,
    })
    const [successPopup, setSuccessPopup] = useState({
        SuccessInvoice_ID: null,
        isCredit: false,
        bill_receipt_id: null,
        patiendId: null,
        successText: '',
        is_issued_drug: false,
    })
    let history = useHistory()
    const [historyData, setHistoryData] = useState({})
    const [isCancelFailed, setIsCancelFailed] = useState("pass");
    const [searchKey, setsearchKey] = useState("");
    const [ServiceCount, setServiceCount] = useState(false)
    const [refDocList, setrefDocList] = useState([])
    const [selectedRefDoc, setselectedRefDoc] = useState(null);
    const [InputRefDoc, setInputRefDoc] = useState('');
    const [futureAppointments, setFutureAppointments] = useState([]) 
    const [hasValiuptoDate, setHasValiuptoDate] = useState(null)
    const [dialogFuture, setDialogFuture] = useState(false)

    const errorMessage = (message) => {
        setMessage({
            ...message,
            isErrorMsg: true,
            isErrorMsgText: message,
            transmit: false,
            saveLoad: false
        })
        setBilling((prev) => ({ ...prev, postLoad: false }))
    }

    const successMessage = (message) => {
        setMessage({
            ...message,
            successMsg: true,
            successMsgText: message,
        })
    }

    const msgClose = () => {
        setMessage({
            ...message,
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    // API INTEGRATION STARTS =====>

    // COMPONENT DID MOUNT
    useEffect(() => {
        if (!loginInfo?.is_doctor) {
            getApporverListData()
        }
        getDoctorList()
        getreferralDoc()
    }, [])
    
    useEffect(() => {
        // FROM HOSPITAL BILLING
        if (Object.keys(props?.patientData)?.length > 0 && JSON.stringify(billing.patientData) !== JSON.stringify(props?.patientData)) {
            let module = ''
            if (window.location.pathname === '/OPHome/Billing/NewQuickBilling') {
                module = loginInfo?.module_name === 'Laboratory' ? 'LAB' : loginInfo?.module_name === 'Radiology' ? 'RADIOLOGY' : loginInfo?.module_name === 'Investigation' ? GetInvestigationName() : 'op'
            } else {
                module = loginInfo?.module_name === 'Laboratory' ? 'LAB' : loginInfo?.module_name === 'Radiology' ? 'RADIOLOGY' : loginInfo?.module_name === 'Investigation' ? GetInvestigationName() :
                    props.patientData?.appointment_id ? 'op' : 'self'
            }
            const { doctor_name, doctor_id, company_name, id_no, employer_id, employee_id, patient_type, appointment_id, insurance_company_name, policy_number, insurance_name, policy_no } = props?.patientData || {};
            const allow_patient_credit_bills = JSON.parse(localGetItem('allow_patient_credit_bills'));
            setBilling((prev) => {
                const updatedBilling = {
                    ...prev,
                    patientData: props.patientData,
                    dupPatientData: props.patientData,
                    selected_bill_doc: doctor_name ?? 'All',
                    selected_bill_doc_id: doctor_id ?? 'all',
                    // patientCreditType: props?.patientData?.primary_payment_type ?
                    //     (props?.patientData?.primary_payment_type === 'Patient credit' ? (allow_patient_credit_bills ? 'patientcredit' : '') : 'corporatecredit') :
                    //     (allow_patient_credit_bills === false && props.patientData?.appointment_id && company_name) ? 'corporatecredit' : 'patientcredit',
                    patientCreditType: ( props?.patientData?.primary_payment_type === 'Patient credit' ? (JSON.parse(localGetItem('allow_patient_credit_bills')) ? 'patientcredit'  : '' ) : (props?.patientData?.primary_payment_type === "Insurance credit" ? "insurancecredit"  : (props?.patientData?.primary_payment_type === 'Corporate credit' ? 'corporatecredit'  : '' ) ) ),
                    selectedCorporate: company_name,
                    selectedInsurance: insurance_company_name || insurance_name,
                    employeeNo: employee_id || id_no,
                    policyno: policy_number || policy_no,
                    selectedCorportateId: employer_id,
                    credit_due_date: props.patientData?.credit_due_date ? new Date(props.patientData?.credit_due_date) : null,
                    billingList: [],
                    bill_id : null,
                };
                if (getCachevalue('BillType') !== 'Cancel') {
                    if (JSON.stringify(billing.selected_bill_doc) !== JSON.stringify(doctor_name)) {
                        getServiceListData(doctor_id, patient_type, appointment_id, module);
                        getTemplateList(module)
                    }
                    if (doctor_id && (doctor_id !== billing.selected_bill_doc_id) && employer_id && (employer_id !== billing.selectedCorportateId)) {
                        getCorporateServiceData(doctor_id, patient_type, employer_id)
                    }
                }
                return updatedBilling;
            });
        }
        // FROM OPLIST
        if (history?.location?.state?.fromOpList || history?.location?.state?.patientId) {
            if (JSON.stringify(billing.patientData) !== JSON.stringify(props?.patientData)) {
                setBilling((prev) => {
                    const { doctor_name, doctor_id, company_name, id_no, employer_id, employee_id, patient_type, insurance_company_name, policy_number, insurance_name, policy_no } = props?.patientData || {};
                    const updatedBilling = {
                        ...prev,
                        patientData: props.patientData,
                        selected_bill_doc: doctor_name ?? 'All',
                        selected_bill_doc_id: doctor_id ?? 'all', 
                        // patientCreditType: props?.patientData?.primary_payment_type ? props?.patientData?.primary_payment_type === 'Patient credit' ? (JSON.parse(localGetItem('allow_patient_credit_bills')) ?  'patientcredit' : '') : 'corporatecredit' : 'patientcredit',
                        patientCreditType: ( props?.patientData?.primary_payment_type === 'Patient credit' ? (JSON.parse(localGetItem('allow_patient_credit_bills')) ? 'patientcredit'  : '' ) : (props?.patientData?.primary_payment_type === "Insurance credit" ? "insurancecredit"  : (props?.patientData?.primary_payment_type === 'Corporate credit'  ? 'corporatecredit'  : '' ) ) ),
                        selectedCorporate: company_name,
                        selectedInsurance: insurance_company_name || insurance_name,
                        employeeNo: employee_id || id_no,
                        policyno:policy_number || policy_no,
                        selectedCorportateId: employer_id,
                        billingList: [],
                        credit_due_date: props.patientData?.credit_due_date ? new Date(props.patientData?.credit_due_date) : null,
                    };
                    // if (JSON.stringify(billing.selected_bill_doc) !== JSON.stringify(doctor_name)) {
                    //     getServiceListData(doctor_id, patient_type);
                    // }
                    return updatedBilling;
                });

            }
        }
        // FROM DRAFT AND ORDER
        if (
            history?.location?.state?.fromDraft || history?.location?.state?.fromOrder ||
            history?.location?.state?.pendingDraft || history?.location?.state?.pendingOrder
        ) {
            if (props?.draftData?.length > 0 || Object.keys(props?.orderData)?.length > 0) {
                if (Object.keys(props?.orderData)?.length > 0 && !history?.location?.state?.fromOrder && props?.draftData?.length === 0 && billing.billingList?.some(item => item?.order_id === props?.orderData?.order_id)) {
                    errorMessage('This order is already fetched in the billing list.');
                } else {
                    let draftData = []; let orderList = []; let billData = [];
                    let data = props?.draftData[0]
                    let orderData = props?.orderData
                    let draftOrderData = props?.draftData[0] ? props?.draftData[0] : props?.orderData
                    if (history?.location?.state?.fromDraft) {
                        draftData = setBillingListData(data?.bill_line_items, "", false, false)
                        billData = [...draftData]
                    } else if (history?.location?.state?.fromOrder) {
                        orderList = setBillingListData(orderData?.order_line_items, "", false, false)
                        orderList = orderList?.map((item) => {
                            return {
                                ...item,
                                order_id: props?.orderData?.order_id ?? null,
                            }
                        })
                        billData = [...orderList]
                    } else if (history?.location?.state?.pendingDraft) {
                        draftData = setBillingListData(data?.bill_line_items, "", false, false)
                        billData = [...draftData]
                        let refDoc = { name: (data?.referred_doctor_name || ''), specialization: (data?.referred_doctor_spec || ''), qualification: (data?.referred_doctor_qual || '') }
                        setselectedRefDoc(refDoc)
                    } else if (history?.location?.state?.pendingOrder) {
                        orderList = setBillingListData(orderData?.order_line_items, "", false, false)
                        let orderFilter = billing.billingList?.filter(item => item?.bill_type !== 'Draft')
                        orderList = orderList?.map((item) => {
                            return {
                                ...item,
                                order_id: props?.orderData?.order_id ?? null,
                            }
                        })
                        billData = [...orderFilter, ...orderList]
                    }
                    setBilling((prev) => {
                        const {
                            doctor_name, doctor_id, company_name,
                            id_no, employee_id, employer_id, patient_type, policy_number, policy_no,
                            appointment_id, insurance_company_name, insurance_name } = props?.patientData || {};
                        const updatedBilling = {
                            ...prev,
                            patientData: props.patientData,
                            selected_bill_doc: (doctor_name || data?.doctor_name) ?? 'All',
                            selected_bill_doc_id: (doctor_id || data?.doctor_id) ?? 'all',
                            // patientCreditType: props?.patientData?.primary_payment_type ? props?.patientData?.primary_payment_type === 'Patient credit' ? (JSON.parse(localGetItem('allow_patient_credit_bills')) ?  'patientcredit' : '') : 'corporatecredit' : 'patientcredit',
                            patientCreditType: ( props?.patientData?.primary_payment_type === 'Patient credit' ? (JSON.parse(localGetItem('allow_patient_credit_bills')) ? 'patientcredit'  : '' ) : (props?.patientData?.primary_payment_type === "Insurance credit" ? "insurancecredit"  : (props?.patientData?.primary_payment_type === 'Corporate credit' ? 'corporatecredit'  : '' ) ) ),
                            selectedCorporate: company_name,
                            selectedInsurance: insurance_company_name || insurance_name,
                            employeeNo: employee_id || id_no,
                            policyno : policy_number || policy_no,
                            selectedCorportateId: employer_id,
                            billingList: [...billData],
                            overallDiscount: {
                                discount_amount: data?.discount_amount ? data?.discount_amount : '',
                                discount_percentage: data?.overall_discount_percentage ? data?.overall_discount_percentage : '',
                                discount_percentage_w_r: data?.overall_discount_percentage ? (+data?.overall_discount_percentage)?.toFixed(2) : '',
                            },
                            bill_id: props?.draftData?.length > 0 ? data?.id : null,
                            order_id: props?.draftData?.length === 0 ? null : data?.order_id,
                            concessionReason: data?.overall_concession_comments || '',
                            credit_due_date: props.patientData?.credit_due_date ? new Date(props.patientData?.credit_due_date) : null,
                        };
                        // if (JSON.stringify(billing.patientData) !== JSON.stringify(props.patientData) && getCachevalue('BillType') !== 'Cancel') {
                        //     getServiceListData(doctor_id, patient_type, appointment_id);
                        // }
                        return updatedBilling;
                    })
                }
            }
        }
        // FROM MODIFY AND CANCEL BILL
        if (
            (props?.billingData?.length > 0 && JSON.stringify(props?.billingData) !== JSON.stringify(billing.tempBillData))
            && (history?.location?.state?.fromPatientBills || history?.location?.state?.fromPatientSavedBill)
        ) {
            let billingData = props?.billingData[0]
            let data = setBillingListData(billingData?.bill_line_items, "", false, false)

            const billLineItems = billingData?.bill_line_items || [];
            const totalConcession = billLineItems.reduce((acc, item) => {
                return acc + (parseFloat(item?.discount_amount) || 0);
            }, 0);

            setBilling((prev) => ({
                ...prev,
                tempBillData: props?.billingData,
                patientData: props?.patientData,
                selected_bill_doc: (props?.patientData?.doctor__first_name || props?.patientData?.doctor_name) ?? 'All',
                selected_bill_doc_id: props?.patientData?.doctor_id ?? 'all',
                billingList: data,
                overallDiscount: {
                    discount_amount: billingData?.discount_amount ? billingData?.discount_amount : '',
                    discount_percentage: billingData?.overall_discount_percentage ? billingData?.overall_discount_percentage : '',
                    discount_percentage_w_r: billingData?.overall_discount_percentage ? (+billingData?.overall_discount_percentage)?.toFixed(2) : '',
                },
                bill_id: props?.billingData?.length > 0 ? billingData?.id : null,
                order_id: props?.billingData?.length === 0 ? null : data?.order_id,
                received_amount: billingData?.received_amount,
                concessionReason: billingData?.overall_concession_comments || '',
                tempoverallDis: billingData?.discount_amount ? billingData?.discount_amount : '',
                temptotalConc: totalConcession || 0,
                credit_due_date: props.patientData?.credit_due_date ? new Date(props.patientData?.credit_due_date) : null,
            }))
            let refDoc = {name: (billingData?.referred_doctor_name || ''), specialization: (billingData?.referred_doctor_spec || ''), qualification: (billingData?.referred_doctor_qual || '')}
            setselectedRefDoc(refDoc)
        }
        if (billing.overall_data.concession_applicable !== 0 && billing.overallDiscount.discount_amount && billing.concessionReason === '' && getCachevalue('BillType') !== 'Cancel') {
            setTimeout(() => {
                setBilling((prev) => ({ ...prev, reasonPopup: true }))
            }, 2000)
        }

        if (history?.location?.state?.fromPendingList) {
            setRequestState((prev) => ({
                ...prev,
                fromPendingList: true, pending_list_id: history?.location?.state?.pending_list_id,
                fromApprover: false, fromBillConvert: false, selectedApproverId: history?.location?.state?.approver_id,
                selectedApprover: history?.location?.state?.approver_name,
                remarks: history?.location?.state?.remarks,
                requested_from: history?.location?.state?.requested_from,
            }))
        }
        // FROM PENDING LIST
        if (
            (props?.billingData?.length > 0 && JSON.stringify(props?.billingData) !== JSON.stringify(billing.tempBillData))
            && history?.location?.state?.fromPendingList
        ) {
            let billingData = props?.billingData[0]
            let data = setBillingListData(billingData?.bill_line_items, "", false, false)
            setBilling((prev) => ({
                ...prev,
                tempBillData: props?.billingData,
                patientData: props?.patientData,
                selected_bill_doc: (props?.patientData?.doctor__first_name || props?.patientData?.doctor_name) ?? 'All',
                selected_bill_doc_id: props?.patientData?.doctor_id ?? 'all',
                billingList: data,
                overallDiscount: {
                    discount_amount: billingData?.discount_amount ? billingData?.discount_amount : '',
                    discount_percentage: billingData?.overall_discount_percentage ? billingData?.overall_discount_percentage : '',
                    discount_percentage_w_r: billingData?.overall_discount_percentage ? (+billingData?.overall_discount_percentage)?.toFixed(2) : '',
                },
                bill_id: props?.billingData?.length > 0 ? billingData?.id : null,
                order_id: props?.billingData?.length === 0 ? null : data?.order_id,
                received_amount: billingData?.received_amount,
                concessionReason: billingData?.overall_concession_comments || '',
                credit_due_date: props.patientData?.credit_due_date ? new Date(props.patientData?.credit_due_date) : null,
            }))
            let refDoc = {name: (billingData?.referred_doctor_name || ''), specialization: (billingData?.referred_doctor_spec || ''), qualification: (billingData?.referred_doctor_qual || '')}
            setselectedRefDoc(refDoc)
        }
        if (history?.location?.state?.fromBillConvert) {
            setRequestState((prev) => ({
                ...prev,
                fromPendingList: false, pending_list_id: history?.location?.state?.pending_list_id,
                fromApprover: false, fromBillConvert: true,
                selectedApproverId: history?.location?.state?.approver_id,
                // selectedApprover: history?.location?.state?.approver_name,
                // remarks: history?.location?.state?.remarks,
                // requested_from: history?.location?.state?.requested_from,
            }))
        }
        // // FROM BILL CONVERT
        if (
            (props?.billingData?.length > 0 && JSON.stringify(props?.billingData) !== JSON.stringify(billing.tempBillData))
            && history?.location?.state?.fromBillConvert
        ) {
            let billingData = props?.billingData[0]
            let data = setConvertBillData(billingData?.bill_line_items)
            setBilling((prev) => ({
                ...prev,
                tempBillData: props?.billingData,
                patientData: props?.patientData,
                selected_bill_doc: (props?.patientData?.doctor__first_name || props?.patientData?.doctor_name) ?? 'All',
                selected_bill_doc_id: props?.patientData?.doctor_id ?? 'all',
                billingList: data,
                overallDiscount: {
                    discount_amount: '',
                    discount_percentage: '',
                    discount_percentage_w_r: '',
                },
                bill_id: props?.billingData?.length > 0 ? billingData?.id : null,
                order_id: props?.billingData?.length === 0 ? null : data?.order_id,
                received_amount: billingData?.received_amount,
                concessionReason: '',
                credit_due_date: props.patientData?.credit_due_date ? new Date(props.patientData?.credit_due_date) : null,
            }))
            let refDoc = {name: (billingData?.referred_doctor_name || ''), specialization: (billingData?.referred_doctor_spec || ''), qualification: (billingData?.referred_doctor_qual || '')}
            setselectedRefDoc(refDoc)
        }
        if (history?.location?.state?.fromApprover) {
            setRequestState((prev) => ({
                ...prev,
                fromApprover: true, pending_list_id: history?.location?.state?.pending_list_id,
                selectedApproverId: history?.location?.state?.approver_id,
                requested_from: history?.location?.state?.requested_from,
                fromBillConvert: false, fromPendingList: false,
                RequestComments: history?.location?.state?.patientDetails?.remarks,
            }))
        }
        if (history?.location?.state?.fromApprover)
            setRequestState((prev) => ({
                ...prev,
                fromApprover: true,
            }))
        // FROM APPROVER
        if (
            (props?.billingData?.length > 0 && JSON.stringify(props?.billingData) !== JSON.stringify(billing.tempBillData)) &&
            (history?.location?.state?.fromApprover || requestState?.fromApprover)
        ) {
            let billingData = props?.billingData[0]
            let data = setBillingListData(billingData?.bill_line_items, "", false, false)
            setBilling((prev) => ({
                ...prev,
                tempBillData: props?.billingData,
                patientData: props?.patientData,
                selected_bill_doc: (props?.patientData?.doctor__first_name || props?.patientData?.doctor_name) ?? 'All',
                selected_bill_doc_id: props?.patientData?.doctor_id ?? 'all',
                billingList: data,
                overallDiscount: {
                    discount_amount: billingData?.discount_amount ? billingData?.discount_amount : '',
                    discount_percentage: billingData?.overall_discount_percentage ? billingData?.overall_discount_percentage : '',
                    discount_percentage_w_r: billingData?.overall_discount_percentage ? (+billingData?.overall_discount_percentage)?.toFixed(2) : '',
                },
                bill_id: props?.billingData?.length > 0 ? billingData?.id : null,
                order_id: props?.billingData?.length === 0 ? null : data?.order_id,
                received_amount: billingData?.received_amount,
                concessionReason: billingData?.overall_concession_comments || '',
                selected_service: null,
                credit_due_date: props.patientData?.credit_due_date ? new Date(props.patientData?.credit_due_date) : null,
                service_data: {
                    rate_per_unit: '', unit: 1, unit_type: 'Nos', total_amt: '', total_with_discount: '',
                    doctor_amt: '', doctor_percent: '', old_doctor_amt: '', new_doctor_amt: '',
                    hospital_amt: '', hospital_percent: '', old_hospital_amt: '', new_hospital_amt: '',
                    interval_time: '', interval_amount: '', service_name: '', service_head_name: '',
                    service_code: '', service_head_code: '', edit_unit: false, edit_amount: false,
                    edit_discount: false, doctor_name: '', doctor_id: '', start_time: '',
                    end_time: '', doc_discount_amt: '', doc_discount_percent: '',
                    hos_discount_amt: '', hos_discount_percent: '', concession_amt: '',
                    concession_percent: '', gst_percent: 0, hours: '', minutes: '',
                    concession_comments: '', service_details_id: '', doctor_id: '',
                    review_days: '', review_count: '', charge_id: '',
                    gst_amount: '', sgst_amount: '', cgst_amount: '', igst_amount: '',
                    taxable_amount: '', sub_total_amount: '', round_off: '',
                    received_amount: '', net_amount: '', concession_percent_w_r: '',
                    doc_discount_percent_w_r: '', hos_discount_percent_w_r: '',
                    doctor_percent_w_r: '', hospital_percent_w_r: '',
                    module_type: '', start_date: new Date(), end_date: null, is_hospital: false,
                    service_head_id: null, doctor_id: '', op_order_number: '',
                    id: null
                },
            }))
            let refDoc = {name: (billingData?.referred_doctor_name || ''), specialization: (billingData?.referred_doctor_spec || ''), qualification: (billingData?.referred_doctor_qual || '')}
            setselectedRefDoc(refDoc)
        }
    }, [
        history?.location?.state?.fromOpList, props?.patientData,
        history?.location?.state?.fromDraft, props?.draftData,
        history?.location?.state?.fromOrder, props?.orderData,
        history?.location?.state?.pendingDraft, props?.billingData?.bill_line_items,
        history?.location?.state?.pendingOrder, props?.clearService,
        billing?.overallDiscount?.discount_amount,
        history?.location?.state?.patientId, props?.billingData,
        history?.location?.state?.fromPatientSavedBill, props?.quickBillClear,
        history?.location?.state?.fromPendingList, history?.location?.state?.fromBillConvert,
        history?.location?.state?.fromApprover
    ])

    useEffect(() => {
        let isActive = true;
        if ((props?.clearService || props.quickBillClear) && isActive) {
            clearAllData(props.quickBillClear ? true : false);
        }

        return () => {
            isActive = false;
        };
    }, [props.clearService, props.quickBillClear]);

    useEffect(() => {
        if (billing?.triggerReject) {
            setIsLoader(true)
            setTimeout(() => {
                postRiseRequestAndAccept("Rejected", requestState?.rejected_remarks);
                setBilling((prev) => ({
                    ...prev,
                    triggerReject: false
                }))
            }, 3000);
        }
    }, [billing?.triggerReject]);

    useEffect(() => {
        if (props?.fromQuickBill) {
            if (JSON.stringify(billing.patientData) !== JSON.stringify(props?.patientData)) {
                setBilling((prev) => {
                    const {
                        company_name,
                        insurance_company_name,
                        policy_number,
                        insurance_name, policy_no,
                        id_no, employee_id,
                    } = props?.patientData || {};
                    let updatePatient = {
                        ...prev,
                        patientData: props?.patientData,
                        patientCreditType: props?.patientData?.primary_payment_type === "Insurance credit" ? "insurancecredit" : props?.patientData?.primary_payment_type === "Corporate credit" ? 'corporatecredit' : 'patientcredit',
                        selectedCorporate: company_name,
                        selectedInsurance: insurance_company_name || insurance_name,
                        employeeNo: employee_id || id_no,
                        policyno: policy_number || policy_no,
                        selectedCorportateId: employee_id,
                    }
                    return updatePatient
                })
            }
            if (loginInfo?.module_name === 'front_office' || loginInfo?.module_name === 'Radiology' || loginInfo?.module_name === 'Investigation') {
                if (props?.doctorDetails?.selectedDoctor !== null && props?.patientData?.patient_id) {
                    let doctorId = props?.doctorDetails?.selectedDoctor?.doctor_id
                    let doctorName = props?.doctorDetails?.selectedDoctor?.doctor_name
                    const { patient_type, appointment_id, employer_id } = props?.patientData || {};
                    setBilling((prev) => {
                        let updateDoctor = {
                            ...prev,
                            selected_bill_doc: doctorName ?? 'All',
                            selected_bill_doc_id: doctorId ?? 'all'
                        }
                        if (JSON.stringify(billing.selected_bill_doc) !== JSON.stringify(doctorName)) {
                            let module = ''
                            if (window.location.pathname === '/OPHome/Billing/NewQuickBilling') {
                                module = loginInfo?.module_name === 'Laboratory' ? 'LAB' : loginInfo?.module_name === 'Radiology' ? 'RADIOLOGY' : loginInfo?.module_name === 'Investigation' ? GetInvestigationName() : 'op'
                            } else {
                                module = loginInfo?.module_name === 'Laboratory' ? 'LAB' : loginInfo?.module_name === 'Radiology' ? 'RADIOLOGY' : loginInfo?.module_name === 'Investigation' ? GetInvestigationName() :
                                    props.patientData?.appointment_id ? 'op' : 'self'
                            }
                            getServiceListData(doctorId, patient_type, appointment_id, module);
                            getTemplateList(module)
                        }
                        if (doctorId && (doctorId !== billing.selected_bill_doc_id) && employer_id && (employer_id !== billing.selectedCorportateId)) {
                            getCorporateServiceData(doctorId, patient_type, employer_id)
                        }
                        return updateDoctor
                    })
                }
            }
            if (loginInfo?.module_name === 'Radiology' || loginInfo?.module_name === 'Laboratory') {
                let doctorId = props?.doctorDetails?.selectedDoctor?.doctor_id
                const { patient_type, employee_id, employer_id, id_no, company_name, insurance_company_name, policy_number, insurance_name, policy_no } = props?.patientData || {};
                if (employer_id && (employer_id !== billing.selectedCorportateId)) {
                    setBilling((prev) => ({
                        ...prev,
                        selectedCorporate: company_name,
                        selectedInsurance:insurance_company_name || insurance_name,
                        employeeNo: employee_id || id_no,
                        policyno: policy_number || policy_no,
                        selectedCorportateId: employer_id,
                    }))
                    getCorporateServiceData(doctorId, patient_type, employer_id)
                }
            }
        }
    }, [
        props?.patientData, props?.doctorDetails,
        loginInfo, billing.billingList, props?.fromQuickBill
    ])

    useEffect(() => {
        if (props?.fromQuickBill && props.patientData.patient_id && loginInfo?.module_name === 'front_office') {
            try {
                const { patient_id, patient_type, appointment_id } = props?.patientData || {};
                let startDate = new Date()
                let date = DateTime.fromJSDate(startDate).toFormat('yyyy-MM-dd')
                let Aptime = DateTime.fromJSDate(startDate).toLocaleString(DateTime.TIME_24_SIMPLE);
                let params = `?module_type=OP&patient_type=${patient_type ? patient_type : ''}&patient_id=${patient_id ? patient_id : ''}&appointment_id=${appointment_id ? (props?.fromQuickBill ? '' : appointment_id) : appontimentId ? appontimentId : ''}&bill_date=${date}&bill_time=${Aptime}&doctor_id=${props?.doctorDetails?.selectedDoctor?.doctor_id ? props?.doctorDetails?.selectedDoctor?.doctor_id : ''}&ward_id=${''}`
                if (localGetItem('enable_specialization_auto_bill') == "true") {
                    params += `&specialization_id=${props?.doctorDetails?.selectedSpecName?.id || ''}`;
                }
                if (!props?.doctorDetails?.selectedSpecName?.id && props?.doctorDetails?.selectedDoctor?.doctor_id && localGetItem('enable_specialization_auto_bill') == "true") {
                    return
                }
                RestAPIService.getAll(Serviceurls.NEW_AUTO_BILLING_GET + params)
                    .then((response) => {
                        if (response?.data?.status === 'success') {
                            let billList = setBillingListData(response?.data?.data?.filter((list)=>(list?.autobilling_type !== "yearly")), "", true)
                            setBilling((prev) => ({ ...prev, billingList: [...prev.billingList?.filter((list) => (!list?.from_auto_billing)), ...billList] }))

                            let AnnualserviceData = response?.data?.data?.filter((list)=>(list?.autobilling_type === "yearly"));
                            if(AnnualserviceData?.length){
                                setAnnualFeeList(AnnualserviceData)
                            }
                        }
                    }).catch((error) => {
                        if (error?.response?.data?.message) {
                            errorMessage(error?.response?.data?.message)
                        } else {
                            errorMessage(error.message)
                        }
                    })
            } catch (error) {
                errorMessage(error.message)
            }
        }
    }, [props?.fromQuickBill, props?.patientData?.patient_id, props?.doctorDetails?.selectedDoctor?.doctor_id, props?.doctorDetails?.selectedSpecName?.id])

    useEffect(() => {
        setBilling((prev) => ({
            ...prev,
            billingList: prev?.billingList?.some((item) => (item?.membership_discount_percentage)) ? [] : prev?.billingList,
        }))
        if (props?.patientData?.is_memberships){
            setHasMembershipCard(true)
        } else{
            setHasMembershipCard(false)
        }
    }, [props.patientData.patient_id !== billing?.patientData?.patient_id, props?.patientData?.is_memberships])

    useEffect(() => {
        if(props?.patientData?.patient_id && loginInfo?.module_name === 'front_office' ){
            getFutureAppointmentData()
        }
    },[props.patientData.patient_id])

    useEffect(()=>{
        if((loginInfo?.review_period_based_on === 'clinic' || loginInfo?.review_period_based_on === 'doctor') && props?.doctorDetails?.selectedDoctor?.doctor_id && props.patientData.patient_id){
            getValidUptoData()
        }else if(loginInfo?.review_period_based_on === 'specialization' && props?.doctorDetails?.selectedSpecName?.id && props.patientData.patient_id){
            getValidUptoData()
        }
    },[loginInfo?.review_period_based_on === 'specialization'? props?.doctorDetails?.selectedSpecName?.id : '', loginInfo?.review_period_based_on === 'doctor' ? props?.doctorDetails?.selectedDoctor?.doctor_id : '', props.patientData.patient_id, props?.doctorDetails?.appointmentDateTime])


    useEffect(() => {
        if (loginInfo?.module_name === "front_office" && props?.patientData?.appointment_id && props?.patientData?.patient_id) {
            try {
                const { patient_id, patient_type, appointment_id, doctor_id, speciality_id, specialization_id } = props?.patientData || {};
                let startDate = new Date()
                let date = DateTime.fromJSDate(startDate).toFormat('yyyy-MM-dd')
                let Aptime = DateTime.fromJSDate(startDate).toLocaleString(DateTime.TIME_24_SIMPLE);
                let params = `?module_type=OP&patient_type=${patient_type ? patient_type : ''}&patient_id=${patient_id ? patient_id : ''}&appointment_id=${appointment_id ? (props?.fromQuickBill ? '' : appointment_id) : ''}&bill_date=${date}&bill_time=${Aptime}&doctor_id=${doctor_id ? doctor_id : ''}&ward_id=${''}`
                if (localGetItem('enable_specialization_auto_bill') == "true") {
                    params += `&specialization_id=${speciality_id || specialization_id || ''}`;
                }
                RestAPIService.getAll(Serviceurls.NEW_AUTO_BILLING_GET + params)
                    .then((response) => {
                        if (response?.data?.status === 'success') {
                            let billList = setBillingListData(response?.data?.data?.filter((list)=>(list?.autobilling_type !== "yearly")), "", true)
                            setBilling((prev) => ({ ...prev, billingList: [...prev.billingList?.filter((list) => (!list?.from_auto_billing)), ...billList] }))

                            let AnnualserviceData = response?.data?.data?.filter((list)=>(list?.autobilling_type === "yearly"));
                            if(AnnualserviceData?.length){
                                setAnnualFeeList(AnnualserviceData)
                            }
                        }
                    }).catch((error) => {
                        if (error?.response?.data?.message) {
                            errorMessage(error?.response?.data?.message)
                        } else {
                            errorMessage(error.message)
                        }
                    })
            } catch (error) {
                errorMessage(error.message)
            }
        }
    }, [props?.patientData?.appointment_id, props?.patientData?.patient_id])


    useEffect(() => {
        const FetchingAccess = localGetItem("auto_fetch_bill_amount_to_payment");
        if (!billing.isCash) {
            setBilling((prev) => ({
                ...prev,
                cash_amt: "",
                cash_collected: "",
                balance_amt: "",
            }));
        }
        if (!billing.isCard) {
            setBilling((prev) => ({
                ...prev,
                card_amt: "",
                card_no: "",
            }));
        }
        if (!billing.isUPI) {
            setBilling((prev) => ({
                ...prev,
                upi_amt: "",
                upi_no: "",
            }));
        }
        if (!billing.isCheque) {
            setBilling((prev) => ({
                ...prev,
                cheque_amt: "",
                cheque_no: "",
            }));
        }
        if (!billing.isBank) {
            setBilling((prev) => ({
                ...prev,
                bank_amt: "",
                bank_no: "",
            }));
        }
        if (FetchingAccess === "true") {
            setBilling((prev) => ({
                ...prev,
                cash_amt: prev.isCash && !prev.isCard && !prev.isUPI && !prev.isBank && !prev.isCheque ? prev.overall_data.payable_amt : prev.cash_amt,
                card_amt: !prev.isCash && prev.isCard && !prev.isUPI && !prev.isBank && !prev.isCheque ? prev.overall_data.payable_amt : prev.card_amt,
                upi_amt: !prev.isCash && !prev.isCard && prev.isUPI && !prev.isBank && !prev.isCheque ? prev.overall_data.payable_amt : prev.upi_amt,
                bank_amt: !prev.isCash && !prev.isCard && !prev.isUPI && prev.isBank && !prev.isCheque ? prev.overall_data.payable_amt : prev.bank_amt,
                cheque_amt: !prev.isCash && !prev.isCard && !prev.isUPI && !prev.isBank && prev.isCheque ? prev.overall_data.payable_amt : prev.cheque_amt,
            }));
        }
    }, [billing?.isCash, billing?.isCard, billing?.isUPI, billing?.isBank, billing?.isCheque]);

    useEffect(() => {
        return () => {
            setBilling((prev) => ({ ...prev, tempBillData: null }))
        }
    }, [])

    // useEffect for enter and add service to the list on edit
    useEffect(() => {
        if (billing.isEdit) {
            const el = document.querySelector('[data-billing-container]');
            el?.focus();
        }
    }, [billing.isEdit]);

    const getDoctorList = () => {
        try {
            RestAPIService.getAll(Serviceurls.FO_CONFIG_OPDOCTORNAME)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        setBilling((prev) => ({ ...prev, billDocSugg: [{ doctor_name: 'All', doctor_id: 'all' }, ...response?.data?.data] }))
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error?.response?.data?.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }
    const getreferralDoc = () => {
        try {
            const userData = JSON.parse(localGetItem('loggedInUserInfo'))
            let url = userData?.module_name === "Radiology" ? Serviceurls.RAD_REFERRAL_DOCTOR : userData?.module_name === "Laboratory" ? Serviceurls.LAB_REFERRED_DOCTOR : Serviceurls.FO_CONFIG_REF_DOCTOR
            RestAPIService.getAll(url)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        setrefDocList(response.data.data || [])
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error?.response?.data?.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const deletePendingListData = () => {
        try {
            setIsLoader(true);
            let data = {
                id: requestState?.pending_list_id
            }
            RestAPIService.delete(Serviceurls.NEW_BILLING_PENDING_LIST, data)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        setIsLoader(false);
                        setRequestState((prev) => ({ ...prev, pendingCancel: false }))
                        setIsDelete(false)
                        if (requestState.fromPendingList) {
                            clearAllData()
                            let path = getCachevalue('path')
                            history?.push({ pathname: path, state: {} })
                            setTimeout(() => {
                                clearCachevalue('path')
                                clearCachevalue('BillType')
                                clearCachevalue('FromOtherScreen')
                                clearCachevalue('isForCancelBill')
                            }, 50)
                        }
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error?.response?.data?.message)
                        setIsLoader(false);
                    } else {
                        errorMessage(error?.message)
                        setIsLoader(false);
                    }
                })
        } catch (error) {
            errorMessage(error.message)
            setIsLoader(false);
        }
    }
    const getServiceListData = (item, type = null, appointment_id = null, module, searchkey = '') => {
        try {
            let userInfo = JSON.parse(localGetItem('loggedInUserInfo'))
            let moduleType = userInfo?.module_name === MODULE_NAME.LABORATORY_LOW ? 'lab' :
                userInfo?.module_name === MODULE_NAME.RADIOLOGY_LOW ? 'radiology' : loginInfo?.module_name === 'Investigation' ? GetInvestigationName() : userInfo?.module_name === 'Canteen' ? 'canteen' :
                    appointment_id ? 'op' : 'self'
            let patType1 = (type === 'new_patient' || type === 'New Patient') ? 'New Patient' : (type === 'old_patient' || type === 'Old Patient') ? 'Old Patient' : (type === 'review_patient' || type === 'Review Patient') ? 'Review Patient' : null
            let patType2 = (billing.patientData?.patient_type === 'new_patient' || billing.patientData?.patient_type === 'New Patient') ? 'New Patient' : (billing.patientData?.patient_type === 'old_patient' || billing.patientData?.patient_type === 'Old Patient') ? 'Old Patient' :
                (billing.patientData?.patient_type === 'review_patient' || billing.patientData?.patient_type === 'Review Patient') ? 'Review Patient' : null
            let patientType = patType1 ?? patType2 ?? 'New Patient'
            let doctor_id = item ?? billing.selected_bill_doc_id ?? 'all'
            RestAPIService.getAll(
                Serviceurls.NEW_BILLING_OP_SERVICE_GET +
                '?patient_type=' + patientType +
                '&module_type=' + module +
                '&ward_id=' +
                '&doctor_id=' + doctor_id +
                '&search_key=' + searchkey +
                '&patient_id=' + props?.patientData?.patient_id +
                ((appointment_id && !props?.fromQuickBill) ? `&appointment_id=${appointment_id}` : "")
            ).then((response) => {
                if (response?.data?.status === 'success') {
                    setBilling((prev) => ({ ...prev, serviceSugg: response?.data?.data, selectDoc: true }))
                    if (!ServiceCount) {
                        setServiceCount(response.data.service_length > 1000 ? true : false)
                    }
                }
            }).catch((error) => {
                if (error?.response?.data?.message) {
                    errorMessage(error?.response?.data?.message)
                } else {
                    errorMessage(error.message)
                }
            })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const getTemplateList = (module) => {
        try {
              RestAPIService.getAll(Serviceurls.NEW_BILLING_OP_TEMPLATE_LIST + '?module_type=' + module + '&patient_id=' + props?.patientData?.patient_id || billing?.patientData?.patient_id )
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        setBilling((prev) => ({ ...prev, tempPackSugg: response?.data?.data }))
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error?.response?.data?.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const setConvertBillData = (data = [], insertPackName = '') => {
        try {
            let newBillingList = [];
            for (let i = 0; i < data?.length; i++) {
                let element = {}
                if ('emergency' in data[i]) {
                    element = data[i]?.emergency
                } else if ('holiday' in data[i]) {
                    element = data[i]?.holiday
                } else {
                    element = data[i]
                }
                let packageLine = element?.package_line
                let transformedPackageLine = [];
                if (data[i]?.package_type === 'Assorted' || data[i]?.package_type === 'Package') {
                    for (let k = 0; k < packageLine?.length; k++) {
                        const pack = packageLine[k]
                        const serviceLine = pack.service_data
                        let transformedServiceData = [];
                        for (let j = 0; j < serviceLine?.length; j++) {
                            const service = serviceLine[j]
                            const concession_applicable = service?.edit_discount ? (service?.is_hospital ? service.old_hospital_fee : service?.sub_total_amount) : 0
                            let incGst = loginInfo?.is_gst_enabled ? CommonValidation.calculateTotalWithGST(service?.sub_total_amount, service?.gst_percent) : 0
                            let tltGstdiff = loginInfo?.is_gst_enabled ? incGst : 0
                            let sgstCgst = loginInfo?.is_gst_enabled ? +tltGstdiff / 2 : 0

                            transformedServiceData?.push({
                                rate_per_unit: service?.service_rate_per_unit ? service?.service_rate_per_unit : service?.rate_per_unit,
                                unit: service?.unit,
                                unit_type: service?.unit_type,
                                total_amt: service?.sub_total_amount,
                                doctor_amt: service?.old_doctor_fee,
                                doctor_percent: service?.doctor_share_percent || service?.doctor_percent,
                                old_doctor_amt: service?.old_doctor_fee || service?.old_doctor_amt,
                                new_doctor_amt: service?.old_doctor_fee || service?.new_doctor_amt,
                                hospital_amt: service?.old_hospital_fee || service?.hospital_amt,
                                hospital_percent: service?.hospital_share_percent || service?.hospital_percent,
                                old_hospital_amt: service?.old_hospital_fee || service?.old_hospital_amt,
                                new_hospital_amt: service?.old_hospital_fee || service?.new_hospital_amt,
                                interval_time: service.interval_time || service?.interval_time,
                                interval_amount: service.interval_amount || service?.interval_amount,
                                service_name: service.service_name ? service.service_name : '',
                                service_head_name: service?.service_head_name,
                                service_code: service.service_code ? service.service_code : '',
                                service_head_code: service.service_head_code ? service.service_head_code : '',
                                edit_unit: service.edit_unit,
                                edit_amount: service.edit_amount,
                                edit_discount: service.edit_discount,
                                doctor_name: service?.doctor_name,
                                doctor_id: service?.bill_doctor_id,
                                start_time: service.start_time,
                                end_time: service.end_time,
                                gst_percent: service.gst_percent ? service.gst_percent : 0,
                                hours: service.unit_type === 'Hrs' ? service.unit?.split(":")[0] : '',
                                minutes: service.unit_type === 'Hrs' ? service.unit?.split(":")[1] : '',
                                service_details_id: service?.service_details_id ? service?.service_details_id : null,
                                review_days: service?.review_days ? service?.review_days : 0,
                                review_count: service?.review_count ? service?.review_count : 0,
                                charge_id: service?.service_charge_id || service?.charge_id,
                                module_type: service?.module_type ? service?.module_type : 'OP',
                                doctor_percent_w_r: +((+service?.doctor_share_percent)?.toFixed(2)) || +((+service?.doctor_percent_w_r)?.toFixed(2)),
                                hospital_percent_w_r: +((+service?.hospital_share_percent)?.toFixed(2)) || +((+service?.hospital_percent_w_r)?.toFixed(2)),
                                start_date: new Date(),
                                end_date: null,
                                is_hospital: service?.is_hospital,
                                old_time_taken: service?.service_old_unit_count || service?.old_time_taken,
                                concession_amt: '',
                                concession_percent: '',
                                concession_percent_w_r: '',
                                concession_comments: '',
                                bill_type: service?.bill_type ? service?.bill_type : '',
                                doc_discount_amt: '',
                                doc_discount_percent: '',
                                doc_discount_percent_w_r: '',
                                hos_discount_amt: '',
                                hos_discount_percent: '',
                                hos_discount_percent_w_r: '',
                                service_head_id: service?.service_head_id ? service?.service_head_id : null,
                                op_order_line_id: service?.op_order_line_id ? service?.op_order_line_id : null,
                                total_with_discount: service?.sub_total_amount || service?.total_with_discount,
                                service_with_gst_total_amt: CommonValidation.calculateTotalWithGST(service?.sub_total_amount, service?.gst_percent),
                                gst_amount: +CommonValidation.formatAmount(tltGstdiff),
                                sgst_amount: +CommonValidation.formatAmount(sgstCgst),
                                cgst_amount: +CommonValidation.formatAmount(sgstCgst),
                                igst_amount: +CommonValidation.formatAmount(tltGstdiff),
                                taxable_amount: service?.sub_total_amount || service?.taxable_amount,
                                sub_total_amount: service?.sub_total_amount,
                                concession_applicable: concession_applicable,
                                op_order_number: null,
                                id: service?.id ? service?.id : null,
                                package_detail_id: service?.package_detail_id ? service?.package_detail_id : null,
                                package_name: service?.package_detail_id ? insertPackName : '',
                                doctor_list: service?.doctor_list || [],
                                not_from_order: (service?.op_order_id || service?.bill_type === 'Draft') ? false : true,
                                draft_id: service?.draft_id ? service?.draft_id : null,
                                is_sharable: service?.is_sharable,
                                is_consultation: service?.is_consultation,
                                order_line_ids: service?.order_line_ids ?? [],
                                drug_config_id: service?.drug_config_id ?? null,
                                drug_ms_id: service?.drug_ms_id ?? null,
                                pharmacy_id: service?.pharmacy_id ?? null,
                                sub_location_id: service?.sub_location_id ?? null,
                            })
                        }
                        transformedPackageLine?.push({
                            ...pack,
                            service_data: transformedServiceData,
                            edit_discount: true,
                            edit_amount: false,
                            edit_unit: true,
                            rate_per_unit: pack?.service_data[0]?.rate_per_unit ?? pack?.service_data[0]?.service_charge ?? 0,
                            unit: pack?.service_data[0]?.unit ?? 1,
                            unit_type: pack?.service_data[0]?.unit_type ?? 'Nos',
                            concession_amt: '',
                            concession_percent: '',
                            concession_percent_w_r: '',
                            total_amt: pack?.service_data[0]?.sub_total_amount ?? pack?.service_data[0]?.service_charge ?? 0,
                            total_with_discount: pack?.service_data[0]?.sub_total_amount ?? 0,
                            service_with_gst_total_amt: CommonValidation.calculateTotalWithGST(pack?.sub_total_amount, pack?.gst_percent),
                            gst_amount: 0,
                            sgst_amount: 0,
                            cgst_amount: 0,
                            igst_amount: pack?.service_data[0]?.igst_amount ?? 0,
                            taxable_amount: pack?.service_data[0]?.taxable_amount ?? 0,
                            sub_total_amount: pack?.service_data[0]?.sub_total_amount ?? 0,
                            concession_applicable: pack?.service_data[0]?.taxable_amount ?? 0,
                            service_name: pack?.service_data[0]?.service_name ?? '',
                            service_head_name: pack?.service_data[0]?.service_head ?? '',
                            service_code: pack?.service_data[0]?.service_code ?? '',
                            service_head_code: pack?.service_data[0]?.service_head_code ?? '',
                            is_sharable: pack?.service_data[0]?.is_sharable ?? '',
                            is_consultation: pack?.service_data[0]?.is_consultation ?? '',
                            id: pack?.service_data[0]?.id ?? null,
                            order_line_ids: pack?.service_data[0]?.order_line_ids ?? [],
                            drug_config_id: pack?.service_data[0]?.drug_config_id ?? null,
                            drug_ms_id: pack?.service_data[0]?.drug_ms_id ?? null,
                            pharmacy_id: pack?.service_data[0]?.pharmacy_id ?? null,
                            sub_location_id: pack?.service_data[0]?.sub_location_id ?? null,
                        })
                    }
                    newBillingList?.push({
                        "package_name": element?.package_name,
                        "package_code": element?.package_code,
                        "module_type": element?.module_type,
                        "package_id": element?.package_id,
                        'billing_display': element?.billing_display,
                        'package_type': element?.package_type,
                        'package_amount': element?.package_amount,
                        'package_line': transformedPackageLine,
                        edit_discount: true,
                        edit_amount: false,
                        edit_unit: true,
                        order_line_ids: element?.package_line[0]?.service_data[0]?.order_line_ids ?? [],
                        rate_per_unit: element?.package_line[0]?.service_data[0]?.service_rate_per_unit ?? 0,
                        unit: element?.package_line[0]?.service_data[0]?.unit ?? 1,
                        unit_type: element?.package_line[0]?.service_data[0]?.unit_type ?? 'Nos',
                        concession_amt: '',
                        concession_percent: '',
                        concession_percent_w_r: '',
                        total_amt: element?.package_line[0]?.service_data[0]?.sub_total_amount ?? 0,
                        total_with_discount: element?.package_line[0]?.service_data[0]?.service_charge ?? 0,
                        service_with_gst_total_amt: element?.package_line[0]?.service_data[0]?.sub_total_amount ?? 0,
                        gst_amount: 0,
                        sgst_amount: 0,
                        cgst_amount: 0,
                        igst_amount: element?.package_line[0]?.service_data[0]?.sub_total_amount ?? 0,
                        taxable_amount: element?.package_line[0]?.service_data[0]?.taxable_amount ?? 0,
                        sub_total_amount: element?.package_line[0]?.service_data[0]?.sub_total_amount ?? 0,
                        concession_applicable: element?.package_line[0]?.service_data[0]?.taxable_amount ?? 0,
                        service_name: element?.package_line[0]?.service_data[0]?.service_name ?? '',
                        service_head_name: element?.package_line[0]?.service_data[0]?.service_head ?? '',
                        service_code: element?.package_line[0]?.service_data[0]?.service_code ?? '',
                        service_head_code: element?.package_line[0]?.service_data[0]?.service_head_code ?? '',
                        is_sharable: element?.package_line[0]?.service_data[0]?.is_sharable ?? '',
                        is_consultation: element?.package_line[0]?.service_data[0]?.is_consultation ?? '',
                        id: element?.package_line[0]?.service_data[0]?.id ?? null,
                        order_line_ids: element?.package_line[0]?.service_data[0]?.order_line_ids ?? [],
                        drug_config_id: element?.package_line[0]?.service_data[0]?.drug_config_id ?? null,
                        drug_ms_id: element?.package_line[0]?.service_data[0]?.drug_ms_id ?? null,
                        pharmacy_id: element?.package_line[0]?.service_data[0]?.pharmacy_id ?? null,
                        sub_location_id: element?.package_line[0]?.service_data[0]?.sub_location_id ?? null,
                    })
                } else {
                    const concession_applicable = element?.edit_discount ? (element?.is_hospital ? element.old_hospital_fee : element?.sub_total_amount) : 0
                    let incGst = loginInfo?.is_gst_enabled ? CommonValidation.calculateTotalWithGST(element?.sub_total_amount, element?.gst_percent) : 0
                    let tltGstdiff = loginInfo?.is_gst_enabled ? incGst : 0
                    let sgstCgst = loginInfo?.is_gst_enabled ? +tltGstdiff / 2 : 0

                    newBillingList?.push({
                        rate_per_unit: element?.service_rate_per_unit ? element?.service_rate_per_unit : element?.rate_per_unit,
                        unit: element?.unit,
                        unit_type: element?.unit_type,
                        total_amt: element?.sub_total_amount,
                        doctor_amt: element?.old_doctor_fee,
                        doctor_percent: element?.doctor_share_percent || element?.doctor_percent,
                        old_doctor_amt: element?.old_doctor_fee || element?.old_doctor_amt,
                        new_doctor_amt: element?.old_doctor_fee || element?.new_doctor_amt,
                        hospital_amt: element?.old_hospital_fee || element?.hospital_amt,
                        hospital_percent: element?.hospital_share_percent || element?.hospital_percent,
                        old_hospital_amt: element?.old_hospital_fee || element?.old_hospital_amt,
                        new_hospital_amt: element?.old_hospital_fee || element?.new_hospital_amt,
                        interval_time: element.interval_time || element?.interval_time,
                        interval_amount: element.interval_amount || element?.interval_amount,
                        service_name: element.service_name ? element.service_name : '',
                        service_head_name: element?.service_head_name,
                        service_code: element.service_code ? element.service_code : '',
                        service_head_code: element.service_head_code ? element.service_head_code : '',
                        edit_unit: element.edit_unit,
                        edit_amount: element.edit_amount,
                        edit_discount: element.edit_discount,
                        doctor_name: element?.doctor_name,
                        doctor_id: element?.bill_doctor_id,
                        start_time: element.start_time,
                        end_time: element.end_time,
                        gst_percent: element.gst_percent ? element.gst_percent : 0,
                        hours: element.unit_type === 'Hrs' ? element.unit?.split(":")[0] : '',
                        minutes: element.unit_type === 'Hrs' ? element.unit?.split(":")[1] : '',
                        service_details_id: element?.service_details_id ? element?.service_details_id : null,
                        review_days: element?.review_days ? element?.review_days : 0,
                        review_count: element?.review_count ? element?.review_count : 0,
                        charge_id: element?.service_charge_id || element?.charge_id,
                        module_type: element?.module_type ? element?.module_type : 'op',
                        doctor_percent_w_r: +((+element?.doctor_share_percent)?.toFixed(2)) || +((+element?.doctor_percent_w_r)?.toFixed(2)),
                        hospital_percent_w_r: +((+element?.hospital_share_percent)?.toFixed(2)) || +((+element?.hospital_percent_w_r)?.toFixed(2)),
                        start_date: new Date(),
                        end_date: null,
                        is_hospital: element?.is_hospital,
                        old_time_taken: element?.service_old_unit_count || element?.old_time_taken,
                        concession_amt: '',
                        concession_percent: '',
                        concession_percent_w_r: '',
                        concession_comments: '',
                        bill_type: element?.bill_type ? element?.bill_type : '',
                        doc_discount_amt: '',
                        doc_discount_percent: '',
                        doc_discount_percent_w_r: '',
                        hos_discount_amt: '',
                        hos_discount_percent: '',
                        hos_discount_percent_w_r: '',
                        service_head_id: element?.service_head_id ? element?.service_head_id : null,
                        op_order_line_id: element?.op_order_line_id ? element?.op_order_line_id : null,
                        total_with_discount: element?.sub_total_amount || element?.total_with_discount,
                        service_with_gst_total_amt: CommonValidation.calculateTotalWithGST(element?.sub_total_amount, element?.gst_percent),
                        gst_amount: +CommonValidation.formatAmount(tltGstdiff),
                        sgst_amount: +CommonValidation.formatAmount(sgstCgst),
                        cgst_amount: +CommonValidation.formatAmount(sgstCgst),
                        igst_amount: +CommonValidation.formatAmount(tltGstdiff),
                        taxable_amount: element?.sub_total_amount || element?.taxable_amount,
                        sub_total_amount: element?.sub_total_amount,
                        concession_applicable: concession_applicable,
                        op_order_number: null,
                        id: element?.bill_type ? element?.id ? element?.id : null : null,
                        package_detail_id: element?.package_detail_id ? element?.package_detail_id : null,
                        package_name: element?.package_detail_id ? insertPackName : '',
                        doctor_list: element?.doctor_list || [],
                        not_from_order: (element?.op_order_id || element?.bill_type === 'Draft') ? false : true,
                        draft_id: element?.draft_id ? element?.draft_id : null,
                        is_sharable: element?.is_sharable,
                        is_consultation: element?.is_consultation,
                        order_line_ids: element?.order_line_ids ?? [],
                        drug_config_id: element?.drug_config_id ?? null,
                        drug_ms_id: element?.drug_ms_id ?? null,
                        pharmacy_id: element?.pharmacy_id ?? null,
                        sub_location_id: element?.sub_location_id ?? null,
                    })
                }
            }
            return newBillingList;
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const setPackageListData = (packageData) => {
        try {
            let newBillList = []
            let packageLine = packageData?.package_line
            let transformedPackageLine = [];
            if (packageLine?.length) {
                for (let i = 0; i < packageLine?.length; i++) {
                    let pack = packageLine[i]
                    let serviceLine = pack.service_data
                    let transformedServiceData = [];
                    if (serviceLine?.length) {
                        for (let j = 0; j < serviceLine?.length; j++) {
                            let element = serviceLine[j]

                            let bill_type = element?.bill_type === 'Draft' ? true : false
                            const rate_per_unit = element?.service_rate_per_unit ? element?.service_rate_per_unit : element?.rate_per_unit ? element?.rate_per_unit : element?.service_charge
                            const totalAmt = element?.sub_total_amount ? element?.sub_total_amount : element?.service_charge ? element?.service_charge : element?.sub_total_amount
                            const total_with_discount = element?.total_amount ? element?.total_amount : element?.service_charge ? element?.service_charge : element?.total_amount
                            const oldDocAmt = element?.old_doctor_fee ? element?.old_doctor_fee : element?.new_doctor_fee ? element?.new_doctor_fee : element?.doctor_share_amount ? element?.doctor_share_amount : ''
                            const oldHosAmt = element?.old_hospital_fee ? element?.old_hospital_fee : element?.new_hospital_fee ? element?.new_hospital_fee : element?.hospital_share_amount ? element?.hospital_share_amount : ''
                            const newDocAmt = element?.new_doctor_fee ? element?.new_doctor_fee : element?.doctor_share_amount ? element?.doctor_share_amount : ''
                            const newHosAmt = element?.new_hospital_fee ? element?.new_hospital_fee : element?.hospital_share_amount ? element?.hospital_share_amount : ''
                            const docAmt = element?.new_doctor_fee ? element?.new_doctor_fee : element?.doctor_share_amount ? element?.doctor_share_amount : ''
                            const hosAmt = element?.new_hospital_fee ? element?.new_hospital_fee : element?.hospital_share_amount ? element?.hospital_share_amount : ''
                            const docPer = element?.doctor_share_percent ? element?.doctor_share_percent : ''
                            const hosPer = element?.hospital_share_percent ? element?.hospital_share_percent : ''
                            const doctor_id = element?.bill_doctor_id ? element?.bill_doctor_id : element?.doctor_id ? element?.doctor_id : billing.selected_bill_doc?.doctor_id ? billing.selected_bill_doc?.doctor_id : billing.selected_bill_doc_id
                            const doctor_name = element?.bill_doctor_name ? element?.bill_doctor_name : element?.doctor_name ? element?.doctor_name : ''
                            const sub_total_amount = element?.sub_total_amount ? element?.sub_total_amount : element?.service_charge ? element?.service_charge : 0
                            const taxable_amount = element?.taxable_amount ? element?.taxable_amount : element?.total_amount ? element?.total_amount : element?.service_charge ? element?.service_charge : 0
                            const concession_amt = element?.discount_amount ? element?.discount_amount : 0
                            const concession_percent = element?.discount_percentage ? element?.discount_percentage : 0
                            const concession_comments = element?.concession_comments ? element?.concession_comments : ''
                            const service_head_name = element?.service_head_name ? element?.service_head_name : element?.service_head ? element?.service_head : ''
                            const unit = element?.unit ? element?.unit : 1
                            const unit_type = element?.unit_type ? element?.unit_type : 'Nos'
                            const charge_ids = element?.unit_type === 'Nos' ? null : (element?.service_charge_id ? element?.service_charge_id : element?.charge_id ? element?.charge_id : null)
                            const old_time_taken = element?.service_old_unit_count ? element?.service_old_unit_count : element?.service_unit ? element?.service_unit : element?.unit ? element?.unit : null
                            const disDocAmt = (+oldDocAmt) - (+newDocAmt)
                            const disHosAmt = (+oldHosAmt) - (+newHosAmt)
                            const disDocPer = CommonValidation.getDiscountPercentage(disDocAmt, oldDocAmt)
                            const disHosPer = CommonValidation.getDiscountPercentage(disHosAmt, oldHosAmt)
                            const concession_applicable = element?.is_hospital ? oldHosAmt : taxable_amount ? taxable_amount : 0
                            const op_order_no = bill_type ? '' : element?.op_order_number ? element?.op_order_number : element?.order_number ? element?.order_number : ''

                            let discountTotal = element?.discount_amount ? (+totalAmt) - (+element?.discount_amount) : totalAmt
                            let incGst = loginInfo?.is_gst_enabled ? CommonValidation.calculateTotalWithGST(discountTotal, element?.gst_percent) : 0
                            let tltGstdiff = loginInfo?.is_gst_enabled ? incGst - discountTotal : 0
                            let sgstCgst = loginInfo?.is_gst_enabled ? +tltGstdiff / 2 : 0

                            transformedServiceData?.push({
                                rate_per_unit: (element?.drug_config_id || element?.drug_ms_id) ? rate_per_unit / unit : rate_per_unit,
                                unit: unit,
                                unit_type: unit_type,
                                total_amt: totalAmt,
                                doctor_amt: docAmt,
                                doctor_percent: docPer,
                                old_doctor_amt: oldDocAmt,
                                new_doctor_amt: newDocAmt,
                                hospital_amt: hosAmt,
                                hospital_percent: hosPer,
                                old_hospital_amt: oldHosAmt,
                                new_hospital_amt: newHosAmt,
                                interval_time: element.interval_time,
                                interval_amount: element.interval_amount,
                                service_name: element.service_name ? element.service_name : '',
                                service_head_name: service_head_name,
                                service_code: element.service_code ? element.service_code : '',
                                service_head_code: element.service_head_code ? element.service_head_code : '',
                                // FOR ASSORTED/PACKAGE DEFAULT TRUE
                                edit_unit: true,
                                edit_amount: false,
                                edit_discount: true,
                                doctor_name: doctor_name,
                                doctor_id: doctor_id,
                                start_time: element.start_time,
                                end_time: element.end_time,
                                gst_percent: element.gst_percent ? element.gst_percent : 0,
                                hours: element.unit_type === 'Hrs' ? element.unit?.split(":")[0] : '',
                                minutes: element.unit_type === 'Hrs' ? element.unit?.split(":")[1] : '',
                                service_details_id: element?.service_details_id ? element?.service_details_id : null,
                                review_days: element?.review_days ? element?.review_days : 0,
                                review_count: element?.review_count ? element?.review_count : 0,
                                charge_id: charge_ids,
                                module_type: element?.module_type ? element?.module_type : '',
                                doctor_percent_w_r: +((+docPer)?.toFixed(2)),
                                hospital_percent_w_r: +((+hosPer)?.toFixed(2)),
                                start_date: new Date(),
                                end_date: null,
                                is_hospital: element?.is_hospital,
                                old_time_taken: old_time_taken,
                                concession_amt: concession_amt,
                                concession_percent: concession_percent,
                                concession_percent_w_r: +((+concession_percent)?.toFixed(2)),
                                concession_comments: concession_comments,
                                bill_type: element?.bill_type ? element?.bill_type : '',
                                doc_discount_amt: disDocAmt,
                                doc_discount_percent: disDocPer || '',
                                doc_discount_percent_w_r: +CommonValidation.formatAmount(disDocPer),
                                hos_discount_amt: disHosAmt,
                                hos_discount_percent: disHosPer || '',
                                hos_discount_percent_w_r: CommonValidation.formatAmount(disHosPer),
                                service_head_id: element?.service_head_id ? element?.service_head_id : null,
                                op_order_line_id: element?.op_order_line_id ? element?.op_order_line_id : null,
                                total_with_discount: total_with_discount,
                                service_with_gst_total_amt: +CommonValidation.formatAmount(incGst),
                                gst_amount: +CommonValidation.formatAmount(tltGstdiff),
                                sgst_amount: +CommonValidation.formatAmount(sgstCgst),
                                cgst_amount: +CommonValidation.formatAmount(sgstCgst),
                                igst_amount: +CommonValidation.formatAmount(tltGstdiff),
                                taxable_amount: taxable_amount,
                                sub_total_amount: sub_total_amount,
                                concession_applicable: concession_applicable,
                                old_time_taken: old_time_taken,
                                op_order_number: op_order_no,
                                id: element?.bill_type ? element?.id ? element?.id : null : null,
                                package_detail_id: element?.package_detail_id ? element?.package_detail_id : null,
                                // package_name: element?.package_detail_id ? insertPackName : '',
                                doctor_list: element?.doctor_list || [],
                                not_from_order: (element?.op_order_id || element?.bill_type === 'Draft') ? false : true,
                                draft_id: element?.draft_id ? element?.draft_id : null,
                                is_sharable: element?.is_sharable,
                                is_consultation: element?.is_consultation,
                                drug_config_id: element?.drug_config_id ?? null,
                                drug_ms_id: element?.drug_ms_id ?? null,
                                pharmacy_id: element?.pharmacy_id ?? null,
                                sub_location_id: element?.sub_location_id ?? null,
                            })
                        }
                    }
                    transformedPackageLine?.push({
                        ...pack,
                        service_data: transformedServiceData?.length ? transformedServiceData : [],
                        edit_discount: true,
                        edit_amount: false,
                        edit_unit: false,
                        order_line_ids: [],
                        rate_per_unit: pack?.package_head_amount,
                        unit: 1,
                        unit_type: 'Nos',
                        concession_amt: 0,
                        concession_percent: 0,
                        concession_percent_w_r: 0,
                        total_amt: +pack?.package_head_amount,
                        total_with_discount: +pack?.package_head_amount,
                        service_with_gst_total_amt: +pack?.package_head_amount,
                        gst_amount: 0,
                        sgst_amount: 0,
                        cgst_amount: 0,
                        igst_amount: +pack?.package_head_amount,
                        taxable_amount: +pack?.package_head_amount,
                        sub_total_amount: +pack?.package_head_amount,
                        concession_applicable: +pack?.package_head_amount,
                        service_name: pack?.package_head_type,
                        service_head_name: pack?.package_service_head,
                        service_code: pack?.package_code ?? '',
                        service_head_code: pack?.package_code ?? '',
                        package_type: packageData?.package_type,
                        billing_display: packageData?.billing_display,
                        drug_config_id: pack?.drug_config_id ?? null,
                        drug_ms_id: pack?.drug_ms_id ?? null,
                        pharmacy_id: pack?.pharmacy_id ?? null,
                        sub_location_id: pack?.sub_location_id ?? null,
                    })
                }
            }
            newBillList?.push({
                "package_name": packageData?.package_name,
                "package_code": packageData?.package_code,
                "module_type": packageData?.module_type,
                "package_id": packageData?.package_id,
                'billing_display': packageData?.billing_display,
                'package_type': packageData?.package_type,
                'package_amount': packageData?.package_amount,
                'package_line': transformedPackageLine?.length ? transformedPackageLine : [],
                edit_discount: true,
                edit_amount: false,
                edit_unit: false,
                order_line_ids: [],
                rate_per_unit: packageData?.package_amount,
                unit: 1,
                unit_type: 'Nos',
                concession_amt: 0,
                concession_percent: 0,
                concession_percent_w_r: 0,
                total_amt: +packageData?.package_amount,
                total_with_discount: +packageData?.package_amount,
                service_with_gst_total_amt: +packageData?.package_amount,
                gst_amount: 0,
                sgst_amount: 0,
                cgst_amount: 0,
                igst_amount: +packageData?.package_amount,
                taxable_amount: +packageData?.package_amount,
                sub_total_amount: +packageData?.package_amount,
                concession_applicable: +packageData?.package_amount,
                service_name: packageData?.package_name,
                service_head_name: packageData?.package_name,
                service_code: packageData?.package_code ?? '',
                service_head_code: packageData?.package_code ?? '',
                drug_config_id: packageData?.drug_config_id ?? null,
                drug_ms_id: packageData?.drug_ms_id ?? null,
                pharmacy_id: packageData?.pharmacy_id ?? null,
                sub_location_id: packageData?.sub_location_id ?? null,
                doctor_id: billing.selected_bill_doc?.doctor_id || billing.selected_bill_doc_id || null
            })
            return newBillList;
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const setBillingListData = (data = [], insertPackName = '', fromAutoBilling = false, CalculateMembershipDisc = true) => {
        try {
            let newBillingList = [];
            for (let i = 0; i < data?.length; i++) {
                let element = {}
                if ('emergency' in data[i]) {
                    element = data[i]?.emergency
                } else if ('holiday' in data[i]) {
                    element = data[i]?.holiday
                } else {
                    element = data[i]
                }
                let packageLine = element?.package_line
                let transformedPackageLine = [];
                if (data[i]?.package_type === 'Assorted' || data[i]?.package_type === 'Package') {
                    for (let k = 0; k < packageLine?.length; k++) {
                        const pack = packageLine[k]
                        const serviceLine = pack.service_data
                        let transformedServiceData = [];
                        for (let j = 0; j < serviceLine?.length; j++) {
                            const service = serviceLine[j]

                            // SET BILL DATA FROM DRAFT AND ORDER
                            let bill_type = service?.bill_type === 'Draft' ? true : false
                            const rate_per_unit = service?.service_rate_per_unit ? service?.service_rate_per_unit : service?.rate_per_unit ? service?.rate_per_unit : service?.service_charge
                            const totalAmt = service?.sub_total_amount ? service?.sub_total_amount : service?.service_charge ? service?.service_charge : service?.sub_total_amount
                            const total_with_discount = service?.total_amount ? service?.total_amount : service?.service_charge ? service?.service_charge : service?.total_amount
                            const oldDocAmt = service?.old_doctor_fee ? service?.old_doctor_fee : service?.new_doctor_fee ? service?.new_doctor_fee : service?.doctor_share_amount ? service?.doctor_share_amount : ''
                            const oldHosAmt = service?.old_hospital_fee ? service?.old_hospital_fee : service?.new_hospital_fee ? service?.new_hospital_fee : service?.hospital_share_amount ? service?.hospital_share_amount : ''
                            const newDocAmt = service?.new_doctor_fee ? service?.new_doctor_fee : service?.doctor_share_amount ? service?.doctor_share_amount : ''
                            const newHosAmt = service?.new_hospital_fee ? service?.new_hospital_fee : service?.hospital_share_amount ? service?.hospital_share_amount : ''
                            const docAmt = service?.new_doctor_fee ? service?.new_doctor_fee : service?.doctor_share_amount ? service?.doctor_share_amount : ''
                            const hosAmt = service?.new_hospital_fee ? service?.new_hospital_fee : service?.hospital_share_amount ? service?.hospital_share_amount : ''
                            const docPer = service?.doctor_share_percent ? service?.doctor_share_percent : ''
                            const hosPer = service?.hospital_share_percent ? service?.hospital_share_percent : ''
                            const doctor_id = service?.bill_doctor_id ? service?.bill_doctor_id : service?.doctor_id ? service?.doctor_id : props?.patientData?.doctor_id ? props?.patientData?.doctor_id : null
                            const doctor_name = service?.bill_doctor_name ? service?.bill_doctor_name : service?.doctor_name ? service?.doctor_name : props?.patientData?.doctor_name ? props?.patientData?.doctor_name : ''
                            const sub_total_amount = service?.sub_total_amount ? service?.sub_total_amount : service?.service_charge ? service?.service_charge : 0
                            const taxable_amount = service?.taxable_amount ? service?.taxable_amount : service?.total_amount ? service?.total_amount : service?.service_charge ? service?.service_charge : 0
                            const concession_amt = service?.discount_amount ? service?.discount_amount : 0
                            const concession_percent = service?.discount_percentage ? service?.discount_percentage : 0
                            const concession_comments = service?.concession_comments ? service?.concession_comments : ''
                            const service_head_name = service?.service_head_name ? service?.service_head_name : service?.service_head ? service?.service_head : ''
                            const unit = service?.unit ? service?.unit : 1
                            const unit_type = service?.unit_type ? service?.unit_type : 'Nos'
                            const charge_ids = service?.service_charge_id ? service?.service_charge_id : service?.charge_id ? service?.charge_id : null
                            const old_time_taken = service?.service_old_unit_count ? service?.service_old_unit_count : service?.service_unit ? service?.service_unit : null
                            const disDocAmt = (+oldDocAmt) - (+newDocAmt)
                            const disHosAmt = (+oldHosAmt) - (+newHosAmt)
                            const disDocPer = CommonValidation.getDiscountPercentage(disDocAmt, oldDocAmt)
                            const disHosPer = CommonValidation.getDiscountPercentage(disHosAmt, oldHosAmt)
                            const concession_applicable = element?.is_hospital ? oldHosAmt : taxable_amount ? taxable_amount : 0
                            const op_order_no = bill_type ? '' : service?.op_order_number ? service?.op_order_number : service?.order_number ? service?.order_number : ''

                            let discountTotal = service?.discount_amount ? (+totalAmt) - (+service?.discount_amount) : totalAmt
                            let incGst = loginInfo?.is_gst_enabled ? CommonValidation.calculateTotalWithGST(discountTotal, service?.gst_percent) : 0
                            let tltGstdiff = loginInfo?.is_gst_enabled ? incGst - discountTotal : 0
                            let sgstCgst = loginInfo?.is_gst_enabled ? +tltGstdiff / 2 : 0

                            transformedServiceData?.push({
                                rate_per_unit: rate_per_unit,
                                unit: unit,
                                unit_type: unit_type,
                                total_amt: totalAmt,
                                doctor_amt: docAmt,
                                doctor_percent: docPer,
                                old_doctor_amt: oldDocAmt,
                                new_doctor_amt: newDocAmt,
                                hospital_amt: hosAmt,
                                hospital_percent: hosPer,
                                old_hospital_amt: oldHosAmt,
                                new_hospital_amt: newHosAmt,
                                interval_time: service.interval_time,
                                interval_amount: service.interval_amount,
                                service_name: service.service_name ? service.service_name : '',
                                service_head_name: service_head_name,
                                service_code: service.service_code ? service.service_code : '',
                                service_head_code: service.service_head_code ? service.service_head_code : '',
                                // FOR ASSORTED/PACKAGE DEFAULT TRUE
                                edit_unit: true,
                                edit_amount: false,
                                edit_discount: true,
                                doctor_name: doctor_name,
                                doctor_id: doctor_id,
                                start_time: service.start_time,
                                end_time: service.end_time,
                                gst_percent: service.gst_percent ? service.gst_percent : 0,
                                hours: service.unit_type === 'Hrs' ? service.unit?.split(":")[0] : '',
                                minutes: service.unit_type === 'Hrs' ? service.unit?.split(":")[1] : '',
                                service_details_id: service?.service_details_id ? service?.service_details_id : null,
                                review_days: service?.review_days ? service?.review_days : 0,
                                review_count: service?.review_count ? service?.review_count : 0,
                                charge_id: charge_ids,
                                module_type: service?.module_type ? service?.module_type : 'OP',
                                doctor_percent_w_r: +((+docPer)?.toFixed(2)),
                                hospital_percent_w_r: +((+hosPer)?.toFixed(2)),
                                start_date: new Date(),
                                end_date: null,
                                is_hospital: service?.is_hospital,
                                old_time_taken: old_time_taken,
                                concession_amt: concession_amt,
                                concession_percent: concession_percent,
                                concession_percent_w_r: +((+concession_percent)?.toFixed(2)),
                                concession_comments: concession_comments,
                                bill_type: service?.bill_type ? service?.bill_type : '',
                                doc_discount_amt: disDocAmt,
                                doc_discount_percent: disDocPer || '',
                                doc_discount_percent_w_r: +CommonValidation.formatAmount(disDocPer),
                                hos_discount_amt: disHosAmt,
                                hos_discount_percent: disHosPer || '',
                                hos_discount_percent_w_r: CommonValidation.formatAmount(disHosPer),
                                service_head_id: service?.service_head_id ? service?.service_head_id : null,
                                op_order_line_id: service?.op_order_line_id ? service?.op_order_line_id : null,
                                total_with_discount: total_with_discount,
                                service_with_gst_total_amt: +CommonValidation.formatAmount(incGst),
                                gst_amount: +CommonValidation.formatAmount(tltGstdiff),
                                sgst_amount: +CommonValidation.formatAmount(sgstCgst),
                                cgst_amount: +CommonValidation.formatAmount(sgstCgst),
                                igst_amount: +CommonValidation.formatAmount(tltGstdiff),
                                taxable_amount: taxable_amount,
                                sub_total_amount: sub_total_amount,
                                concession_applicable: concession_applicable,
                                old_time_taken: old_time_taken,
                                op_order_number: op_order_no,
                                id: service?.id ? service?.id : null,
                                package_detail_id: service?.package_detail_id ? service?.package_detail_id : null,
                                package_name: service?.package_detail_id ? insertPackName : '',
                                doctor_list: service?.doctor_list || [],
                                not_from_order: (service?.op_order_id || service?.bill_type === 'Draft') ? false : true,
                                draft_id: service?.draft_id ? service?.draft_id : billing?.bill_id ? billing?.bill_id : null,
                                is_sharable: service?.is_sharable ? service?.is_sharable : false,
                                is_consultation: service?.is_consultation ? service?.is_consultation : false,
                                order_line_ids: service?.order_line_ids ?? [],
                                drug_config_id: service?.drug_config_id ?? null,
                                drug_ms_id: service?.drug_ms_id ?? null,
                                pharmacy_id: service?.pharmacy_id ?? null,
                                sub_location_id: service?.sub_location_id ?? null,
                            })
                        }
                        transformedPackageLine?.push({
                            ...pack,
                            service_data: transformedServiceData,
                            edit_discount: true,
                            edit_amount: false,
                            edit_unit: false,
                            rate_per_unit: pack?.service_data[0]?.rate_per_unit ?? pack?.service_data[0]?.service_charge ?? 0,
                            unit: pack?.service_data[0]?.unit ?? 1,
                            unit_type: pack?.service_data[0]?.unit_type ?? 'Nos',
                            concession_amt: pack?.service_data[0]?.discount_amount ?? 0,
                            concession_percent: pack?.service_data[0]?.discount_percentage ?? 0,
                            concession_percent_w_r: (+pack?.service_data[0]?.discount_percentage)?.toFixed(2) ?? 0,
                            total_amt: pack?.service_data[0]?.rate_per_unit ?? pack?.service_data[0]?.service_charge ?? 0,
                            total_with_discount: pack?.service_data[0]?.service_charge ?? 0,
                            service_with_gst_total_amt: pack?.service_data[0]?.service_charge ?? 0,
                            gst_amount: 0,
                            sgst_amount: 0,
                            cgst_amount: 0,
                            igst_amount: pack?.service_data[0]?.igst_amount ?? 0,
                            taxable_amount: pack?.service_data[0]?.taxable_amount ?? 0,
                            sub_total_amount: pack?.service_data[0]?.sub_total_amount ?? 0,
                            concession_applicable: pack?.service_data[0]?.taxable_amount ?? 0,
                            service_name: pack?.service_data[0]?.service_name ?? '',
                            service_head_name: pack?.service_data[0]?.service_head ?? '',
                            service_code: pack?.service_data[0]?.service_code ?? '',
                            service_head_code: pack?.service_data[0]?.service_head_code ?? '',
                            is_sharable: pack?.service_data[0]?.is_sharable ?? '',
                            is_consultation: pack?.service_data[0]?.is_consultation ?? '',
                            id: pack?.service_data[0]?.id ?? null,
                            order_line_ids: pack?.service_data[0]?.order_line_ids ?? [],
                            drug_config_id: pack?.service_data[0]?.drug_config_id ?? null,
                            drug_ms_id: pack?.service_data[0]?.drug_ms_id ?? null,
                            pharmacy_id: pack?.service_data[0]?.pharmacy_id ?? null,
                            sub_location_id: pack?.service_data[0]?.sub_location_id ?? null,
                        })
                    }
                    newBillingList?.push({
                        "package_name": element?.package_name,
                        "package_code": element?.package_code,
                        "module_type": element?.module_type,
                        "package_id": element?.package_id,
                        'billing_display': element?.billing_display,
                        'package_type': element?.package_type,
                        'package_amount': element?.package_amount,
                        'package_line': transformedPackageLine,
                        edit_discount: true,
                        edit_amount: false,
                        edit_unit: false,
                        order_line_ids: element?.package_line[0]?.service_data[0]?.order_line_ids ?? [],
                        rate_per_unit: element?.package_line[0]?.service_data[0]?.service_rate_per_unit ?? 0,
                        unit: element?.package_line[0]?.service_data[0]?.unit ?? 1,
                        unit_type: element?.package_line[0]?.service_data[0]?.unit_type ?? 'Nos',
                        concession_amt: element?.package_line[0]?.service_data[0]?.discount_amount ?? 0,
                        concession_percent: element?.package_line[0]?.service_data[0]?.discount_percentage ?? 0,
                        concession_percent_w_r: (+element?.package_line[0]?.service_data[0]?.discount_percentage)?.toFixed(2) ?? 0,
                        total_amt: element?.package_line[0]?.service_data[0]?.sub_total_amount ?? 0,
                        total_with_discount: element?.package_line[0]?.service_data[0]?.service_charge ?? 0,
                        service_with_gst_total_amt: element?.package_line[0]?.service_data[0]?.sub_total_amount ?? 0,
                        gst_amount: 0,
                        sgst_amount: 0,
                        cgst_amount: 0,
                        igst_amount: element?.package_line[0]?.service_data[0]?.sub_total_amount ?? 0,
                        taxable_amount: element?.package_line[0]?.service_data[0]?.taxable_amount ?? 0,
                        sub_total_amount: element?.package_line[0]?.service_data[0]?.sub_total_amount ?? 0,
                        concession_applicable: element?.package_line[0]?.service_data[0]?.taxable_amount ?? 0,
                        service_name: element?.package_line[0]?.service_data[0]?.service_name ?? '',
                        service_head_name: element?.package_line[0]?.service_data[0]?.service_head ?? '',
                        service_code: element?.package_line[0]?.service_data[0]?.service_code ?? '',
                        service_head_code: element?.package_line[0]?.service_data[0]?.service_head_code ?? '',
                        is_sharable: element?.package_line[0]?.service_data[0]?.is_sharable ?? '',
                        is_consultation: element?.package_line[0]?.service_data[0]?.is_consultation ?? '',
                        id: element?.package_line[0]?.service_data[0]?.id ?? null,
                        order_line_ids: element?.package_line[0]?.service_data[0]?.order_line_ids ?? [],
                        drug_config_id: element?.package_line[0]?.service_data[0]?.drug_config_id ?? null,
                        drug_ms_id: element?.package_line[0]?.service_data[0]?.drug_ms_id ?? null,
                        pharmacy_id: element?.package_line[0]?.service_data[0]?.pharmacy_id ?? null,
                        sub_location_id: element?.package_line[0]?.service_data[0]?.sub_location_id ?? null,
                        received_amount: element?.received_amount,
                    })
                } else {
                    // SET BILL DATA FROM DRAFT AND ORDER
                    let bill_type = element?.bill_type === 'Draft' ? true : false
                    const rate_per_unit = element?.service_rate_per_unit ? element?.service_rate_per_unit : element?.rate_per_unit ? element?.rate_per_unit : element?.service_charge
                    const totalAmt = element?.sub_total_amount ? element?.sub_total_amount : element?.service_charge ? element?.service_charge : element?.sub_total_amount
                    const total_with_discount = element?.total_amount ? element?.total_amount : element?.service_charge ? element?.service_charge : element?.total_amount
                    const oldDocAmt = element?.old_doctor_fee || element?.new_doctor_fee || (element?.doctor_share_amount ? element?.doctor_share_amount : '')
                    const oldHosAmt = element?.old_hospital_fee || element?.new_hospital_fee || (element?.hospital_share_amount ? element?.hospital_share_amount : '')
                    const newDocAmt = element?.new_doctor_fee ? element?.new_doctor_fee : (element?.doctor_share_amount ? element?.doctor_share_amount : '')
                    const newHosAmt = element?.new_hospital_fee ? element?.new_hospital_fee : (element?.hospital_share_amount ? element?.hospital_share_amount : '')
                    const docAmt = element?.new_doctor_fee ? element?.new_doctor_fee : (element?.doctor_share_amount ? element?.doctor_share_amount : '')
                    const hosAmt = element?.new_hospital_fee ? element?.new_hospital_fee : (element?.hospital_share_amount ? element?.hospital_share_amount : '')
                    const docPer = element?.doctor_share_percent ? element?.doctor_share_percent : ''
                    const hosPer = element?.hospital_share_percent ? element?.hospital_share_percent : ''
                    const doctor_id = element?.bill_doctor_id || element?.doctor_id || billing?.selected_bill_doc?.doctor_id || props?.patientData?.doctor_id || props?.doctorDetails?.selectedDoctor?.doctor_id || null
                    const doctor_name = element?.bill_doctor_name?.trim() ? element?.bill_doctor_name : element?.doctor_name?.trim() ? element?.doctor_name : (billing?.selected_bill_doc?.doctor_name ? billing?.selected_bill_doc?.doctor_name : props?.doctorDetails?.selectedDoctor?.doctor_name ? props?.doctorDetails?.selectedDoctor?.doctor_name : (props?.patientData?.doctor_name ? props?.patientData?.doctor_name : ''))
                    const sub_total_amount = element?.sub_total_amount ? element?.sub_total_amount : element?.service_charge ? element?.service_charge : 0
                    const taxable_amount = element?.taxable_amount ? element?.taxable_amount : element?.total_amount ? element?.total_amount : element?.service_charge ? element?.service_charge : 0
                    const concession_amt = element?.discount_amount ? element?.discount_amount : 0
                    const concession_percent = element?.discount_percentage ? element?.discount_percentage : 0
                    const concession_comments = element?.concession_comments ? element?.concession_comments : ''
                    const service_head_name = element?.service_head_name ? element?.service_head_name : element?.service_head ? element?.service_head : ''
                    const unit = element?.unit ? element?.unit : 1
                    const unit_type = element?.unit_type ? element?.unit_type : 'Nos'
                    const charge_ids = element?.service_charge_id ? element?.service_charge_id : element?.charge_id ? element?.charge_id : null
                    const old_time_taken = bill_type ? element?.service_old_unit_count : element?.service_unit ? element?.service_unit : null
                    const disDocAmt = (+oldDocAmt) - (+newDocAmt)
                    const disHosAmt = (+oldHosAmt) - (+newHosAmt)
                    const disDocPer = CommonValidation.getDiscountPercentage(disDocAmt, oldDocAmt)
                    const disHosPer = CommonValidation.getDiscountPercentage(disHosAmt, oldHosAmt)
                    const concession_applicable = element?.edit_discount ? (element?.is_hospital ? oldHosAmt : taxable_amount) : 0
                    const op_order_no = bill_type ? '' : element?.op_order_number ? element?.op_order_number : element?.order_number ? element?.order_number : ''

                    let discountTotal = element?.discount_amount ? (+totalAmt) - (+element?.discount_amount) : totalAmt
                    let incGst = loginInfo?.is_gst_enabled ? CommonValidation.calculateTotalWithGST(discountTotal, element?.gst_percent) : 0
                    let tltGstdiff = loginInfo?.is_gst_enabled ? incGst - discountTotal : 0
                    let sgstCgst = loginInfo?.is_gst_enabled ? +tltGstdiff / 2 : 0

                    let Object = { 
                        rate_per_unit: rate_per_unit,
                        unit: unit,
                        unit_type: unit_type,
                        total_amt: totalAmt,
                        doctor_amt: docAmt,
                        doctor_percent: docPer,
                        old_doctor_amt: oldDocAmt,
                        new_doctor_amt: newDocAmt,
                        hospital_amt: hosAmt,
                        hospital_percent: hosPer,
                        old_hospital_amt: oldHosAmt,
                        new_hospital_amt: newHosAmt,
                        interval_time: element.interval_time,
                        interval_amount: element.interval_amount,
                        service_name: element.service_name ? element.service_name : '',
                        service_head_name: service_head_name,
                        service_code: element.service_code ? element.service_code : '',
                        service_head_code: element.service_head_code ? element.service_head_code : '',
                        edit_unit: element.edit_unit,
                        edit_amount: element.edit_amount,
                        edit_discount: element.edit_discount,
                        doctor_name: doctor_name,
                        doctor_id: doctor_id,
                        start_time: element.start_time,
                        end_time: element.end_time,
                        gst_percent: element.gst_percent ? element.gst_percent : 0,
                        hours: element.unit_type === 'Hrs' ? element.unit?.split(":")[0] : '',
                        minutes: element.unit_type === 'Hrs' ? element.unit?.split(":")[1] : '',
                        service_details_id: element?.service_details_id ? element?.service_details_id : null,
                        review_days: element?.review_days ? element?.review_days : 0,
                        review_count: element?.review_count ? element?.review_count : 0,
                        charge_id: charge_ids,
                        module_type: element?.module_type ? element?.module_type : 'OP',
                        doctor_percent_w_r: +((+docPer)?.toFixed(2)),
                        hospital_percent_w_r: +((+hosPer)?.toFixed(2)),
                        start_date: new Date(),
                        end_date: null,
                        is_hospital: element?.is_hospital,
                        old_time_taken: old_time_taken,
                        concession_amt: concession_amt,
                        concession_percent: concession_percent,
                        concession_percent_w_r: +((+concession_percent)?.toFixed(2)),
                        concession_comments: concession_comments,
                        bill_type: element?.bill_type ? element?.bill_type : '',
                        doc_discount_amt: disDocAmt,
                        doc_discount_percent: disDocPer || '',
                        doc_discount_percent_w_r: +CommonValidation.formatAmount(disDocPer),
                        hos_discount_amt: disHosAmt,
                        hos_discount_percent: disHosPer || '',
                        hos_discount_percent_w_r: CommonValidation.formatAmount(disHosPer),
                        service_head_id: element?.service_head_id ? element?.service_head_id : null,
                        op_order_line_id: element?.op_order_line_id ? element?.op_order_line_id : null,
                        total_with_discount: total_with_discount,
                        service_with_gst_total_amt: +CommonValidation.formatAmount(incGst),
                        gst_amount: +CommonValidation.formatAmount(tltGstdiff),
                        sgst_amount: +CommonValidation.formatAmount(sgstCgst),
                        cgst_amount: +CommonValidation.formatAmount(sgstCgst),
                        igst_amount: +CommonValidation.formatAmount(tltGstdiff),
                        taxable_amount: taxable_amount,
                        sub_total_amount: sub_total_amount,
                        concession_applicable: concession_applicable,
                        old_time_taken: old_time_taken,
                        op_order_number: op_order_no,
                        id: element?.bill_type ? element?.id ? element?.id : null : null,
                        package_detail_id: element?.package_detail_id ? element?.package_detail_id : null,
                        package_name: element?.package_detail_id ? insertPackName : '',
                        doctor_list: element?.doctor_list || [],
                        not_from_order: (element?.op_order_id || element?.bill_type === 'Draft') ? false : true,
                        draft_id: element?.draft_id ? element?.draft_id : null,
                        is_sharable: element?.is_sharable,
                        is_consultation: element?.is_consultation,
                        order_line_ids: element?.order_line_ids ?? [],
                        drug_config_id: element?.drug_config_id ?? null,
                        drug_ms_id: element?.drug_ms_id ?? null,
                        pharmacy_id: element?.pharmacy_id ?? null,
                        sub_location_id: element?.sub_location_id ?? null,
                        from_auto_billing: fromAutoBilling,
                        received_amount: element?.received_amount,
                    }
                    
                        let MemberDiscount = element?.is_membership_discount_applied ? element?.discount_percentage : element?.membership_discount_percentage
                    if (MemberDiscount) {
                        if (!props?.patientData?.is_memberships) {
                            Object.membership_discount_percentage = false
                                if (element?.is_sharable) {
                                    const baseTotalAmt = totalAmt;
                                    const updatedOldDoc = CommonValidation.getDiscountAmountWithRound(Object.doctor_percent, baseTotalAmt)
                                    const updatedOldHos = CommonValidation.getDiscountAmountWithRound(Object.hospital_percent, baseTotalAmt)
                                    const disDoc = CommonValidation.getDiscountAmountWithRound(0, updatedOldDoc)
                                    const disHos = CommonValidation.getDiscountAmountWithRound(0, updatedOldHos)
                                    const conTlt = (+disDoc) + (+disHos)

                                    Object.total_amt = baseTotalAmt
                                    Object.total_with_discount = (totalAmt)
                                    Object.old_doctor_amt = updatedOldDoc
                                    Object.old_hospital_amt = updatedOldHos
                                    Object.new_doctor_amt = updatedOldDoc
                                    Object.new_hospital_amt = updatedOldHos
                                    Object.doctor_amt = updatedOldDoc
                                    Object.hospital_amt = updatedOldHos
                                    Object.doc_discount_amt = 0
                                    Object.hos_discount_amt = 0
                                    Object.hos_discount_percent = 0
                                    Object.hos_discount_percent_w_r = 0
                                    Object.concession_amt = CommonValidation.formatAmount(0)
                                    Object.concession_percent = 0
                                    Object.concession_percent_w_r = 0
                                    Object.concession_comments = ""
                                    Object.taxable_amount = totalAmt
                                    Object.concession_applicable = totalAmt
                                } else {
                                    Object.concession_percent = 0
                                    Object.concession_percent_w_r = 0
                                    Object.total_with_discount = totalAmt
                                    Object.concession_amt = 0
                                    Object.taxable_amount = totalAmt
                                    Object.concession_applicable = totalAmt
                                }
                        } else {
                            Object.membership_discount_percentage = true
                            if (CalculateMembershipDisc) {
                                if (element?.is_sharable) {
                                    const baseTotalAmt = totalAmt;
                                    const updatedOldDoc = CommonValidation.getDiscountAmountWithRound(Object.doctor_percent, baseTotalAmt)
                                    const updatedOldHos = CommonValidation.getDiscountAmountWithRound(Object.hospital_percent, baseTotalAmt)
                                    const disDoc = CommonValidation.getDiscountAmountWithRound(0, updatedOldDoc)
                                    const disHos = CommonValidation.getDiscountAmountWithRound(MemberDiscount, updatedOldHos)
                                    const conTlt = (+disDoc) + (+disHos)
                                    const cons_amt = CommonValidation.formatAmount(conTlt)

                                    Object.total_amt = baseTotalAmt
                                    Object.total_with_discount = (totalAmt - disHos)
                                    Object.old_doctor_amt = updatedOldDoc
                                    Object.old_hospital_amt = updatedOldHos
                                    Object.new_doctor_amt = updatedOldDoc - disDoc
                                    Object.new_hospital_amt = updatedOldHos - disHos
                                    Object.doctor_amt = updatedOldDoc - disDoc
                                    Object.hospital_amt = updatedOldHos - disHos
                                    Object.doc_discount_amt = disDoc
                                    Object.hos_discount_amt = disHos
                                    Object.hos_discount_percent = MemberDiscount
                                    Object.hos_discount_percent_w_r = MemberDiscount
                                    Object.concession_amt = CommonValidation.formatAmount(conTlt)
                                    Object.concession_percent = MemberDiscount
                                    Object.concession_percent_w_r = MemberDiscount
                                    Object.concession_comments = "Membership concession"
                                    Object.taxable_amount = taxable_amount - (cons_amt)
                                    Object.concession_applicable = concession_applicable - (cons_amt)
                                } else {
                                    const cons_amt = +CommonValidation.getDiscountAmountWithRound(MemberDiscount, totalAmt)

                                    Object.concession_percent = MemberDiscount
                                    Object.concession_percent_w_r = MemberDiscount
                                    Object.total_with_discount = (totalAmt - CommonValidation.getDiscountAmountWithRound(MemberDiscount, totalAmt))
                                    Object.concession_amt = cons_amt
                                    Object.taxable_amount = taxable_amount - (cons_amt)
                                    Object.concession_applicable = concession_applicable - (cons_amt)
                                }
                            }
                        }

                    }
                    newBillingList?.push(Object)
                }
            }
            return newBillingList;
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const hasDuplicateBetweenArrays = (arr1, arr2) => {
        const seen = new Set();
        for (const obj of arr1) {
            if (obj.package_id) {
                const key = `${obj.package_id}`;
                seen.add(key);
            } else {
                const key = obj?.drug_ms_id ? `${obj?.drug_ms_id}-${obj.doctor_id}` : obj?.drug_config_id ? `${obj?.drug_config_id}-${obj.doctor_id}` : obj?.package_detail_id ? `${obj?.package_detail_id}-${obj.doctor_id}` : `${obj.service_details_id || obj?.service_charge_id}-${obj.doctor_id}`
                seen.add(key);
            }
        }
        for (const obj of arr2) {
            if (obj.package_id) {
                const key = `${obj.package_id}`;
                if (seen.has(key)) {
                    return true;
                }
            } else {
                const key = obj?.drug_ms_id ? `${obj?.drug_ms_id}-${obj.doctor_id}` : obj?.drug_config_id ? `${obj?.drug_config_id}-${obj.doctor_id}` : obj?.package_detail_id ? `${obj?.package_detail_id}-${obj.doctor_id}` : `${obj.service_details_id || obj?.service_charge_id}-${obj.doctor_id}`
                if (seen.has(key)) {
                    return true;
                }
            }
        }
        return false;
    }

    const hasDuplicateEntries = (arr) => {
        const seen = new Set();
        for (const obj of arr) {
            if (obj.package_id) {
                const key = `${obj.package_id}`;
                if (seen.has(key)) {
                    return true;
                }
                seen.add(key);
            } else {
                const key = obj?.drug_ms_id ? `${obj?.drug_ms_id}-${obj.doctor_id}` : obj?.drug_config_id ? `${obj?.drug_config_id}-${obj.doctor_id}` : obj?.package_detail_id ? `${obj?.package_detail_id}-${obj.doctor_id}` : `${obj.service_details_id || obj?.service_charge_id}-${obj.doctor_id}`
                if (seen.has(key)) {
                    return true;
                }
                seen.add(key);
            }
        }
        return false;
    }

    const getTemplateData = (value) => {
        try {
            let patType2 = (billing.patientData?.patient_type === 'new_patient' || billing.patientData?.patient_type === 'New Patient') ? 'New Patient' : (billing.patientData?.patient_type === 'old_patient' || billing.patientData?.patient_type === 'Old Patient') ? 'Old Patient' :
                (billing.patientData?.patient_type === 'review_patient' || billing.patientData?.patient_type === 'Review Patient') ? 'Review Patient' : null
            let patientType = patType2 ?? 'New Patient'
            let template_id = value?.template_id ? value?.template_id : ''
            let package_id = value?.package_id ? value?.package_id : ''
            let assorted_id = value?.assorted_package_id ? value?.assorted_package_id : ''
            let doctor_id = billing.selected_bill_doc?.doctor_id ? billing.selected_bill_doc?.doctor_id : billing.selected_bill_doc_id
            let moduleType = loginInfo?.module_name === MODULE_NAME.LABORATORY_LOW ? 'lab' :
                loginInfo?.module_name === MODULE_NAME.RADIOLOGY_LOW ? 'radiology' : loginInfo?.module_name === 'Investigation' ? GetInvestigationName() : loginInfo?.module_name === 'Canteen' ? 'canteen' :
                    billing?.patientData?.appointment_id ? 'op' : 'self'
            RestAPIService.getAll(Serviceurls.NEW_BILLING_OP_TEMPLATE_GET
                + '?template_id=' + template_id +
                '&package_id=' + package_id +
                '&assorted_id=' + assorted_id +
                '&doctor_id=' + doctor_id +
                '&patient_type=' + patientType +
                '&from_billing=true' +
                '&patient_id=' + props?.patientData?.patient_id || billing.patientData?.patient_id +
                (billing?.patientData?.appointment_id ? `&appointment_id=${billing?.patientData?.appointment_id}` : "")
                // '&module_type=' + moduleType
            ).then((response) => {
                if (response?.data?.status === 'success') {
                    let packageName = response?.data?.data?.package_name
                    let packData = response?.data?.data
                    if (packData?.package_type === 'Package' || packData?.package_type === 'Assorted') {
                        let billPackData = setPackageListData(packData)
                        setBilling((prev) => ({ ...prev, billingList: [...billing.billingList, ...billPackData] }))
                    } else {
                        let data = response?.data?.data?.template_line
                        let hasDuplicate = hasDuplicateBetweenArrays(billing.billingList, data)
                        let billList = setBillingListData(data, packageName)
                        if (hasDuplicate) {
                            setIsWarning(true)
                            settempDup(billList)
                        } else {
                            setBilling((prev) => ({ ...prev, billingList: [...billing.billingList, ...billList] }))
                        }
                    }
                }
            }).catch((error) => {
                if (error?.response?.data?.message) {
                    errorMessage(error?.response?.data?.message)
                } else {
                    errorMessage(error.message)
                }
            })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const getCorporateDetails = () => {
        try {
            RestAPIService.getAll(Serviceurls.FO_CONFIG_CORPORATE)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setBilling((prev) => ({
                            ...prev,
                            corporateData: response?.data?.data,
                            creditType: true
                        }))
                    }
                }).catch((error) => {
                    if (error?.response?.data?.status) {
                        errorMessage(error.response.data.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const getInsuranceDetails = () => {
        try{
            RestAPIService.getAll(Serviceurls.FO_INSURANCE_LIST)
                .then((response) => {
                    if(response.data.status === 'success'){
                        setBilling((prev) => ({
                            ...prev,
                            insuranceData: response?.data?.data,
                            creditType: true
                        }))
                    }
                }).catch((error) => {
                    if(error?.response?.data.status){
                      errorMessage(error.response.data.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        }catch (error){
             errorMessage(error.message)
        }
    }

    const getCorporateServiceData = (doctor_id = "", type, selectedCorportateId) => {
        try {
            let patType2 = (type === 'new_patient' || type === 'New Patient') ? 'New Patient' : (type === 'old_patient' || type === 'Old Patient') ? 'Old Patient' :
                (type === 'review_patient' || type === 'Review Patient') ? 'Review Patient' : null
            let patientType = patType2 ?? 'New Patient'
            RestAPIService.getAll(Serviceurls.BILLING_OP_CORPORATE_LIST + `?employer_id=${selectedCorportateId}&module=${loginInfo?.module_name === MODULE_NAME.LABORATORY_LOW ? 'LAB' :
                loginInfo?.module_name === MODULE_NAME.RADIOLOGY_LOW ? "RADIOLOGY" : loginInfo?.module_name === 'Investigation' ? GetInvestigationName() : "OP"}&doctor_id=${doctor_id}&patient_type=${patientType}`)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        setBilling((prev) => ({
                            ...prev,
                            corporateServiceList: response?.data?.data
                        }))
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error?.response?.data?.message)
                    } else {
                        errorMessage(error?.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const getApporverListData = () => {
        try {
            let moduleType = loginInfo?.module_name === 'front_office' ? 'fo' : loginInfo?.module_name === 'Laboratory' ? 'lab' :
                loginInfo?.module_name === 'Radiology' ? 'radiology' : loginInfo?.module_name === 'Investigation' ? GetInvestigationName() : ""
            RestAPIService.getAll(Serviceurls.NEW_BILLING_APPROVER_LIST + '?module=' + moduleType)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        setRequestState((prev) => ({ ...prev, approverList: response?.data?.data }))
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error?.response?.data?.message)
                    } else {
                        errorMessage(error?.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const applyDiscountPaymentSplitUp = (data, overallDiscount, cashAmt, cardAmt, upiAmt, bankAmt, chequeAmt) => {
        try {
            let totalHospitalShare = 0;

            for (const item of data) {
                totalHospitalShare += item?.edit_discount ? item.is_hospital ? item.hospital_amt : item.total_with_discount : 0;
            }

            let remainingCash = +cashAmt || 0;
            let remainingCard = +cardAmt || 0;
            let remainingUpi = +upiAmt || 0;
            let remainingBank = +bankAmt || 0;
            let remainingCheque = +chequeAmt || 0;

            const result = new Array(data.length);
            for (let i = 0; i < data.length; i++) {
                const item = data[i];
                const isHospital = item.is_hospital;
                const maxDiscount = isHospital ? item.hospital_amt : item.total_with_discount;

                let discountShare = 0;
                let newTotalAmount = 0;

                let newDoctorShare = 0, newHospitalShare = 0, newDoctorPercent = 0, newHospitalPercent = 0;

                if (item?.edit_discount && overallDiscount) {
                    discountShare = (maxDiscount / totalHospitalShare) * overallDiscount;
                    discountShare = Math.min(parseFloat(discountShare.toFixed(2)), maxDiscount);

                    newTotalAmount = parseFloat((item.total_with_discount - discountShare).toFixed(2));

                    if (isHospital) {
                        const doctorAmt = parseFloat(item.doctor_amt) || 0;
                        const hospiAmt = parseFloat(item.hospital_amt) || 0;
                        newDoctorShare = parseFloat(doctorAmt.toFixed(5));
                        newHospitalShare = parseFloat((hospiAmt - discountShare).toFixed(5));

                        newDoctorPercent = parseFloat(((newDoctorShare / newTotalAmount) * 100).toFixed(5));
                        newHospitalPercent = parseFloat(((newHospitalShare / newTotalAmount) * 100).toFixed(5));

                    } else if (item.doctor_amt && item.hospital_amt) {
                        newDoctorShare = (newTotalAmount * item.doctor_percent) / 100;
                        newHospitalShare = (newTotalAmount * item.hospital_percent) / 100;

                        let totalShare = newDoctorShare + newHospitalShare;
                        let diff = newTotalAmount - totalShare;

                        if (Math.abs(diff) > 0.009) newHospitalShare += diff;

                        newDoctorShare = parseFloat(newDoctorShare.toFixed(5));
                        newHospitalShare = parseFloat(newHospitalShare.toFixed(5));

                        newDoctorPercent = parseFloat(((newDoctorShare / newTotalAmount) * 100).toFixed(5));
                        newHospitalPercent = parseFloat(((newHospitalShare / newTotalAmount) * 100).toFixed(5));
                    }
                } else {
                    newDoctorShare = item?.new_doctor_amt
                    newHospitalShare = item?.new_hospital_amt
                    newDoctorPercent = item?.doctor_percent
                    newHospitalPercent = item?.hospital_percent
                    newTotalAmount = item?.total_with_discount
                }

                let newTotalWithGst = parseFloat((newTotalAmount * (1 + (item.gst_percent || 0) / 100)).toFixed(2));

                let billRemaining = newTotalWithGst;
                let payments = { cash: 0, card: 0, upi: 0, bank: 0, cheque: 0 };

                if (billRemaining > 0 && remainingCash > 0) {
                    let cashToUse = Math.min(remainingCash, billRemaining);
                    payments.cash = parseFloat(cashToUse.toFixed(2));
                    remainingCash = parseFloat((remainingCash - cashToUse).toFixed(2));
                    billRemaining = parseFloat((billRemaining - cashToUse).toFixed(2));
                }

                if (billRemaining > 0 && remainingCard > 0) {
                    let cardToUse = Math.min(remainingCard, billRemaining);
                    payments.card = parseFloat(cardToUse.toFixed(2));
                    remainingCard = parseFloat((remainingCard - cardToUse).toFixed(2));
                    billRemaining = parseFloat((billRemaining - cardToUse).toFixed(2));
                }

                if (billRemaining > 0 && remainingUpi > 0) {
                    let upiToUse = Math.min(remainingUpi, billRemaining);
                    payments.upi = parseFloat(upiToUse.toFixed(2));
                    remainingUpi = parseFloat((remainingUpi - upiToUse).toFixed(2));
                    billRemaining = parseFloat((billRemaining - upiToUse).toFixed(2));
                }

                if (billRemaining > 0 && remainingBank > 0) {
                    let bankToUse = Math.min(remainingBank, billRemaining);
                    payments.bank = parseFloat(bankToUse.toFixed(2));
                    remainingBank = parseFloat((remainingBank - bankToUse).toFixed(2));
                    billRemaining = parseFloat((billRemaining - bankToUse).toFixed(2));
                }

                if (billRemaining > 0 && remainingCheque > 0) {
                    let chequeToUse = Math.min(remainingCheque, billRemaining);
                    payments.cheque = parseFloat(chequeToUse.toFixed(2));
                    remainingCheque = parseFloat((remainingCheque - chequeToUse).toFixed(2));
                    billRemaining = parseFloat((billRemaining - chequeToUse).toFixed(2));
                }

                let servicePayment = parseFloat((payments.cash + payments.card + payments.upi + payments.bank + payments.cheque).toFixed(2));

                let updated = {
                    aft_discount: discountShare ?? item?.concession_amt,
                    aft_total_amount: newTotalAmount ?? item.total_with_discount,
                    aft_doctor_share: newDoctorShare ?? item?.doctor_amt,
                    aft_hospital_share: newHospitalShare ?? item?.hospital_amt,
                    aft_doctor_percent: newDoctorPercent ?? item?.doctor_percent,
                    aft_hospital_percent: newHospitalPercent ?? item?.hospital_percent,
                    aft_total_with_gst: loginInfo?.is_gst_enabled ? newTotalWithGst ?? item?.service_with_gst_total_amt : 0,
                    aft_payment_status: servicePayment === 0 ? 'not paid' : servicePayment === newTotalWithGst ? 'paid' : 'partial',
                    aft_net_amount: item?.edit_discount ? (newTotalWithGst ? newTotalWithGst : item?.service_with_gst_total_amt) : newTotalAmount,
                    aft_receive_amt: servicePayment,
                    aft_bill_gst_amount: (newTotalWithGst && newTotalAmount) ? (newTotalWithGst - newTotalAmount) : (item.service_with_gst_total_amt - item?.total_with_discount),
                    ...payments

                }
                result[i] = { item, updated };
            }

            return result;
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const checkApiValidation = () => {
        try {
            let message = null;
            let totalAmt = (+billing.cash_amt) + (+billing.card_amt) + (+billing.upi_amt) + (+billing.bank_amt) + (+billing.cheque_amt)
            if (totalAmt > billing.overall_data.payable_amt) {
                message = 'Amount is greater than payable amount'
            } else if (checkTransationMandatory() &&
                ((billing.card_amt !== "" && billing.card_no === "") ||
                    (billing.upi_amt !== "" && billing.upi_no === "") ||
                    (billing.cheque_amt !== "" && billing.cheque_no === "") ||
                    (billing.bank_amt !== "" && billing.bank_no === ""))) {
                message = 'Please,Enter Reference Number'
            } else if (billing.overallDiscount.discount_amount && billing.concessionReason === '') {
                message = 'Reason is mandatory.Click Note icon to enter reason'
            } else if (
                (billing.card_no !== "" && billing.card_no?.length < TXN_MSG_MAX_LEN) ||
                (billing.upi_no !== "" && billing.upi_no?.length < TXN_MSG_MAX_LEN) ||
                (billing.cheque_no !== "" && billing.cheque_no?.length < TXN_MSG_MAX_LEN) ||
                (billing.bank_no !== "" && billing.bank_no?.length < TXN_MSG_MAX_LEN)) {
                message = TXN_MSG_MAX
            }
            return message;
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const flatBillData = (billData = []) => {
        try {
            const newBillData = [];
            billData?.forEach(element => {
                if (element?.package_type === 'Assorted' || element?.package_type === 'Package') {
                    switch (element?.billing_display) {
                        case 'Package Name':
                        case 'Assorted Package Name':
                            newBillData?.push({
                                line_item_type: element?.package_type === 'Package' ? 'Package' : 'Assorted',
                                billing_display: element?.billing_display,
                                package_id: element?.package_type === 'Package' ? element?.package_id : null,
                                assorted_package_id: element?.package_type === 'Assorted' ? element?.package_id : null,
                                service_head_name: element?.billing_display === 'Package Name' ? 'Package' : 'Assorted Package',
                                service_head_code: '',
                                service_name: element?.package_name,
                                service_code: element?.package_code,
                                package_name: element?.package_type === 'Assorted' ? '' : element.package_name,
                                assorted_package_name: element?.package_type === 'Assorted' ? element.package_name : '',
                                id: element?.package_line[0]?.service_data[0]?.id ?? null,
                                order_line_ids: element?.order_line_ids ?? [],
                                edit_discount: true,
                                edit_amount: false,
                                edit_unit: false,
                                rate_per_unit: element?.rate_per_unit ?? 0,
                                unit: element?.unit ?? 1,
                                unit_type: element?.unit_type ?? 'Nos',
                                concession_amt: element?.concession_amt ?? 0,
                                concession_percent: element?.concession_percent ?? 0,
                                concession_percent_w_r: (+element?.concession_percent_w_r)?.toFixed(2) ?? 0,
                                total_amt: element?.total_amt ?? 0,
                                total_with_discount: element?.total_with_discount ?? 0,
                                service_with_gst_total_amt: element?.service_with_gst_total_amt ?? 0,
                                gst_amount: 0,
                                sgst_amount: 0,
                                cgst_amount: 0,
                                igst_amount: element?.igst_amount ?? 0,
                                taxable_amount: element?.taxable_amount ?? 0,
                                sub_total_amount: element?.sub_total_amount ?? 0,
                                concession_applicable: element?.concession_applicable ?? 0,
                                is_sharable: element?.is_sharable ?? '',
                                is_consultation: element?.is_consultation ?? '',
                                drug_config_id: element?.drug_config_id ?? null,
                                drug_ms_id: element?.drug_ms_id ?? null,
                                pharmacy_id: element?.pharmacy_id ?? null,
                                sub_location_id: element?.sub_location_id ?? null,
                                service_details_id: element?.service_details_id ?? null,
                                service_head_id: element?.service_head_id ?? null,
                                doctor_id: element?.doctor_id ?? null,
                                doctor_name: element?.doctor_name ?? null,
                                old_doctor_amt: element?.old_doctor_amt,
                                new_doctor_amt: element?.new_doctor_amt,
                                old_hospital_amt: element?.old_hospital_amt,
                                new_hospital_amt: element?.new_hospital_amt,
                                doctor_percent: element?.doctor_percent,
                                hospital_percent: element?.hospital_percent,
                                start_time: element?.start_time || null,
                                end_time: element?.end_time || null,
                                total_amount: +element?.total_with_discount || 0,
                                sub_total_amount: +element?.sub_total_amount || 0,
                                discount_amount: +element?.concession_amt || 0,
                                discount_percentage: +element?.concession_percent || 0,
                                concession_comments: element?.concession_comments || '',
                                service_rate_per_unit: +element?.rate_per_unit || 0,
                                service_old_unit_count: element?.unit_type === 'Hrs' ? element?.old_time_taken : null,
                                module_type: element?.module_type ?? '',
                                gst_percent: 0
                            })
                            break;
                        case 'Assorted Service Head':
                            if (element?.package_line?.length) {
                                element?.package_line?.forEach(pack => {
                                    newBillData?.push({
                                        line_item_type: element?.package_type === 'Package' ? 'Package' : 'Assorted',
                                        billing_display: element?.billing_display,
                                        package_id: element?.package_type === 'Package' ? element?.package_id : null,
                                        assorted_package_id: element?.package_type === 'Assorted' ? element?.package_id : null,
                                        service_head_name: element?.package_name,
                                        service_head_code: element?.package_code,
                                        service_name: pack?.package_service_head,
                                        service_code: pack?.package_service_code || '',
                                        package_name: element?.package_type === 'Assorted' ? '' : element.package_name,
                                        assorted_package_name: element?.package_type === 'Assorted' ? element.package_name : '',
                                        assorted_package_head_id: pack?.package_head_id,
                                        id: pack?.service_data[0]?.id,
                                        order_line_ids: pack?.order_line_ids ?? [],
                                        drug_config_id: pack?.drug_config_id ?? null,
                                        drug_ms_id: pack?.drug_ms_id ?? null,
                                        pharmacy_id: pack?.pharmacy_id ?? null,
                                        sub_location_id: pack?.sub_location_id ?? null,

                                        edit_discount: true,
                                        edit_amount: false,
                                        edit_unit: false,
                                        rate_per_unit: pack?.rate_per_unit ?? 0,
                                        unit: pack?.unit ?? 1,
                                        unit_type: pack?.unit_type ?? 'Nos',
                                        concession_amt: pack?.concession_amt ?? 0,
                                        concession_percent: pack?.concession_percent ?? 0,
                                        concession_percent_w_r: (+pack?.concession_percent_w_r)?.toFixed(2) ?? 0,
                                        total_amt: pack?.total_amt ?? 0,
                                        total_with_discount: pack?.total_with_discount ?? 0,
                                        service_with_gst_total_amt: pack?.service_with_gst_total_amt ?? 0,
                                        gst_amount: 0,
                                        sgst_amount: 0,
                                        cgst_amount: 0,
                                        igst_amount: pack?.igst_amount ?? 0,
                                        taxable_amount: pack?.taxable_amount ?? 0,
                                        sub_total_amount: pack?.sub_total_amount ?? 0,
                                        concession_applicable: pack?.concession_applicable ?? 0,
                                        service_name: pack?.service_name ?? '',
                                        service_head_name: pack?.service_head_name ?? '',
                                        service_code: pack?.service_code ?? '',
                                        service_head_code: pack?.service_head_code ?? '',
                                        is_sharable: pack?.is_sharable ?? '',
                                        is_consultation: pack?.is_consultation ?? '',
                                        service_details_id: pack?.service_details_id ?? null,
                                        service_head_id: pack?.service_head_id ?? null,
                                        doctor_id: pack?.doctor_id ?? null,
                                        doctor_name: pack?.doctor_name ?? null,
                                        old_doctor_amt: pack?.old_doctor_amt,
                                        new_doctor_amt: pack?.new_doctor_amt,
                                        old_hospital_amt: pack?.old_hospital_amt,
                                        new_hospital_amt: pack?.new_hospital_amt,
                                        doctor_percent: pack?.doctor_percent,
                                        hospital_percent: pack?.hospital_percent,
                                        start_time: pack?.start_time || null,
                                        end_time: pack?.end_time || null,
                                        total_amount: +pack?.total_with_discount || 0,
                                        sub_total_amount: +pack?.sub_total_amount || 0,
                                        discount_amount: +pack?.concession_amt || 0,
                                        discount_percentage: +pack?.concession_percent || 0,
                                        concession_comments: pack?.concession_comments || '',
                                        service_rate_per_unit: +pack?.rate_per_unit || 0,
                                        service_old_unit_count: pack?.unit_type === 'Hrs' ? pack?.old_time_taken : null,
                                        module_type: pack?.module_type ?? '',
                                        gst_percent: 0
                                    })
                                })
                            }
                            break;
                        case 'Service Head':
                            if (element?.package_line?.length) {
                                element?.package_line?.forEach(pack => {
                                    pack?.service_data?.forEach(ser => {
                                        newBillData?.push({
                                            line_item_type: element?.package_type === 'Package' ? 'Package' : 'Assorted',
                                            billing_display: element?.billing_display,
                                            package_id: element?.package_type === 'Package' ? element?.package_id : null,
                                            assorted_package_id: element?.package_type === 'Assorted' ? element?.package_id : null,
                                            service_head_name: element?.package_type === 'Package' ? element?.package_name : pack?.package_service_head,
                                            service_head_code: element?.package_type === 'Package' ? element?.package_code : '',
                                            service_name: ser?.service_head_name,
                                            service_code: ser?.service_head_code,
                                            package_name: element?.package_type === 'Assorted' ? '' : element.package_name,
                                            assorted_package_name: element?.package_type === 'Assorted' ? element.package_name : '',
                                            assorted_package_head_id: element?.package_type === 'Assorted' ? pack?.package_head_id : null,
                                            package_detail_id: element?.package_type === 'Assorted' ? null : ser?.package_detail_id,
                                            id: ser?.id ?? null,
                                            order_line_ids: ser?.order_line_ids ?? [],
                                            drug_config_id: ser?.drug_config_id ?? null,
                                            drug_ms_id: ser?.drug_ms_id ?? null,
                                            pharmacy_id: ser?.pharmacy_id ?? null,
                                            sub_location_id: ser?.sub_location_id ?? null,

                                            edit_discount: true,
                                            edit_amount: false,
                                            edit_unit: false,
                                            rate_per_unit: ser?.rate_per_unit ?? 0,
                                            unit: ser?.unit ?? 1,
                                            unit_type: ser?.unit_type ?? 'Nos',
                                            concession_amt: ser?.concession_amt ?? 0,
                                            concession_percent: ser?.concession_percent ?? 0,
                                            concession_percent_w_r: (+ser?.concession_percent_w_r)?.toFixed(2) ?? 0,
                                            total_amt: ser?.total_amt ?? 0,
                                            total_with_discount: ser?.total_with_discount ?? 0,
                                            service_with_gst_total_amt: ser?.service_with_gst_total_amt ?? 0,
                                            gst_amount: 0,
                                            sgst_amount: 0,
                                            cgst_amount: 0,
                                            igst_amount: ser?.igst_amount ?? 0,
                                            taxable_amount: ser?.taxable_amount ?? 0,
                                            sub_total_amount: ser?.sub_total_amount ?? 0,
                                            concession_applicable: ser?.concession_applicable ?? 0,
                                            service_name: ser?.service_name ?? '',
                                            service_head_name: ser?.service_head_name ?? '',
                                            service_code: ser?.service_code ?? '',
                                            service_head_code: ser?.service_head_code ?? '',
                                            is_sharable: ser?.is_sharable ?? '',
                                            is_consultation: ser?.is_consultation ?? '',
                                            service_details_id: ser?.service_details_id ?? null,
                                            service_head_id: ser?.service_head_id ?? null,
                                            doctor_id: ser?.doctor_id ?? null,
                                            doctor_name: ser?.doctor_name ?? null,
                                            old_doctor_amt: ser?.old_doctor_amt,
                                            new_doctor_amt: ser?.new_doctor_amt,
                                            old_hospital_amt: ser?.old_hospital_amt,
                                            new_hospital_amt: ser?.new_hospital_amt,
                                            doctor_percent: ser?.doctor_percent,
                                            hospital_percent: ser?.hospital_percent,
                                            start_time: ser?.start_time || null,
                                            end_time: ser?.end_time || null,
                                            total_amount: +ser?.total_with_discount || 0,
                                            sub_total_amount: +ser?.sub_total_amount || 0,
                                            discount_amount: +ser?.concession_amt || 0,
                                            discount_percentage: +ser?.concession_percent || 0,
                                            concession_comments: ser?.concession_comments || '',
                                            service_rate_per_unit: +ser?.rate_per_unit || 0,
                                            service_old_unit_count: ser?.unit_type === 'Hrs' ? ser?.old_time_taken : null,
                                            module_type: ser?.module_type ?? '',
                                            gst_percent: 0
                                        })
                                    })
                                })
                            }
                            break;
                        case 'Service Name':
                            if (element?.package_line?.length) {
                                element?.package_line?.forEach(pack => {
                                    pack?.service_data?.length && pack?.service_data?.forEach(ser => {
                                        newBillData?.push({
                                            line_item_type: element?.package_type === 'Package' ? 'Package' : 'Assorted',
                                            billing_display: element?.billing_display,
                                            package_id: element?.package_type === 'Package' ? element?.package_id : null,
                                            assorted_package_id: element?.package_type === 'Assorted' ? element?.package_id : null,
                                            package_name: element?.package_type === 'Assorted' ? '' : element.package_name,
                                            assorted_package_name: element?.package_type === 'Assorted' ? element.package_name : '',
                                            assorted_package_head_id: pack?.package_head_id,
                                            assorted_package_items_id: element?.package_type === 'Assorted' ? ser?.package_detail_id : null,
                                            package_detail_id: element?.package_type === 'Assorted' ? null : ser?.package_detail_id,
                                            id: ser?.id ?? null,
                                            order_line_ids: ser?.order_line_ids ?? [],
                                            drug_config_id: ser?.drug_config_id ?? null,
                                            drug_ms_id: ser?.drug_ms_id ?? null,
                                            pharmacy_id: ser?.pharmacy_id ?? null,
                                            sub_location_id: ser?.sub_location_id ?? null,

                                            edit_discount: true,
                                            edit_amount: false,
                                            edit_unit: true,
                                            rate_per_unit: ser?.rate_per_unit ?? 0,
                                            unit: ser?.unit ?? 1,
                                            unit_type: ser?.unit_type ?? 'Nos',
                                            concession_amt: ser?.concession_amt ?? 0,
                                            concession_percent: ser?.concession_percent ?? 0,
                                            concession_percent_w_r: (+ser?.concession_percent_w_r)?.toFixed(2) ?? 0,
                                            total_amt: ser?.total_amt ?? 0,
                                            total_with_discount: ser?.total_with_discount ?? 0,
                                            service_with_gst_total_amt: ser?.service_with_gst_total_amt ?? 0,
                                            gst_amount: 0,
                                            sgst_amount: 0,
                                            cgst_amount: 0,
                                            igst_amount: ser?.igst_amount ?? 0,
                                            taxable_amount: ser?.taxable_amount ?? 0,
                                            sub_total_amount: ser?.sub_total_amount ?? 0,
                                            concession_applicable: ser?.concession_applicable ?? 0,
                                            service_name: ser?.service_name ?? '',
                                            service_head_name: ser?.service_head_name ?? '',
                                            service_code: ser?.service_code ?? '',
                                            service_head_code: ser?.service_head_code ?? '',
                                            is_sharable: ser?.is_sharable ?? '',
                                            is_consultation: ser?.is_consultation ?? '',
                                            service_details_id: ser?.service_details_id ?? null,
                                            service_head_id: ser?.service_head_id ?? null,
                                            doctor_id: ser?.doctor_id ?? null,
                                            doctor_name: ser?.doctor_name ?? null,
                                            old_doctor_amt: ser?.old_doctor_amt,
                                            new_doctor_amt: ser?.new_doctor_amt,
                                            old_hospital_amt: ser?.old_hospital_amt,
                                            new_hospital_amt: ser?.new_hospital_amt,
                                            doctor_percent: ser?.doctor_percent,
                                            hospital_percent: ser?.hospital_percent,
                                            start_time: ser?.start_time || null,
                                            end_time: ser?.end_time || null,
                                            total_amount: +ser?.total_with_discount || 0,
                                            sub_total_amount: +ser?.sub_total_amount || 0,
                                            discount_amount: +ser?.concession_amt || 0,
                                            discount_percentage: +ser?.concession_percent || 0,
                                            concession_comments: ser?.concession_comments || '',
                                            service_rate_per_unit: +ser?.rate_per_unit || 0,
                                            service_old_unit_count: ser?.unit_type === 'Hrs' ? ser?.old_time_taken : null,
                                            module_type: ser?.module_type ?? '',
                                            gst_percent: 0
                                        })
                                    })
                                })
                            }
                            break;
                    }
                } else {
                    newBillData?.push({
                        line_item_type: 'Individual',
                        billing_display: '',
                        ...element
                    })
                }
            })

            return newBillData;
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const postBillingData = (billType, appointId, MoveToCashCounter = false) => {
        try {
            let check = billType === 'draft' ? null : checkApiValidation();
            if (check === null) {
                let hasPackage = billing.billingList?.some(item => item?.package_type)
                let finalData = [];
                if (hasPackage) {
                    let convertBillingList = flatBillData(billing.billingList)
                    finalData = applyDiscountPaymentSplitUp(convertBillingList, +billing.overallDiscount?.discount_amount, billing.cash_amt, billing.card_amt, billing.upi_amt, billing.bank_amt, billing.cheque_amt) || []
                } else {
                    finalData = applyDiscountPaymentSplitUp(billing.billingList, +billing.overallDiscount?.discount_amount, billing.cash_amt, billing.card_amt, billing.upi_amt, billing.bank_amt, billing.cheque_amt) || []
                }
                let finalBillingListData = [];
                let payamt = (+billing.cash_amt) + (+billing.card_amt) + (+billing.upi_amt) + (+billing.bank_amt) + (+billing.cheque_amt)
                let status = payamt === 0 ? 'not paid' : payamt < billing?.overall_data?.payable_amt ? 'partial' : payamt === billing.overall_data?.payable_amt ? 'paid' : 'not paid'
                for (let i = 0; i < finalData.length; i++) {
                    const original = finalData[i]?.item;
                    const updated = finalData[i]?.updated;

                    finalBillingListData?.push({
                        id: original?.id,
                        bill_doctor_id: original?.doctor_id === 'all' ? null : original?.doctor_id,
                        op_order_line_id: original?.op_order_line_id || null,
                        service_head_id: original?.service_head_id || null,
                        service_details_id: original?.service_details_id || null,
                        service_charge_id: original?.charge_id || null,
                        gst_percent: original?.gst_percent || 0,
                        unit: original?.unit || '1',
                        unit_type: original?.unit_type || 'Nos',
                        interval_time: original?.interval_time || null,
                        interval_amount: original?.interval_amount || 0,
                        doctor_share_percent: +original?.doctor_percent || 0,
                        hospital_share_percent: +original?.hospital_percent || 0,
                        old_doctor_fee: +original?.old_doctor_amt || 0,
                        old_hospital_fee: +original?.old_hospital_amt || 0,
                        new_doctor_fee: +original?.new_doctor_amt || 0,
                        new_hospital_fee: +original?.new_hospital_amt || 0,
                        start_time: original?.start_time || null,
                        end_time: original?.end_time || null,
                        total_amount: +original?.total_with_discount || 0,
                        sub_total_amount: +original?.sub_total_amount || 0,
                        discount_amount: +original?.concession_amt || 0,
                        discount_percentage: +original?.concession_percent || 0,
                        concession_comments: original?.concession_comments || '',
                        service_rate_per_unit: +original?.rate_per_unit || 0,
                        service_old_unit_count: original?.unit_type === 'Hrs' ? original?.old_time_taken : null,

                        taxable_amount: +original?.total_with_discount || 0,
                        gst_amount: +original?.gst_amount || 0,
                        cgst_amount: +original?.cgst_amount || 0,
                        sgst_amount: +original?.sgst_amount || 0,
                        igst_amount: +original?.gst_amount || 0,
                        net_amount: +original?.total_with_discount || 0,
                        // net_amount: +updated?.aft_net_amount || 0,
                        received_amount: billType === 'Draft' ? 0 : (+updated?.aft_receive_amt || 0),
                        bill_type: billType,
                        is_sharable: original?.is_sharable || false,
                        is_consultation: original?.is_consultation || false,

                        cash_amount: updated?.cash || 0,
                        card_amount: updated?.card || 0,
                        upi_amount: updated?.upi || 0,
                        bank_amount: updated?.bank || 0,
                        cheque_amount: updated?.cheque || 0,

                        bill_discount_amount: +updated?.aft_discount || 0,
                        bill_total_amount: +updated?.aft_total_amount || 0,
                        bill_doctor_share: +updated?.aft_doctor_share || 0,
                        bill_hospital_share: +updated?.aft_hospital_share || 0,
                        bill_doctor_percent: +updated?.aft_doctor_percent || 0,
                        bill_hospital_percent: +updated?.aft_hospital_percent || 0,
                        bill_total_with_gst: loginInfo?.is_gst_enabled ? +updated?.aft_total_with_gst : 0,
                        payment_status: updated?.aft_payment_status,
                        service_code: original?.service_code || '',
                        service_head_code: original?.service_head_code || '',
                        service_head_name: original?.service_head_name || '',
                        service_name: original?.service_name || '',
                        // op_order_number: original?.op_order_number || '',
                        package_detail_id: original?.line_item_type === 'Assorted' ? null : original?.package_detail_id ?? null,
                        package_name: original?.package_name || '',
                        order_line_status: billType === 'Draft' ? 'Draft' :
                            (loginInfo?.module_name === MODULE_NAME.LABORATORY_LOW || loginInfo?.module_name === MODULE_NAME.RADIOLOGY_LOW || loginInfo?.module_name === "Investigation") ? 'Accepted' :
                                (loginInfo?.module_name === 'front_office'|| loginInfo?.module_name === MODULE_NAME.DOCTOR) && (original?.module_type?.toLowerCase() === 'op' || original?.module_type?.toLowerCase() === 'ip_op' || original?.drug_config_id || original?.drug_ms_id) ? 'Accepted' : 'Billed',
                        package_id: original?.package_id ?? null,
                        assorted_package_id: original?.line_item_type === 'Assorted' ? original?.assorted_package_id ?? null : null,
                        line_item_type: original?.line_item_type ?? 'Individual',
                        billing_display: original?.billing_display ?? '',
                        assorted_package_name: original?.assorted_package_name ?? '',
                        assorted_package_head_id: original?.assorted_package_head_id ?? null,
                        assorted_package_items_id: original?.assorted_package_items_id ?? null,
                        order_line_ids: original?.order_line_ids ?? [],
                        drug_config_id: original?.drug_config_id ?? null,
                        drug_ms_id: original?.drug_ms_id ?? null,
                        pharmacy_id: original?.pharmacy_id ?? null,
                        sub_location_id: original?.sub_location_id ?? null,
                        is_membership_discount_applied: original?.membership_discount_percentage ?? false,
                        module_type: original?.module_type?.toUpperCase() ?? ''
                    })
                }

                let payment = []
                if (billing.isCash) {
                    payment.push(1)
                }
                if (billing.isCard) {
                    payment.push(2)
                }
                if (billing.isUPI) {
                    payment.push(3)
                }
                if (billing.isCheque) {
                    payment.push(4)
                }
                if (billing.isBank) {
                    payment.push(5)
                }
                let startDate = new Date()
                let date = DateTime.fromJSDate(startDate).toFormat('yyyy-MM-dd')
                let Aptime = DateTime.fromJSDate(startDate).toLocaleString(DateTime.TIME_24_SIMPLE);
                const invoice_date = date ? `${DateTime.fromJSDate(startDate).toFormat("yyyy-MM-dd")} ${Aptime}:00` : ""
                let appointment_id = appontimentId ? appontimentId : props?.patientData?.appointment_id ? props?.patientData?.appointment_id : null
                let doctorId = props?.doctorDetails?.selectedDoctor?.doctor_id ? props?.doctorDetails?.selectedDoctor?.doctor_id : props?.patientData?.doctor_id ?? null
                let patientId = billing.patientData?.patient_id
                const referredDoctorName = selectedRefDoc && typeof selectedRefDoc === "object"
                        ? `${selectedRefDoc.name}`
                        : InputRefDoc || null;

                const referredDoctorSpec = selectedRefDoc && typeof selectedRefDoc === "object"
                        ? selectedRefDoc.specialization
                        : null;
                const referredDoctorQualify = selectedRefDoc && typeof selectedRefDoc === "object"
                        ? selectedRefDoc.qualification
                        : null;
                let ModifyBill = getCachevalue('BillType') === 'Modify' 
                let billDetails = props?.billingData?.[0]
                let patientCreditType = ModifyBill ?
                ( billDetails?.credit_type === 'Patient credit' ? (JSON.parse(localGetItem('allow_patient_credit_bills')) ? 'Patient credit'  : '' ) : (billDetails?.credit_type === "Insurance credit" ? "Insurance credit"  : (billDetails?.credit_type === 'Corporate credit' ? 'Corporate credit'  : '' ) ) ) :
                (billType === "Regular" ? ((billing.patientCreditType === 'patientcredit' && JSON.parse(localGetItem('allow_patient_credit_bills'))) ? "Patient credit" : (billing.patientCreditType === 'corporatecredit' ? "Corporate credit" : billing.patientCreditType === 'insurancecredit' ? 'Insurance credit' : "")) : billing.patientCreditType === 'patientcredit' ? ((JSON.parse(localGetItem('allow_patient_credit_bills'))) ? 'Patient credit' : '') : billing.patientCreditType === 'insurancecredit' ? 'Insurance credit' : billing.patientCreditType === 'corporatecredit' ? 'Corporate credit' : "")
                let data = {
                    appointment_id: appointId || appointment_id,
                    invoice_date: invoice_date,
                    bill_type: billType,
                    patient_id: patientId,
                    doctor_id: (doctorId === 'all' || props.is_Nurse === true) ? null : doctorId,
                    clinic_id: JSON.parse(localGetItem('SelectedDoctorClinicId')) || JSON.parse(localGetItem('clinicId')),
                    credit_type: patientCreditType,
                    sub_total_amount: +billing.overall_data.sub_total || +billing.overall_data.sub_total_amount,
                    actual_sub_amount: +billing.overall_data.actual_sub_total_amount || 0,
                    discount_amount: +billing.overallDiscount.discount_amount,
                    total_amount: +((+billing.overall_data.taxable_amount) - (+billing.overallDiscount.discount_amount)),
                    taxable_amount: +((+billing.overall_data.taxable_amount) - (+billing.overallDiscount.discount_amount)),
                    gst_amount: loginInfo?.is_gst_enabled ? +billing.overall_data.gst_amount : 0,
                    cgst_amount: loginInfo?.is_gst_enabled ? +billing.overall_data.cgst_amount : 0,
                    sgst_amount: loginInfo?.is_gst_enabled ? +billing.overall_data.sgst_amount : 0,
                    igst_amount: loginInfo?.is_gst_enabled ? +billing.overall_data.gst_amount : 0,
                    round_off: +CommonValidation.formatAmount(billing.overall_data.round_off),
                    net_amount: +billing.overall_data.payable_amt,
                    received_amount: billType === 'Draft' ? 0 : +payamt,
                    order_status: billType === 'Credit' ? 'Billed' : null,
                    billed_from: loginInfo?.module_name === MODULE_NAME.FRONT_OFFICE ? 'FO' : loginInfo?.module_name === MODULE_NAME.LABORATORY_LOW ? 'LAB' :
                        loginInfo?.module_name === MODULE_NAME.RADIOLOGY_LOW ? 'RADIOLOGY' : loginInfo?.module_name === "Investigation" ? GetInvestigationName() : loginInfo?.module_name === MODULE_NAME.DOCTOR ? 'DOCTOR' : 'CANTEEN',
                    payment_status: status,
                    paid_in: status === "not paid" ? null : (loginInfo?.module_name === 'front_office' ? 'FRONT OFFICE' : loginInfo?.module_name === MODULE_NAME.LABORATORY_LOW ? 'LAB' :
                        loginInfo?.module_name === MODULE_NAME.RADIOLOGY_LOW ? 'RADIOLOGY' : loginInfo?.module_name === "Investigation" ? GetInvestigationName() : 'CANTEEN'),
                    receipt_for: +payamt > 0 ? 'Bill' : '',
                    cash_amount: +billing.cash_amt,
                    card_amount: +billing.card_amt,
                    upi_amount: +billing.upi_amt,
                    bank_amount: +billing.bank_amt,
                    cheque_amount: +billing.cheque_amt,
                    card_ref_no: +billing.card_no,
                    upi_ref_no: +billing.upi_no,
                    bank_ref_no: +billing.bank_no,
                    cheque_ref_no: +billing.cheque_no,
                    overall_concession_comment: billing.concessionReason,
                    overall_discount_percentage: +billing.overallDiscount.discount_percentage,
                    bill_item_details: finalBillingListData,
                    bill_id: billing?.bill_id,
                    company_name: ModifyBill ? billDetails?.company_name : billing.patientCreditType === 'corporatecredit' ? billing?.selectedCorporate?.company_name ?? billing?.selectedCorporate : null,
                    insurance_company_name: ModifyBill ? billDetails?.insurance_company_name : billing.patientCreditType === 'insurancecredit' ? billing?.selectedInsurance?.insurance_name ?? billing?.selectedInsurance : null,
                    policy_number: ModifyBill ? billDetails?.policyno : billing.patientCreditType === 'insurancecredit' ? billing?.policyno : '',
                    employer_id: ModifyBill ? billDetails?.employer_id : billing.patientCreditType === 'corporatecredit' ? (billing?.selectedCorporate?.id || billing?.selectedCorportateId || props?.patientData?.employer_id || null) : null,
                    employee_id: ModifyBill ? billDetails?.employee_id : billing.patientCreditType === 'corporatecredit' ? billing?.employeeNo : '',
                    is_includes_lab_bill: billing?.billingList?.some((list) => list?.module_type === "LAB"),
                    is_includes_radiology_bill: billing?.billingList?.some((list) => list?.module_type === "RADIOLOGY"),
                    is_includes_canteen_bill: billing?.billingList?.some((list) => list?.module_type === "CANTEEN"),
                    is_includes_investigation_bill: billing?.billingList?.some((list) => list?.module_type === GetInvestigationName()),
                    cancelled_line_ids: getCachevalue('BillType') === 'Modify' ? billing.cancelled_ids : [],
                    payment_mode: payment,
                    convert_to_regular_bill : (MoveToCashCounter || (billing?.tempBillData ? billing?.tempBillData[0]?.convert_to_regular_bill : false)) ? true : false,
                    credit_due_date: (localGetItem('set_due_date_for_credit_billing') === 'true' && billing?.credit_due_date) ? DateTime.fromJSDate(new Date(billing?.credit_due_date)).toFormat('yyyy-MM-dd') : null,
                    referred_doctor_name: referredDoctorName,
                    referred_doctor_spec: referredDoctorSpec,
                    referred_doctor_qual: referredDoctorQualify,
                }
                // if (data.doctor_id === null && data?.appointment_id) {
                //     errorMessage(error.message)
                // } else {
                RestAPIService.create(data, Serviceurls.NEW_BILLING_OP_POST)
                    .then((response) => {
                        if (response?.data?.status === 'success') {
                            successMessage(response?.data?.message)
                            if(loginInfo?.module_name !== MODULE_NAME.DOCTOR){
                                props.triggerNotifyCount(true)
                            }
                            if (props?.fromQuickBill && loginInfo?.module_name === 'front_office' && getCachevalue('AppRequestPatientData')) {
                                clearCachevalue('AppRequestPatientData');
                            }
                            if (requestState?.fromBillConvert) {
                                deletePendingListData()
                            }
                            setAppointmentId(null)
                            clearAllData(true)
                            if (billType !== 'Draft' || (localGetItem("isNewBilling") === "true" && localGetItem("print_option_for_draft_bills") === "true")) {
                                setSuccessPopup((prev) => ({
                                    ...prev,
                                    SuccessInvoice_ID: response.data.data?.bill_id,
                                    bill_receipt_id: response.data?.data?.receipt_id,
                                    isCredit: billType === 'Credit' ? true : false,
                                    patientId: billing.patientData?.patientId,
                                    successText: billType === 'Draft' ? 'Bill Saved Successfully' :
                                        billType === 'Credit' ? 'Credit Added Successfully' : 'Payment Received Successfully',
                                    is_issued_drug: response.data.data?.is_issued_drug,
                                }))
                            }
                            if (props?.fromQuickBill) {
                                props.clearPatientData(true)
                            }else{
                                props.triggerPatientData(true);
                            }
                            if (getCachevalue('FromCreate') === 'true') {
                                const modulePaths = {
                                    front_office: '/HospitalBilling/HospitalBilling',
                                    Laboratory: '/LabBilling/HospitalBilling',
                                    Radiology: '/RadiologyBilling/HospitalBilling',
                                    Investigation: `/${GetInvestigationName()}Billing/HospitalBilling`,
                                    Doctor:'/DoctorBilling/DoctorBilling'
                                };
                                const { module_name } = loginInfo || {};
                                const targetPath = modulePaths[module_name];
                                history?.push({ pathname: targetPath, state: {} })
                                setBilling((prev) => ({ ...prev, billingList: [] }))
                            } else if (getCachevalue('FromOtherScreen') === 'true') {
                                clearCachevalue('isForCancelBill')
                                clearCachevalue('BillType')
                                clearCachevalue('FromOtherScreen')
                                let path = getCachevalue('path')
                                history?.push({ pathname: path, state: {} })
                                setTimeout(() => clearCachevalue('path'), 50)
                            }
                            clearCachevalue('OP_CreateAppointment_PatientId')
                        }
                    }).catch((error) => {
                        if (error?.response?.data?.message) {
                            errorMessage(error?.response?.data?.message)
                        } else {
                            errorMessage(error.message)
                        }
                    })

                // }
            } else {
                errorMessage(check)
            }
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const postAppointmentCreate = (type, MoveToCashCounter=false) => {
        var AptDateTime = new Date(props?.doctorDetails?.appointmentDateTime);

        var AptDate = DateTime.fromJSDate(AptDateTime).toFormat('yyyy-MM-dd');

        var Aptime = DateTime.fromJSDate(AptDateTime).toLocaleString(DateTime.TIME_24_WITH_SECONDS);

        var data = {
            patient_id: billing.patientData?.patient_id,
            doctor_id: props?.doctorDetails?.selectedDoctor?.doctor_id ? props?.doctorDetails?.selectedDoctor?.doctor_id : null,
            speciality_id: props?.doctorDetails?.selectedSpecName ? props?.doctorDetails?.selectedSpecName?.id : null,
            purpose_of_visit: props?.doctorDetails?.selectedPurposeOfVist?.reason,
            patient_tag_id: props?.doctorDetails?.selectedTagId?.id,
            appointment_date: AptDate,
            appointment_start_time: (props?.doctorDetails?.selectedSlot === null || props?.doctorDetails?.selectedSlot === '') ? Aptime : `${props?.doctorDetails?.selectedSlot}:00`,
            patient_appointment_type: props?.doctorDetails?.selectedAppointTypeId === null ? 3 : props?.doctorDetails.selectedAppointTypeId?.id,
            nurse_id: props?.doctorDetails.selectedNurse?.staff_id ? props?.doctorDetails.selectedNurse?.staff_id : null,
            request_id: props?.doctorDetails.RequestedPatientData?.id ? props?.doctorDetails.RequestedPatientData?.id : null,
            qr_request_id: props?.doctorDetails.QRPatientData?.id ? props?.doctorDetails.QRPatientData?.id : null,
            followup_id: props?.doctorDetails?.followupID ? props?.doctorDetails?.followupID : null,
            optometrist_id: props?.doctorDetails?.selectedOptometrist?.id ? props?.doctorDetails?.selectedOptometrist?.id : null,
        };
        if (data?.purpose_of_visit === null) {
            errorMessage('Select Purpose of visit')
        } else if (data?.doctor_id === null && loginInfo?.token_gen_type === 'Doctor' && props.is_Nurse === false) {
            errorMessage('Select Doctor Name')
        } else if (props.is_Nurse && data?.nurse_id === null) {
            errorMessage('Select Nurse Name')
        } else if (data?.optometrist_id === null && props?.doctorDetails?.selectedSpecName?.name === "OPHTHALMOLOGY" && localGetItem("automatic_opthometrist_mapping") === "false") {
            errorMessage('Select Optometrist Name')
        }else {
            RestAPIService.create(data, Serviceurls.FO_PATIENT_APPOINTMENT)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage("Appointment Created Successfully");
                        setAppointmentId(response?.data?.data?.appointment_id)
                        if (type === 'Requested' || type === 'Accepted') {
                            postRiseRequestAndAccept(type, "", response?.data?.data?.appointment_id, MoveToCashCounter)
                        } else {
                            postBillingData(type, response?.data?.data?.appointment_id, MoveToCashCounter)
                        }
                    }
                }).catch((e) => {
                    if (e?.response?.data?.message) {
                        errorMessage(e.response.data.message);
                    } else {
                        errorMessage(e.message);
                    }
                });
        }
    };

    const postRiseRequestAndAccept = (billType, comments, appointId, MoveToCashCounter=false) => {
        try {
            setIsLoader(true)
            let check = billType === 'draft' ? null : checkApiValidation();
            if (check === null) {
                let hasPackage = billing.billingList?.some(item => item?.package_type)
                let finalData = [];
                if (hasPackage) {
                    let convertBillingList = flatBillData(billing.billingList)
                    finalData = applyDiscountPaymentSplitUp(convertBillingList, +billing.overallDiscount?.discount_amount, billing.cash_amt, billing.card_amt, billing.upi_amt, billing.bank_amt, billing.cheque_amt) || []
                } else {
                    finalData = applyDiscountPaymentSplitUp(billing.billingList, +billing.overallDiscount?.discount_amount, billing.cash_amt, billing.card_amt, billing.upi_amt, billing.bank_amt, billing.cheque_amt) || []
                }
                let finalBillingListData = [];
                let payamt = (+billing.cash_amt) + (+billing.card_amt) + (+billing.upi_amt) + (+billing.bank_amt) + (+billing.cheque_amt)
                let status = payamt === 0 ? 'not paid' : payamt < billing?.overall_data?.payable_amt ? 'partial' : payamt === billing.overall_data?.payable_amt ? 'paid' : 'not paid'
                let actualDiscountTotal = 0
                for (let i = 0; i < finalData.length; i++) {
                    const original = finalData[i]?.item;
                    const updated = finalData[i]?.updated;
                    actualDiscountTotal += (+original?.concession_amt)
                    finalBillingListData?.push({
                        id: original?.id,
                        bill_doctor_id: original?.doctor_id === 'all' ? null : original?.doctor_id,
                        op_order_line_id: original?.op_order_line_id,
                        service_head_id: original?.service_head_id || null,
                        service_details_id: original?.service_details_id || null,
                        service_charge_id: original?.charge_id || null,
                        gst_percent: original?.gst_percent || 0,
                        unit: original?.unit || '1',
                        unit_type: original?.unit_type || 'Nos',
                        interval_time: original?.interval_time || null,
                        interval_amount: original?.interval_amount || 0,
                        doctor_share_percent: +original?.doctor_percent || 0,
                        hospital_share_percent: +original?.hospital_percent || 0,
                        old_doctor_fee: +original?.old_doctor_amt || 0,
                        old_hospital_fee: +original?.old_hospital_amt || 0,
                        new_doctor_fee: +original?.new_doctor_amt || 0,
                        new_hospital_fee: +original?.new_hospital_amt || 0,
                        start_time: original?.start_time || null,
                        end_time: original?.end_time || null,
                        total_amount: +original?.total_with_discount || 0,
                        sub_total_amount: +original?.sub_total_amount || 0,
                        discount_amount: +original?.concession_amt || 0,
                        discount_percentage: +original?.concession_percent || 0,
                        concession_comments: original?.concession_comments || '',
                        service_rate_per_unit: +original?.rate_per_unit || 0,
                        service_old_unit_count: original?.unit_type === 'Hrs' ? original?.old_time_taken : null,

                        taxable_amount: +original?.total_with_discount,
                        gst_amount: +original?.gst_amount || 0,
                        cgst_amount: +original?.cgst_amount || 0,
                        sgst_amount: +original?.sgst_amount || 0,
                        igst_amount: +original?.gst_amount || 0,
                        net_amount: +updated?.aft_net_amount || 0,
                        received_amount: billType === 'Draft' ? 0 : (+updated?.aft_receive_amt || 0),
                        bill_type: billType === 'Requested' ? 'Requested' : 'Credit',
                        is_sharable: original?.is_sharable || false,
                        is_consultation: original?.is_consultation || false,

                        cash_amount: updated?.cash || 0,
                        card_amount: updated?.card || 0,
                        upi_amount: updated?.upi || 0,
                        bank_amount: updated?.bank || 0,
                        cheque_amount: updated?.cheque || 0,

                        bill_discount_amount: +updated?.aft_discount || 0,
                        bill_total_amount: +updated?.aft_total_amount || 0,
                        bill_doctor_share: +updated?.aft_doctor_share || 0,
                        bill_hospital_share: +updated?.aft_hospital_share || 0,
                        bill_doctor_percent: +updated?.aft_doctor_percent || 0,
                        bill_hospital_percent: +updated?.aft_hospital_percent || 0,
                        bill_total_with_gst: loginInfo?.is_gst_enabled ? +updated?.aft_total_with_gst : 0,
                        payment_status: updated?.aft_payment_status,
                        service_code: original?.service_code,
                        service_head_code: original?.service_head_code,
                        service_head_name: original?.service_head_name,
                        service_name: original?.service_name,
                        // op_order_number: original?.op_order_number || '',
                        package_detail_id: original?.line_item_type === 'Assorted' ? null : original?.package_detail_id ?? null,
                        package_name: original?.package_name,
                        order_line_status: (billType === 'Draft' || billType === 'Requested') ? 'Draft' :
                            (loginInfo?.module_name === MODULE_NAME.LABORATORY_LOW || loginInfo?.module_name === MODULE_NAME.RADIOLOGY_LOW || loginInfo?.module_name === 'Investigation' || loginInfo?.module_name === MODULE_NAME.DOCTOR) ? 'Accepted' :
                                loginInfo?.module_name === 'front_office' && (original?.module_type?.toLowerCase() === 'op' || original?.module_type?.toLowerCase() === 'ip_op' || original?.drug_config_id || original?.drug_ms_id) ? 'Accepted' : 'Billed',
                        package_id: original?.package_id ?? null,
                        assorted_package_id: original?.line_item_type === 'Assorted' ? original?.assorted_package_id ?? null : null,
                        line_item_type: original?.line_item_type ?? 'Individual',
                        billing_display: original?.billing_display ?? '',
                        assorted_package_name: original?.assorted_package_name ?? '',
                        assorted_package_head_id: original?.assorted_package_head_id ?? null,
                        assorted_package_items_id: original?.assorted_package_items_id ?? null,
                        order_line_ids: original?.order_line_ids ?? [],
                        drug_config_id: original?.drug_config_id ?? null,
                        drug_ms_id: original?.drug_ms_id ?? null,
                        pharmacy_id: original?.pharmacy_id ?? null,
                        sub_location_id: original?.sub_location_id ?? null,
                        module_type: original?.module_type ?? '',
                        is_membership_discount_applied: original?.membership_discount_percentage ?? false,
                    })
                }

                let payment = []
                if (billing.isCash) {
                    payment.push(1)
                }
                if (billing.isCard) {
                    payment.push(2)
                }
                if (billing.isUPI) {
                    payment.push(3)
                }
                if (billing.isCheque) {
                    payment.push(4)
                }
                if (billing.isBank) {
                    payment.push(5)
                }
                let startDate = new Date()
                let date = DateTime.fromJSDate(startDate).toFormat('yyyy-MM-dd')
                let Aptime = DateTime.fromJSDate(startDate).toLocaleString(DateTime.TIME_24_SIMPLE);
                const invoice_date = date ? `${DateTime.fromJSDate(startDate).toFormat("yyyy-MM-dd")} ${Aptime}:00` : ""
                let appointment_id = appointId ? appointId : appontimentId ? appontimentId : props?.patientData?.appointment_id ? props?.patientData?.appointment_id : null
                let doctorId = props?.doctorDetails?.selectedDoctor?.doctor_id ? props?.doctorDetails?.selectedDoctor?.doctor_id  : props?.patientData?.doctor_id ?? null
                let patientId = billing.patientData?.patient_id
                let data = {
                    appointment_id: appointment_id,
                    invoice_date: invoice_date,
                    bill_type: billType === 'Requested' ? 'Requested' : 'Credit',
                    patient_id: patientId,
                    doctor_id: doctorId === 'all' ? null : doctorId,
                    clinic_id: JSON.parse(localGetItem('SelectedDoctorClinicId')) || JSON.parse(localGetItem('clinicId')),
                    credit_type: billType === "Regular" ? ((billing.patientCreditType === 'patientcredit' && JSON.parse(localGetItem('allow_patient_credit_bills'))) ? "Patient credit" : (billing.patientCreditType === 'corporatecredit' ? "Corporate credit" : billing.patientCreditType === 'insurancecredit' ? 'Insurance credit' : "")) : billing.patientCreditType === 'patientcredit' ? ((JSON.parse(localGetItem('allow_patient_credit_bills'))) ? 'Patient credit' : '') : billing.patientCreditType === 'insurancecredit' ? 'Insurance credit' : billing.patientCreditType === 'corporatecredit' ? 'Corporate credit' : "",
                    sub_total_amount: +billing.overall_data.sub_total || +billing.overall_data.sub_total_amount,
                    actual_sub_amount: +billing.overall_data.actual_sub_total_amount || 0,
                    discount_amount: +billing.overallDiscount.discount_amount,
                    total_amount: +((+billing.overall_data.taxable_amount) - (+billing.overallDiscount.discount_amount)),
                    taxable_amount: +((+billing.overall_data.taxable_amount) - (+billing.overallDiscount.discount_amount)),
                    gst_amount: loginInfo?.is_gst_enabled ? +billing.overall_data.gst_amount : 0,
                    cgst_amount: loginInfo?.is_gst_enabled ? +billing.overall_data.cgst_amount : 0,
                    sgst_amount: loginInfo?.is_gst_enabled ? +billing.overall_data.sgst_amount : 0,
                    igst_amount: loginInfo?.is_gst_enabled ? +billing.overall_data.gst_amount : 0,
                    round_off: +CommonValidation.formatAmount(billing.overall_data.round_off),
                    net_amount: +billing.overall_data.payable_amt,
                    received_amount: billType === 'Draft' ? 0 : +payamt,
                    order_status: billType === 'Credit' ? 'Billed' : null,
                    billed_from: requestState?.requested_from !== '' ? requestState?.requested_from : loginInfo?.module_name === MODULE_NAME.FRONT_OFFICE ? 'FO' : loginInfo?.module_name === MODULE_NAME.LABORATORY_LOW ? 'LAB' :
                        loginInfo?.module_name === MODULE_NAME.RADIOLOGY_LOW ? 'RADIOLOGY' : loginInfo?.module_name === 'Investigation' ? GetInvestigationName() : 'CANTEEN',
                    ordered_from: loginInfo?.module_name === MODULE_NAME.FRONT_OFFICE ? 'FO' : loginInfo?.module_name === MODULE_NAME.LABORATORY_LOW ? 'LAB' :
                        loginInfo?.module_name === MODULE_NAME.RADIOLOGY_LOW ? 'RADIOLOGY' : loginInfo?.module_name === 'Investigation' ? GetInvestigationName() : 'CANTEEN',
                    payment_status: status,
                    paid_in: status === "not paid" ? null : (loginInfo?.module_name === 'front_office' ? 'FRONT OFFICE' : loginInfo?.module_name === MODULE_NAME.LABORATORY_LOW ? 'LAB' :
                        loginInfo?.module_name === MODULE_NAME.RADIOLOGY_LOW ? 'RADIOLOGY' : loginInfo?.module_name === 'Investigation' ? GetInvestigationName() : 'CANTEEN'),
                    receipt_for: +payamt > 0 ? 'Bill' : '',
                    cash_amount: +billing.cash_amt,
                    card_amount: +billing.card_amt,
                    upi_amount: +billing.upi_amt,
                    bank_amount: +billing.bank_amt,
                    cheque_amount: +billing.cheque_amt,
                    card_ref_no: +billing.card_no,
                    upi_ref_no: +billing.upi_no,
                    bank_ref_no: +billing.bank_no,
                    cheque_ref_no: +billing.cheque_no,
                    overall_concession_comment: billing.concessionReason,
                    overall_discount_percentage: +billing.overallDiscount.discount_percentage,
                    bill_item_details: finalBillingListData,
                    bill_id: billing?.bill_id,
                    employer_id: billing.patientCreditType === 'corporatecredit' ? billing?.selectedCorporate?.id ?? billing?.selectedCorportateId : null,
                    employee_id: billing.patientCreditType === 'corporatecredit' ? billing?.employeeNo : '',
                    policy_number: billing.patientCreditType === 'insurancecredit' ? billing?.policyno : '',
                    insurance_company_name: billing.patientCreditType === 'insurancecredit' ? billing?.selectedInsurance?.insurance_company_name ?? billing?.selectedInsurance : null,
                    is_includes_lab_bill: billing?.billingList?.some((list) => list?.module_type === "LAB"),
                    is_includes_radiology_bill: billing?.billingList?.some((list) => list?.module_type === "RADIOLOGY"),
                    is_includes_canteen_bill: billing?.billingList?.some((list) => list?.module_type === "CANTEEN"),
                    is_includes_investigation_bill: billing?.billingList?.some((list) => list?.module_type === GetInvestigationName()),
                    cancelled_line_ids: getCachevalue('BillType') === 'Modify' ? billing.cancelled_ids : [],
                    payment_mode: payment,
                    actual_discount_amount: actualDiscountTotal + (+billing.overallDiscount.discount_amount),
                    remarks: requestState?.remarks,
                    approver_id: requestState?.selectedApproverId,
                    pending_list_id: requestState?.pending_list_id,
                    requested_type: billType,
                    rejected_remarks: billType === 'Rejected' ? comments : "",
                }
                if (requestState?.selectedApproverId === null) {
                    setRequestState((prev) => ({ ...prev, requestLoad: false }))
                    setIsLoader(false)
                    errorMessage('kindly Select The Approver')
                } else {
                    RestAPIService.create(data, Serviceurls.NEW_BILLING_BILL_REQUEST)
                        .then((response) => {
                            if (response?.data?.status === 'success') {
                                successMessage(response?.data?.message)
                                clearAllData(true)
                                setRequestState((prev) => ({
                                    ...prev,
                                    requestLoad: false, fromApprover: false,
                                    fromPendingList: false, selectedApprover: null, selectedApproverId: null, modifyApprover: false,
                                    pending_list_id: null, request_from: '', fromBillConvert: false, rejected_remarks: "", hasConcession: '', pendingCancel: false
                                }))
                                if (props?.fromQuickBill) {
                                    props.clearPatientData(true)
                                }
                                setIsLoader(false)
                                if (getCachevalue('FromOtherScreen') === 'true') {
                                    clearCachevalue('isForCancelBill')
                                    clearCachevalue('BillType')
                                    clearCachevalue('FromOtherScreen')
                                    let path = getCachevalue('path')
                                    history?.push({ pathname: path, state: {} })
                                    setTimeout(() => clearCachevalue('path'), 50)
                                }
                            }
                        }).catch(e => {
                            setIsLoader(false)
                            setRequestState((prev) => ({ ...prev, requestLoad: false }))
                            if (e?.response?.data?.message) {
                                errorMessage(e.response.data.message);
                            } else {
                                errorMessage(e.message);
                            }
                        })
                }
            } else {
                setIsLoader(false)
                setRequestState((prev) => ({ ...prev, requestLoad: false }))
                errorMessage(check)
            }
        } catch (error) {
            setIsLoader(false)
            setRequestState((prev) => ({ ...prev, requestLoad: false }))
            errorMessage(error.message)
        }
    }

    const deleteServiceData = () => {
        try {
            let data = {
                order_id: billing.deleted_service?.bill_type !== 'Draft' ? billing.deleted_service?.op_order_line_id : null,
                draft_id: billing.deleted_service?.bill_type === 'Draft' ? billing.deleted_service?.draft_id : null,
                cancel_reason: billing.cancel_reason
            }
            RestAPIService.delete(Serviceurls.NEW_BILLING_OP_POST, data)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        let billingList = [...billing.billingList]
                        billingList?.splice(billing.deletedIndex, 1)
                        setBilling((prev) => ({
                            ...prev,
                            billingList: billingList,
                            deletedIndex: null,
                            deleted_service: null,
                            cancel_reason: '',
                            openDeletePopup: false,
                            overallDiscount: {
                                discount_amount: '', discount_percentage: '', discount_percentage_w_r: ''
                            }
                        }))
                        successMessage(response?.data?.message)
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error?.response?.data?.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const deleteApproverListData = () => {
        try {
            let data = {
                id: requestState.pending_list_id
            }
            RestAPIService.delete(Serviceurls.NEW_BILLING_PENDING_LIST, data)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        successMessage(response?.data?.message)
                        setRequestState((prev) => ({ ...prev, pending_list_id: null }))
                        clearAllData()
                    }
                }).catch((error) => {
                    if (error?.response?.data?.message) {
                        errorMessage(error?.response?.data?.message)
                    } else {
                        errorMessage(error?.message)
                    }
                })
        } catch (error) {
            errorMessage(error.message)
        }
    }

        const getFutureAppointmentData = () => {
        try{
            let patient = props?.patientData?.patient_id || billing?.patientData?.patient_id
            let clinic = loginInfo?.clinic_id
            RestAPIService.getAll(Serviceurls.FO_FUTURE_APPOINTMENTS + `?patient_id=${patient}&clinic_id=${clinic}`)
            .then((response) => {
                if(response?.data?.status === 'success'){
                    setFutureAppointments(response?.data?.data || [])
                }
            }).catch((error) => {
                if(error?.response?.data?.message){
                    errorMessage(error?.response?.data?.message)
                } else {
                    errorMessage(error?.message)
                }
            })
        }catch(error){
            errorMessage(error.message)
        }
    }

    const getValidUptoData = () => {
        
        let patient = props?.patientData?.patient_id || billing?.patientData?.patient_id
        let specialization_id = props?.doctorDetails?.selectedSpecName?.id || null
        let doctor_id = props?.doctorDetails?.selectedDoctor?.doctor_id || null
        let AptDateTime = new Date(props?.doctorDetails?.appointmentDateTime);
        let AptDate = DateTime.fromJSDate(AptDateTime).toFormat('yyyy-MM-dd');
        try{
            RestAPIService.getAll(Serviceurls.FO_SERVICE_VALID_UPTO + `?patient_id=${patient}&specialization_id=${specialization_id}&doctor_id=${doctor_id}&appointment_date=${AptDate}`)
            .then((response)=>{
                if(response?.data?.status === 'success'){
                    setHasValiuptoDate(response?.data?.data || {})
                }
            }).catch((error)=>{
                if(error?.response?.data?.message){
                    errorMessage(error?.response?.data?.message)
                } else {
                    errorMessage(error?.message)
                }
            })
        }catch(error){
            errorMessage(error.message)
        }
    }

    // API INTEGRATION ENDS =====>

    const onSelectServiceHandler = (value) => {
        try {
            setBilling((prev) => {
                let serviceData = {}
                if (value !== null) {
                    if ('emergency' in value) {
                        serviceData = value?.emergency
                    } else if ('holiday' in value) {
                        serviceData = value?.holiday
                    } else {
                        serviceData = value
                    }
                }

                const sharedFields = {
                    rate_per_unit: serviceData.service_charge,
                    unit: serviceData.unit,
                    unit_type: serviceData.unit_type,
                    total_amt: serviceData.service_charge,
                    total_with_discount: serviceData.service_charge,
                    doctor_amt: serviceData.doctor_share_amount,
                    doctor_percent: serviceData.doctor_share_percent,
                    old_doctor_amt: serviceData.doctor_share_amount,
                    new_doctor_amt: serviceData.doctor_share_amount,
                    hospital_amt: serviceData.hospital_share_amount,
                    hospital_percent: serviceData.hospital_share_percent,
                    old_hospital_amt: serviceData.hospital_share_amount,
                    new_hospital_amt: serviceData.hospital_share_amount,
                    interval_time: serviceData.interval_time,
                    interval_amount: serviceData.interval_amount,
                    service_name: serviceData.service_name,
                    service_head_name: serviceData.service_head,
                    service_code: serviceData.service_code,
                    service_head_code: serviceData.service_head_code,
                    edit_unit: serviceData.edit_unit,
                    edit_amount: serviceData.edit_amount,
                    edit_discount: serviceData.edit_discount,
                    doctor_name: serviceData.doctor_name,
                    doctor_id: serviceData.doctor_id,
                    start_time: serviceData.start_time,
                    end_time: serviceData.end_time,
                    gst_percent: serviceData.gst_percent || 0,
                    hours: serviceData.unit_type === 'Hrs' ? serviceData.unit?.split(":")[0] : '',
                    minutes: serviceData.unit_type === 'Hrs' ? serviceData.unit?.split(":")[1] : '',
                    service_details_id: serviceData?.service_details_id,
                    doctor_id: serviceData?.doctor_id,
                    review_days: serviceData?.review_days,
                    review_count: serviceData?.review_count,
                    charge_id: serviceData?.charge_id,
                    doctor_name: serviceData?.doctor_name,
                    module_type: serviceData?.module_type,
                    doctor_percent_w_r: +(serviceData?.doctor_share_percent?.toFixed(2)),
                    hospital_percent_w_r: +(serviceData?.hospital_share_percent?.toFixed(2)),
                    start_date: new Date(),
                    end_date: null,
                    is_hospital: serviceData?.is_hospital,
                    service_head_id: serviceData?.service_head_id,
                    op_order_number: serviceData?.op_order_number,
                    old_time_taken: serviceData.unit_type === 'Hrs' ? serviceData?.unit : null,
                    doc_discount_amt: '',
                    doc_discount_percent: '',
                    doc_discount_percent_w_r: '',
                    hos_discount_amt: '',
                    hos_discount_percent: '',
                    hos_discount_percent_w_r: '',
                    is_sharable: serviceData?.is_sharable,
                    is_consultation: serviceData?.is_consultation
                };

                if (serviceData?.membership_discount_percentage) {
                    sharedFields.membership_discount_percentage = true
                    if (serviceData?.is_sharable) {
                        const baseTotalAmt = serviceData.service_charge || 0;
                        const updatedOldDoc = CommonValidation.getDiscountAmountWithRound(sharedFields.doctor_percent, baseTotalAmt)
                        const updatedOldHos = CommonValidation.getDiscountAmountWithRound(sharedFields.hospital_percent, baseTotalAmt)
                        const disDoc = CommonValidation.getDiscountAmountWithRound(0, updatedOldDoc)
                        const disHos = CommonValidation.getDiscountAmountWithRound(serviceData?.membership_discount_percentage, updatedOldHos)
                        const conTlt = (+disDoc) + (+disHos)

                        sharedFields.total_amt = baseTotalAmt
                        sharedFields.total_with_discount = (baseTotalAmt - disHos)
                        sharedFields.old_doctor_amt = updatedOldDoc
                        sharedFields.old_hospital_amt = updatedOldHos
                        sharedFields.new_doctor_amt = updatedOldDoc - disDoc
                        sharedFields.new_hospital_amt = updatedOldHos - disHos
                        sharedFields.doctor_amt = updatedOldDoc - disDoc
                        sharedFields.hospital_amt = updatedOldHos - disHos
                        sharedFields.doc_discount_amt = disDoc
                        sharedFields.hos_discount_amt = disHos
                        sharedFields.hos_discount_percent = serviceData?.membership_discount_percentage
                        sharedFields.hos_discount_percent_w_r = serviceData?.membership_discount_percentage
                        sharedFields.concession_amt = CommonValidation.formatAmount(conTlt)
                        sharedFields.concession_percent = serviceData?.membership_discount_percentage
                        sharedFields.concession_percent_w_r = serviceData?.membership_discount_percentage
                        sharedFields.concession_comments = "Membership concession"
                    } else {
                        sharedFields.concession_percent = serviceData?.membership_discount_percentage
                        sharedFields.concession_percent_w_r = serviceData?.membership_discount_percentage
                        sharedFields.total_with_discount = (sharedFields.total_amt - CommonValidation.getDiscountAmountWithRound(serviceData?.membership_discount_percentage, sharedFields.total_amt))
                        sharedFields.concession_amt = +CommonValidation.getDiscountAmountWithRound(serviceData?.membership_discount_percentage, sharedFields.total_amt)
                    }
                }

                return {
                    ...prev,
                    selected_service: value !== null ? serviceData : null,
                    service_data: {
                        ...prev.service_data,
                        ...sharedFields,
                    },
                };
            });

        } catch (error) {
            errorMessage(error.message)
        }
    }

    const onClickUnitHandler = useCallback((type) => {
        try {
            setBilling((prev) => {
                const updatedServiceData = { ...prev.service_data };
                switch (type) {
                    case 'increase':
                        updatedServiceData.unit++;
                        break;
                    case 'decrease':
                        updatedServiceData.unit = Math.max(0, updatedServiceData.unit - 1); // Prevent negative units
                        break;
                }
                if (updatedServiceData.doctor_amt || updatedServiceData.hospital_amt) {
                    const baseTotalAmt = updatedServiceData.unit * updatedServiceData.rate_per_unit;
                    const updatedOldDoc = CommonValidation.getDiscountAmountWithRound(updatedServiceData.doctor_percent, baseTotalAmt)
                    const updatedOldHos = CommonValidation.getDiscountAmountWithRound(updatedServiceData.hospital_percent, baseTotalAmt)
                    const disDoc = CommonValidation.getDiscountAmountWithRound(updatedServiceData.doc_discount_percent, updatedOldDoc)
                    const disHos = CommonValidation.getDiscountAmountWithRound(updatedServiceData.hos_discount_percent, updatedOldHos)
                    const conTlt = (+disDoc) + (+disHos)

                    updatedServiceData.total_amt = baseTotalAmt
                    updatedServiceData.old_doctor_amt = updatedOldDoc
                    updatedServiceData.old_hospital_amt = updatedOldHos
                    updatedServiceData.new_doctor_amt = updatedOldDoc - disDoc
                    updatedServiceData.new_hospital_amt = updatedOldHos - disHos
                    updatedServiceData.doctor_amt = updatedOldDoc - disDoc
                    updatedServiceData.hospital_amt = updatedOldHos - disHos
                    updatedServiceData.doc_discount_amt = disDoc
                    updatedServiceData.hos_discount_amt = disHos
                    updatedServiceData.concession_amt = CommonValidation.formatAmount(conTlt)
                    updatedServiceData.concession_percent = CommonValidation.getDiscountPercentage(conTlt, baseTotalAmt)
                    updatedServiceData.concession_percent_w_r = CommonValidation.getDiscountPercentageWithRound(conTlt, baseTotalAmt)
                } else {
                    let total = updatedServiceData.unit * updatedServiceData.rate_per_unit
                    updatedServiceData.total_amt = total;
                    updatedServiceData.concession_amt = CommonValidation.getDiscountAmountWithRound(updatedServiceData.concession_percent, total)
                }

                return { ...prev, service_data: updatedServiceData };
            })
        } catch (error) {
            errorMessage(error.message)
        }
    }, [billing.service_data])

    const withOutShareHandler = useCallback((e, key) => {
        try {
            const value = e.target.value
            setBilling((prev) => {
                const update = { ...prev.service_data };
                switch (key) {
                    case 'rate_per_unit':
                        let Hours = (update?.hours === "" ? "00" : (update?.hours)?.toString()?.length < 2 ? ("0" + update?.hours) : update?.hours) + ":" + (update?.minutes === "" ? "00" : (update?.minutes)?.toString()?.length < 2 ? ("0" + update?.minutes) : update?.minutes) + ":" + "00"
                        let hourTotal = update.unit_type === 'Hrs' ? CalculateHourAmount(value, Hours, update.old_time_taken, update?.interval_time, update?.interval_amount) : 0
                        const newRatePerUnit = update.unit_type === 'Hrs' ? value : (value * update.unit)

                        update.rate_per_unit = value;
                        update.total_amt = update.unit_type === 'Hrs' ? hourTotal : (value * update.unit);
                        update.concession_amt = newRatePerUnit ? +CommonValidation.getDiscountAmountWithRound(update.concession_percent, newRatePerUnit) : ''
                        update.concession_percent = value ? update.concession_percent : ''
                        update.concession_percent_w_r = value ? update.concession_percent_w_r : ''
                        break;
                    case 'concession_discount_amt':
                        if (CommonValidation.DecimalNumber(value) && value > 0 && value <= update.total_amt || value === '') {
                            update.concession_amt = value
                            update.concession_percent = value ? +CommonValidation.getDiscountPercentage(value, update.total_amt) : ''
                            update.concession_percent_w_r = value ? +CommonValidation.getDiscountPercentageWithRound(value, update.total_amt) : ''
                        }
                        break;
                    case 'concession_discount_percent':
                        if (CommonValidation.DecimalNumber(value) && value > 0 && value <= 100 || value === '') {
                            update.concession_percent = value
                            update.concession_percent_w_r = value
                            update.concession_amt = +CommonValidation.getDiscountAmountWithRound(value, update.total_amt)
                        }
                        break;
                    default: break;
                }
                return { ...prev, service_data: update }
            })
        } catch (error) {
            errorMessage(error.message)
        }
    }, [billing.service_data])

    const onEditHandler = (item, index = null, subIndex = null, mainIndex = null) => {
        try {
            setBilling((prev) => {
                prev.selected_service = item
                prev.selected_bill_doc = item?.doctor_name
                prev.service_data = item
                prev.isEdit = true
                prev.selectedIndex = index
                prev.selectedSubIndex = subIndex ?? null
                prev.selectedServiceIndex = mainIndex ?? null
                return { ...prev }
            })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const onClearServiceData = () => {
        try {
            setBilling((prev) => ({
                ...prev,
                selected_bill_doc: billing.selected_bill_doc,
                selected_service: null,
                service_data: {
                    rate_per_unit: '', unit: 1, unit_type: 'Nos', total_amt: '', total_with_discount: '',
                    doctor_amt: '', doctor_percent: '', old_doctor_amt: '', new_doctor_amt: '',
                    hospital_amt: '', hospital_percent: '', old_hospital_amt: '', new_hospital_amt: '',
                    interval_time: '', interval_amount: '', service_name: '', service_head_name: '',
                    service_code: '', service_head_code: '', edit_unit: '', edit_amount: '',
                    edit_discount: '', doctor_name: '', doctor_id: '', start_time: '',
                    end_time: '', doc_discount_amt: '', doc_discount_percent: '',
                    hos_discount_amt: '', hos_discount_percent: '', concession_amt: '',
                    concession_percent: '', gst_percent: 0, hours: '', minutes: '',
                    concession_comments: '', service_details_id: '', doctor_id: '',
                    review_days: '', review_count: '', charge_id: '',
                    gst_amount: '', sgst_amount: '', cgst_amount: '', igst_amount: '',
                    taxable_amount: '', sub_total_amount: '', round_off: '',
                    received_amount: '', net_amount: '', concession_percent_w_r: '',
                    doc_discount_percent_w_r: '', hos_discount_percent_w_r: '',
                    doctor_percent_w_r: '', hospital_percent_w_r: '',
                    module_type: '', start_date: new Date(), end_date: null, is_hospital: false,
                    service_head_id: null, op_order_number: '', id: null
                },
                isEdit: false,
                selectedIndex: null,
                selected_bill_doc_id: billing.selected_bill_doc_id ?? billing?.selected_bill_doc?.doctor_id,
                selectedServiceIndex: null,
                selectedSubIndex: null
            }))
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const clearAllData = (fromClear = false) => {
        try {
            setselectedRefDoc(null)
            setInputRefDoc('')
            setOpenPopup(null)
            setPopupValues({})
            setDialogOpen(false)
            if (props?.patientData?.is_memberships) {
                setHasMembershipCard(true)
            } else {
                setHasMembershipCard(false)
            }
            setSelectedRadio('input')
            if (getCachevalue('FromCreate') !== 'true') {
                setBilling((prev) => ({
                    ...prev,
                    patientData: {},
                    serviceSugg: [],
                }))
            }
            setBilling((prev) => ({
                ...prev,
                selected_bill_doc: (getCachevalue('FromCreate') === 'true' && props?.patientData?.doctor_name && !fromClear) ? props?.patientData?.doctor_name : null,
                selected_bill_doc_id: (getCachevalue('FromCreate') === 'true' && props?.patientData?.doctor_id && !fromClear) ? props?.patientData?.doctor_id : null,
                selected_service: null,
                selected_temp_pack: null,
                selectedIndex: null,
                isEdit: null,
                isCash: false,
                isCard: false,
                isUPI: false,
                isBank: false,
                isCheque: false,
                cash_amt: '',
                card_amt: '',
                bank_amt: '',
                upi_amt: '',
                cheque_amt: '',
                card_no: '',
                upi_no: '',
                bank_no: '',
                cheque_no: '',
                billingList: [],
                bill_id: null,
                order_id: null,
                service_data: {
                    rate_per_unit: '', unit: 1, unit_type: 'Nos', total_amt: '', total_with_discount: '',
                    doctor_amt: '', doctor_percent: '', old_doctor_amt: '', new_doctor_amt: '',
                    hospital_amt: '', hospital_percent: '', old_hospital_amt: '', new_hospital_amt: '',
                    interval_time: '', interval_amount: '', service_name: '', service_head_name: '',
                    service_code: '', service_head_code: '', edit_unit: false, edit_amount: false,
                    edit_discount: false, doctor_name: '', start_time: '',
                    end_time: '', doc_discount_amt: '', doc_discount_percent: '',
                    hos_discount_amt: '', hos_discount_percent: '', concession_amt: '',
                    concession_percent: '', gst_percent: 0, hours: '', minutes: '',
                    concession_comments: '', service_details_id: '',
                    review_days: '', review_count: '', charge_id: '',
                    gst_amount: '', sgst_amount: '', cgst_amount: '', igst_amount: '',
                    taxable_amount: '', sub_total_amount: '', round_off: '',
                    received_amount: '', net_amount: '', concession_percent_w_r: '',
                    doc_discount_percent_w_r: '', hos_discount_percent_w_r: '',
                    doctor_percent_w_r: '', hospital_percent_w_r: '',
                    module_type: '', start_date: new Date(), end_date: null, is_hospital: false,
                    service_head_id: null, doctor_id: '', op_order_number: '',
                    id: null
                },
                overall_data: {
                    sub_total: '',
                    round_off: '', payable_amt: '', taxable_amount: '',
                    gst_amount: '', sgst_amount: '', cgst_amount: '', net_amount: '',
                    concession_applicable: '', actual_sub_total_amount: ''
                },
                overallDiscount: {
                    discount_amount: '',
                    discount_percentage: '',
                    discount_percentage_w_r: ''
                },
                concessionReason: '',
                reasonPopup: false,
                received_amount: 0,
                openCancelPopup: false,
                // selectedCorportateId: null,
                selectedCorporateService: null,
                tempBillData: null, postLoad: false, cancelled_ids: []
            }))
            if (!(getCachevalue('FromCreate') === 'true' && props?.patientData?.doctor_name && !fromClear)) {
                setTimeout(() => {
                    setBilling((prev) => ({
                        ...prev,
                        selected_bill_doc: null,
                        selected_bill_doc_id: null,
                    }))
                }, 1000)
            }
            setHasDuplicate(false)
            settempDup([])
            setHasValiuptoDate(false)
            setFutureAppointments(false)

            setOverallDiscount((prev) => ({ ...prev, discount_amount: '', discount_percentage: '', discount_comments: '' }))
            setRequestState((prev) => ({
                ...prev,
                selectedApprover: null,
                remarks: '',
                hasConcession: false,
                fromApprover: false,
                fromPendingList: false,
                selectedApproverId: null,
                modifyApprover: false,
                pending_list_id: null,
                request_from: '',
                RequestComments: ""
            }))
            if (props.fromQuickBill) {
                if (!fromClear) {
                    if (loginInfo?.module_name === "Investigation") {
                        history?.push({ pathname: `/${GetInvestigationName()}Home` })
                    } else if (loginInfo?.module_name === MODULE_NAME.RADIOLOGY_LOW) {
                        history?.push({ pathname: '/RadiologyHome' })
                    } else if (loginInfo?.module_name === MODULE_NAME.LABORATORY_LOW) {
                        history.push({ pathname: "/MainHome", state: { selectedScreen: "Status", selectedTabID: 0 } })
                    }
                    //  else if (loginInfo?.module_name === MODULE_NAME.FRONT_OFFICE) {
                    //     history?.push({ pathname: '/OPHome' })
                    // }
                } else {
                    setHasMembershipCard(false)
                    props.clearPatientData(true)
                }
            } else {
                // setHasMembershipCard(false)
                props.clearPatientData(true)
            }
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const onAddHandler = () => {
        try {
            let discountTotal = (+billing.service_data.total_amt) - (+billing.service_data.concession_amt)
            let incGst = loginInfo?.is_gst_enabled ? CommonValidation.calculateTotalWithGST(discountTotal, billing.service_data.gst_percent) : 0
            let tltGstdiff = loginInfo?.is_gst_enabled ? incGst - discountTotal : 0
            let sgstCgst = loginInfo?.is_gst_enabled ? +tltGstdiff / 2 : 0
            let service_list = {
                ...billing.service_data,
                total_with_discount: discountTotal,
                service_with_gst_total_amt: +CommonValidation.formatAmount(incGst),
                gst_amount: +CommonValidation.formatAmount(tltGstdiff),
                sgst_amount: +CommonValidation.formatAmount(sgstCgst),
                cgst_amount: +CommonValidation.formatAmount(sgstCgst),
                igst_amount: +CommonValidation.formatAmount(tltGstdiff),
                taxable_amount: discountTotal,
                sub_total_amount: billing.service_data.total_amt,
                concession_applicable: (billing?.service_data?.edit_discount ) ? (billing?.service_data?.is_hospital ? billing?.service_data?.new_hospital_amt : discountTotal) : 0,
                module_type: billing.service_data.module_type,
                unit: billing.service_data?.unit,
                service_head_id: billing.service_data?.service_head_id,
                doctor_id: billing.selected_bill_doc?.doctor_id || billing.selected_bill_doc_id,
                doctor_name: billing.selected_bill_doc?.doctor_name || billing.selected_bill_doc,
                id: billing.service_data?.id ? billing?.service_data?.id : null,
                package_detail_id: billing.service_data?.package_detail_id ? billing?.service_data?.package_detail_id : null,
                package_name: billing?.service_data?.package_name ? billing?.service_data?.package_name : '',
                not_from_order: true
            }
            let checkData = checkDuplicate()
            if (checkData === null) {
                setBilling((prev) => {
                    const billingList = [...prev.billingList];
                    if (prev.isEdit) {
                        if (prev.selectedSubIndex !== null && prev.selectedIndex !== null && prev.selectedServiceIndex === null) {
                            billingList[prev.selectedIndex]['package_line'][prev.selectedSubIndex] = service_list
                        } else if (prev.selectedSubIndex !== null && prev.selectedServiceIndex !== null && prev.selectedIndex !== null) {
                            billingList[prev.selectedIndex]['package_line'][prev.selectedSubIndex]['service_data'][prev.selectedServiceIndex] = service_list
                        } else {
                            billingList[prev.selectedIndex] = service_list;
                        }
                    } else {
                        billingList.push(service_list);
                    }
                    return {
                        ...prev, billingList, dupBillList: JSON.stringify(billingList),
                        concessionReason: '', overallDiscount: {
                            discount_amount: '', discount_percentage: '', discount_percentage_w_r: ''
                        }
                    };
                });
            } else {
                errorMessage(checkData)
            }
            setTimeout(() => onClearServiceData(), 50)
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const checkDuplicate = () => {
        try {
            let message = null;
            let billingList = [...billing.billingList]
            billingList?.forEach((element, index) => {
                if (index !== billing.selectedIndex) {
                    if ((element?.service_head_code === billing.service_data?.service_head_code) &&
                        (element?.service_code === billing.service_data?.service_code) && (element?.service_details_id === billing.service_data?.service_details_id)) {
                        message = 'Service Already Exist'
                    }
                }
            })
            return message;
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const onPopupChangeHandler = useCallback((e, key) => {
        try {
            let value = e.target.value
            setPopupValues((prev) => {
                let updateState = {};
                switch (key) {
                    case 'doctor_amt':
                        if (CommonValidation.DecimalNumber(value) || value === '') {
                            let totalAmt = (+value) + (+popupValues.hospital_amt)
                            updateState.doctor_amt = value;
                            updateState.new_doctor_amt = value;
                            updateState.old_doctor_amt = value;
                            updateState.total_amt = totalAmt
                            updateState.rate_per_unit = popupValues?.unit_type === 'Hrs' ? ((+value) + (+popupValues.hospital_amt)) : totalAmt / popupValues.unit
                            updateState.doctor_percent = +CommonValidation.getDiscountPercentage(value, totalAmt) || 0
                            updateState.doctor_percent_w_r = +CommonValidation.getDiscountPercentageWithRound(value, totalAmt) || 0
                            updateState.hospital_percent = +CommonValidation.getDiscountPercentage(popupValues.hospital_amt, totalAmt) || 0
                            updateState.hospital_percent_w_r = +CommonValidation.getDiscountPercentageWithRound(popupValues.hospital_amt, totalAmt) || 0
                            updateState.doc_discount_amt = +CommonValidation.getDiscountAmountWithRound(popupValues.doc_discount_percent, value) || 0
                        }
                        break;
                    case 'hospital_amt':
                        if (CommonValidation.DecimalNumber(value) || value === '') {
                            let totalAmt = (+value) + (+popupValues.doctor_amt)
                            updateState.hospital_amt = value;
                            updateState.new_hospital_amt = value;
                            updateState.old_hospital_amt = value;
                            updateState.total_amt = totalAmt
                            updateState.rate_per_unit = popupValues?.unit_type === 'Hrs' ? ((+value) + (+popupValues.doctor_amt)) : totalAmt / popupValues.unit
                            updateState.doctor_percent = +CommonValidation.getDiscountPercentage(popupValues.doctor_amt, totalAmt) || 0
                            updateState.doctor_percent_w_r = +CommonValidation.getDiscountPercentageWithRound(popupValues.doctor_amt, totalAmt) || 0
                            updateState.hospital_percent = +CommonValidation.getDiscountPercentage(value, totalAmt) || 0
                            updateState.hospital_percent_w_r = +CommonValidation.getDiscountPercentageWithRound(value, totalAmt) || 0
                            updateState.hos_discount_amt = +CommonValidation.getDiscountAmountWithRound(popupValues.hos_discount_percent, value) || 0
                        }
                        break;
                    case 'doctor_discount_amt':
                        if (CommonValidation.DecimalNumber(value) && +value <= popupValues.old_doctor_amt || value === '') {
                            updateState.doc_discount_amt = value
                            updateState.new_doctor_amt = +CommonValidation.formatAmount(popupValues.old_doctor_amt - value) || 0;
                            updateState.doc_discount_percent = +CommonValidation.getDiscountPercentage(value, popupValues.old_doctor_amt) || 0
                            updateState.doc_discount_percent_w_r = +CommonValidation.getDiscountPercentageWithRound(value, popupValues.old_doctor_amt) || 0
                            updateState.doctor_amt = +CommonValidation.formatAmount(popupValues.old_doctor_amt - value) || 0;
                        }
                        break;
                    case 'hospital_discount_amt':
                        if (CommonValidation.DecimalNumber(value) && +value <= popupValues.old_hospital_amt || value === '') {
                            updateState.hos_discount_amt = value
                            updateState.new_hospital_amt = +CommonValidation.formatAmount(popupValues.old_hospital_amt - value) || 0;
                            updateState.hos_discount_percent = +CommonValidation.getDiscountPercentage(value, popupValues.old_hospital_amt) || 0
                            updateState.hos_discount_percent_w_r = +CommonValidation.getDiscountPercentageWithRound(value, popupValues.old_hospital_amt) || 0
                            updateState.hospital_amt = +CommonValidation.formatAmount(popupValues.old_hospital_amt - value) || 0;
                        }
                        break;
                    case 'doctor_discount_percent':
                        if (CommonValidation.DecimalNumber(value) && +value <= 100 || value === '') {
                            let disAmt = CommonValidation.getDiscountAmountWithRound(value, popupValues.old_doctor_amt) || 0
                            updateState.doc_discount_percent = value
                            updateState.doc_discount_percent_w_r = value
                            updateState.doc_discount_amt = +CommonValidation.getDiscountAmountWithRound(value, popupValues.old_doctor_amt) || 0
                            updateState.new_doctor_amt = +CommonValidation.formatAmount(popupValues.old_doctor_amt - disAmt) || 0;
                            updateState.doctor_amt = +CommonValidation.formatAmount(popupValues.old_doctor_amt - disAmt) || 0;
                        }
                        break;
                    case 'hospital_discount_percent':
                        if (CommonValidation.DecimalNumber(value) && +value <= 100 || value === '') {
                            let disAmt = CommonValidation.getDiscountAmount(value, popupValues.old_hospital_amt)
                            updateState.hos_discount_percent = value
                            updateState.hos_discount_percent_w_r = value
                            updateState.hos_discount_amt = +CommonValidation.getDiscountAmountWithRound(value, popupValues.old_hospital_amt) || 0
                            updateState.new_hospital_amt = +CommonValidation.formatAmount(popupValues.old_hospital_amt - disAmt) || 0;
                            updateState.hospital_amt = +CommonValidation.formatAmount(popupValues.old_hospital_amt - disAmt) || 0;
                        }
                        break;
                    case 'concession_comments':
                        if (value?.length <= 500 || value === '') {
                            updateState.concession_comments = value
                        }
                        break;
                    case 'hours':
                        if (CommonValidation.numberOnly(value) && value <= 23 || value === '') {
                            updateState.hours = value
                        }
                        break;
                    case 'minutes':
                        if (CommonValidation.numberOnly(value) && value <= 59 || value === '') {
                            updateState.minutes = value
                        }
                        break;
                }
                return { ...prev, ...updateState }
            })
        } catch (error) {
            errorMessage(error.message);
        }
    }, [popupValues])

    const popupTextBox = (key, values, multiline, row, labels, readOnly, width) => {
        try {
            return (
                <TextField
                    autoComplete='off'
                    size='small'
                    sx={{ width: width || '13dvw' }}
                    value={values}
                    onChange={(e) => onPopupChangeHandler(e, key)}
                    multiline={multiline}
                    rows={row}
                    label={labels}
                    InputProps={{ readOnly: readOnly, emed_tid: key }}
                />
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const convertTimeToDecimal = (time) => {
        try {
            let [hours, minutes] = time?.split(':')?.map(Number);
            return hours * 60 + minutes;
        } catch (error) {
            // errorMessage(error.message)
        }
    }

    const CalculateHourAmount = (ratePerHour, changedTime, fixedTime, minTime, minAmount) => {
        try {
            let fixedTimes = convertTimeToDecimal(fixedTime);
            let changedTimes = convertTimeToDecimal(changedTime);
            let minTimes = convertTimeToDecimal(minTime ? minTime : '00:00')
            let changeAndFixedTime = changedTimes - fixedTimes
            let time = changeAndFixedTime > 0 ? changeAndFixedTime : 0
            let timeCalculateTime = (time === 0 && minTimes === 0) ? 0 : Math.ceil(time / minTimes) === Infinity ? 0 : Math.ceil(time / minTimes)
            let totalCost = ((+ratePerHour) + (timeCalculateTime * (minAmount ? minAmount : 0)))

            return totalCost;
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const onSavePopupHandler = (type) => {
        try {
            setBilling((prev) => {
                let updates = { ...prev.service_data }
                switch (type) {
                    case 'rate':
                        let total = 0;
                        if (popupValues.unit_type === 'Nos') {
                            total = popupValues.rate_per_unit * popupValues.unit
                        } else {
                            let Hours = (popupValues?.hours === "" ? "00" : (popupValues?.hours)?.toString()?.length < 2 ? ("0" + popupValues?.hours) : popupValues?.hours) + ":" + (popupValues?.minutes === "" ? "00" : (popupValues?.minutes)?.toString()?.length < 2 ? ("0" + popupValues?.minutes) : popupValues?.minutes) + ":" + "00"
                            let hourTotal = CalculateHourAmount(popupValues.rate_per_unit, Hours, popupValues.old_time_taken, popupValues?.interval_time, popupValues?.interval_amount)
                            total = hourTotal
                        }
                        let concession = (+popupValues.doc_discount_amt) + (+popupValues.hos_discount_amt)

                        updates.doctor_amt = +CommonValidation.formatAmount(popupValues.doctor_amt)
                        updates.hospital_amt = +CommonValidation.formatAmount(popupValues.hospital_amt)
                        updates.doctor_percent = +popupValues.doctor_percent
                        updates.hospital_percent = +popupValues.hospital_percent
                        updates.old_doctor_amt = +CommonValidation.formatAmount(popupValues.doctor_amt)
                        updates.old_hospital_amt = +CommonValidation.formatAmount(popupValues.hospital_amt)
                        updates.new_doctor_amt = +CommonValidation.formatAmount(popupValues.doctor_amt)
                        updates.new_hospital_amt = +CommonValidation.formatAmount(popupValues.hospital_amt)
                        updates.total_amt = +CommonValidation.formatAmount(total)
                        updates.rate_per_unit = +CommonValidation.formatAmount(popupValues.rate_per_unit)
                        updates.doc_discount_amt = +CommonValidation.getDiscountAmountWithRound(popupValues.doc_discount_percent, popupValues.old_doctor_amt)
                        updates.hos_discount_amt = +CommonValidation.getDiscountAmountWithRound(popupValues.hos_discount_percent, popupValues.old_hospital_amt)
                        updates.concession_amt = +CommonValidation.formatAmount(concession)
                        updates.concession_percent = +CommonValidation.getDiscountPercentage(concession, total)
                        updates.concession_percent_w_r = +CommonValidation.getDiscountPercentageWithRound(concession, total)
                        updates.hos_discount_percent_w_r = +popupValues.hos_discount_percent_w_r
                        updates.doc_discount_percent_w_r = +popupValues.doc_discount_percent_w_r
                        updates.doctor_percent_w_r = +popupValues.doctor_percent_w_r
                        updates.hospital_percent_w_r = +popupValues.hospital_percent_w_r
                        break;
                    case 'concession':
                        let concessionAmt = (+popupValues.doc_discount_amt) + (+popupValues.hos_discount_amt)

                        updates.doctor_amt = +CommonValidation.formatAmount(popupValues.doctor_amt)
                        updates.hospital_amt = +CommonValidation.formatAmount(popupValues.hospital_amt)
                        updates.doctor_percent = +popupValues.doctor_percent
                        updates.hospital_percent = +popupValues.hospital_percent
                        updates.old_doctor_amt = +CommonValidation.formatAmount(popupValues.old_doctor_amt)
                        updates.old_hospital_amt = +CommonValidation.formatAmount(popupValues.old_hospital_amt)
                        updates.new_doctor_amt = +CommonValidation.formatAmount(popupValues.new_doctor_amt)
                        updates.new_hospital_amt = +CommonValidation.formatAmount(popupValues.new_hospital_amt)
                        updates.total_amt = +CommonValidation.formatAmount(popupValues.total_amt)
                        updates.concession_amt = +CommonValidation.formatAmount(concessionAmt)
                        updates.concession_percent = +CommonValidation.getDiscountPercentage(concessionAmt, popupValues.total_amt)
                        updates.doc_discount_amt = +CommonValidation.formatAmount(popupValues.doc_discount_amt)
                        updates.doc_discount_percent = +popupValues.doc_discount_percent
                        updates.hos_discount_amt = +CommonValidation.formatAmount(popupValues.hos_discount_amt)
                        updates.hos_discount_percent = +popupValues.hos_discount_percent
                        updates.concession_comments = popupValues.concession_comments
                        updates.hos_discount_percent_w_r = +popupValues.hos_discount_percent_w_r
                        updates.doc_discount_percent_w_r = +popupValues.doc_discount_percent_w_r
                        updates.concession_percent_w_r = +CommonValidation.getDiscountPercentageWithRound(concessionAmt, popupValues.total_amt)
                        updates.doctor_percent_w_r = +popupValues.doctor_percent_w_r
                        updates.hospital_percent_w_r = +popupValues.hospital_percent_w_r
                        break;
                    case 'time':
                        let Hours = (popupValues?.hours === "" ? "00" : (popupValues?.hours)?.toString()?.length < 2 ? ("0" + popupValues?.hours) : popupValues?.hours) + ":" + (popupValues?.minutes === "" ? "00" : (popupValues?.minutes)?.toString()?.length < 2 ? ("0" + popupValues?.minutes) : popupValues?.minutes) + ":" + "00"
                        let hourTotal = CalculateHourAmount(popupValues.rate_per_unit, Hours, popupValues.old_time_taken, popupValues?.interval_time, popupValues?.interval_amount)

                        updates.total_amt = hourTotal
                        updates.unit = Hours.split(":")[0] + ":" + Hours.split(":")[1]
                        updates.old_time_taken = popupValues.old_time_taken
                        updates.interval_amount = popupValues.interval_amount
                        updates.interval_time = popupValues.interval_time
                        updates.rate_per_unit = popupValues.rate_per_unit
                        updates.old_doctor_amt = +CommonValidation.getDiscountAmountWithRound(popupValues.doctor_percent, hourTotal)
                        updates.old_hospital_amt = +CommonValidation.getDiscountAmountWithRound(popupValues.hospital_percent, hourTotal)
                        let docDisc = CommonValidation.getDiscountAmountWithRound(popupValues.doc_discount_percent, updates.old_doctor_amt)
                        let hosDis = CommonValidation.getDiscountAmountWithRound(popupValues.hos_discount_percent, updates.old_hospital_amt)
                        updates.doc_discount_amt = +docDisc
                        updates.hos_discount_amt = +hosDis
                        updates.new_doctor_amt = (+CommonValidation.getDiscountAmountWithRound(popupValues.doctor_percent, hourTotal) || 0) - (+docDisc || 0)
                        updates.new_hospital_amt = (+CommonValidation.getDiscountAmountWithRound(popupValues.hospital_percent, hourTotal) || 0) - (+hosDis || 0)
                        updates.concession_amt = updates.doctor_amt && updates.hospital_amt ? (+docDisc) + (+hosDis) : CommonValidation.getDiscountAmountWithRound(popupValues.concession_percent, hourTotal)
                        break;
                }
                return { ...prev, service_data: updates }
            })
            setSelectedRadio('input')
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const onOpenPopupHandler = (type) => {
        setOpenPopup(type)
        setPopupValues((prev) => {
            let popupUpdates = {};
            switch (type) {
                case 'rate':
                    popupUpdates.doctor_amt = billing?.service_data?.old_doctor_amt
                    popupUpdates.doctor_percent = billing?.service_data?.doctor_percent
                    popupUpdates.doctor_percent_w_r = billing?.service_data?.doctor_percent_w_r
                    popupUpdates.hospital_amt = billing?.service_data?.old_hospital_amt
                    popupUpdates.hospital_percent = billing?.service_data?.hospital_percent
                    popupUpdates.hospital_percent_w_r = billing?.service_data?.hospital_percent_w_r
                    popupUpdates.total_amt = billing?.service_data?.total_amt
                    popupUpdates.rate_per_unit = billing.service_data.unit_type === 'Nos' ? billing?.service_data?.total_amt / billing?.service_data?.unit :
                        billing.service_data.rate_per_unit
                    popupUpdates.unit = billing?.service_data?.unit
                    break
                case 'concession':
                    popupUpdates.old_doctor_amt = billing?.service_data?.old_doctor_amt
                    popupUpdates.old_hospital_amt = billing?.service_data?.old_hospital_amt
                    popupUpdates.new_doctor_amt = billing?.service_data?.new_doctor_amt
                    popupUpdates.new_hospital_amt = billing?.service_data?.new_hospital_amt
                    popupUpdates.doctor_amt = billing?.service_data?.doctor_amt
                    popupUpdates.hospital_amt = billing?.service_data?.hospital_amt
                    popupUpdates.total_amt = billing?.service_data?.total_amt
                    popupUpdates.rate_per_unit = billing?.service_data?.rate_per_unit
                    break;
                case 'time':
                    let hours = billing?.service_data?.unit?.split(":")[0] || ''
                    let mins = billing?.service_data?.unit?.split(":")[1] || ''

                    popupUpdates.hours = hours
                    popupUpdates.minutes = mins
                    popupUpdates.start_date = billing?.service_data?.start_date
                    popupUpdates.end_date = billing?.service_data?.end_date;
                    popupUpdates.interval_amount = billing?.service_data?.interval_amount
                    popupUpdates.interval_time = billing?.service_data?.interval_time
                    popupUpdates.rate_per_unit = billing?.service_data?.rate_per_unit
                    popupUpdates.total_amt = billing?.service_data?.total_amt
                    popupUpdates.unit = billing?.service_data?.unit
                    break;
            }
            return {
                ...prev,
                ...popupUpdates,
                concession_amt: billing?.service_data?.concession_amt,
                concession_percent: billing?.service_data?.concession_percent,
                concession_percent_w_r: billing?.service_data?.concession_percent_w_r,
                concession_comments: billing?.service_data?.concession_comments,
                doc_discount_amt: billing?.service_data?.doc_discount_amt,
                doc_discount_percent: billing?.service_data?.doc_discount_percent,
                doc_discount_percent_w_r: billing?.service_data?.doc_discount_percent_w_r,
                hos_discount_amt: billing?.service_data?.hos_discount_amt,
                hos_discount_percent: billing?.service_data?.hos_discount_percent,
                hos_discount_percent_w_r: billing?.service_data?.hos_discount_percent_w_r,
                doctor_percent: billing?.service_data?.doctor_percent,
                doctor_percent_w_r: billing?.service_data?.doctor_percent_w_r,
                hospital_percent: billing?.service_data?.hospital_percent,
                hospital_percent_w_r: billing?.service_data?.hospital_percent_w_r,
                unit_type: billing?.service_data?.unit_type,
                is_hospital: billing?.service_data?.is_hospital,
                service_head_id: billing?.service_data?.service_head_id,
                op_order_number: billing?.service_data?.op_order_number,
                old_time_taken: billing?.service_data?.old_time_taken
            }
        })
    }

    const getTimeDifference = (startDate, endDate) => {
        try {
            const start = new Date(startDate);
            const end = new Date(endDate);
            start.setSeconds(0, 0);
            end.setSeconds(0, 0);
            let diff = end - start;
            const hours = String(Math.floor(diff / (1000 * 60 * 60))).padStart(2, '0');
            diff %= (1000 * 60 * 60);
            const minutes = String(Math.floor(diff / (1000 * 60))).padStart(2, '0');

            return `${hours}:${minutes}`;
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const onChangeTimeHandler = useCallback((time, key) => {
        try {
            if (!time) return;

            if (key === 'startDate') {
                if (!popupValues?.end_date) {
                    setPopupValues(prev => ({
                        ...prev,
                        start_date: time
                    }));
                } else {
                    const timeDiff = getTimeDifference(time, popupValues.end_date);
                    setPopupValues(prev => ({
                        ...prev,
                        start_date: time,
                        hours: timeDiff?.split(':')[0],
                        minutes: timeDiff?.split(':')[1],
                    }));
                }
            }

            if (key === 'endDate') {
                if (!popupValues.start_date) {
                    errorMessage('Select Start Date');
                    return;
                }

                const timeDiff = getTimeDifference(popupValues.start_date, time);
                setPopupValues(prev => ({
                    ...prev,
                    end_date: time,
                    hours: timeDiff?.split(':')[0],
                    minutes: timeDiff?.split(':')[1],
                }));
            }
        } catch (error) {
            errorMessage(error.message);
        }
    }, [popupValues]);

    const ratePerUnitPopup = () => {
        let totalAmt = +popupValues.doctor_amt + (+popupValues.hospital_amt)
        const appointmentDate = dayjs(billing?.patientData?.appointment_date);
        const currentDate = dayjs();
        const startDate = dayjs(popupValues?.start_date);
        return (
            <>{openPopup === 'rate' ?
                <Dialog open={openPopup === 'rate'} maxWidth='sm' fullWidth>
                    <Box className='com_billing_popup'>
                        <Box component={'div'} p={'0rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
                            <Typography fontSize={'1rem'} fontWeight={600}>Update Rate Per Unit</Typography>
                            <IconButton
                                onClick={() => setOpenPopup(null)}
                            >
                                <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1dvw'} width={'1dvw'} />
                            </IconButton>
                        </Box>
                        <Box component={'div'} p={'0.5rem'}>
                            <Typography fontSize={'1rem'} fontWeight={600}>Doctor Consultation</Typography>
                            <Box component={'div'} display={'flex'} justifyContent={'space-evenly'}>
                                <Typography fontSize={'1rem'} fontWeight={600}>{`Rate / Unit - ${popupValues?.rate_per_unit ? CommonValidation.formatAmount(popupValues?.rate_per_unit) : '0'}`}</Typography>
                                <Typography fontSize={'1rem'} fontWeight={600}>{`Unit - ${popupValues?.unit}`}</Typography>
                            </Box>
                            <Box component={'div'} mt={'1rem'}>
                                <Grid container sx={{ display: 'flex', alignItems: 'center' }} rowGap={2}>
                                    <Grid xs={3}><Typography fontSize={'1rem'} fontWeight={600}>Doctor Share</Typography></Grid>
                                    <Grid xs={4.5}>
                                        {popupTextBox('doctor_amt', popupValues?.doctor_amt, false, 1, `Doctor Fee (${CurrencySymbol})`)}
                                    </Grid>
                                    <Grid xs={4.5}>
                                        {popupTextBox('doctor_percent', popupValues?.doctor_percent_w_r, false, 1, 'Doctor Percentage (%)', true)}
                                    </Grid>
                                    <Grid xs={3}><Typography fontSize={'1rem'} fontWeight={600}>Hosptial Share</Typography></Grid>
                                    <Grid xs={4.5}>
                                        {popupTextBox('hospital_amt', popupValues?.hospital_amt, false, 1, `Hospital Fee (${CurrencySymbol})`)}
                                    </Grid>
                                    <Grid xs={4.5}>
                                        {popupTextBox('hospital_percent', popupValues?.hospital_percent_w_r, false, 1, `Hospital Percentage (%)`, true)}
                                    </Grid>
                                    <Grid xs={3}><Typography fontSize={'1rem'} fontWeight={600}>Total Amount</Typography></Grid>
                                    <Grid xs={4.5}>
                                        {popupTextBox('total_amt', totalAmt ? CommonValidation.formatAmount(totalAmt) : '', false, 1, `Total Amount (${CurrencySymbol})`, true)}
                                    </Grid>
                                    <Grid xs={4.5}>
                                        {popupTextBox('total_percent', '100.00', false, 1, `Total Percentage (%)`, true)}
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>
                        <Box m={'1rem'} display={'flex'} justifyContent={'flex-end'} alignItems={'center'}>
                            <Button variant='outlined' sx={{ textTransform: 'capitalize', mr: '1rem', height: '4dvh' }}
                                onClick={() => setOpenPopup(null)}
                            >Close</Button>
                            <Button variant='contained' sx={{ textTransform: 'capitalize', mr: '1rem', height: '4dvh' }}
                                onClick={() => {
                                    onSavePopupHandler('rate')
                                    setOpenPopup(null)
                                }}
                            >Save</Button>
                        </Box>
                    </Box>
                </Dialog> :
                openPopup === 'concession' ?
                    <Dialog open={openPopup === 'concession'} maxWidth='sm' fullWidth>
                        <Box className='com_billing_popup'>
                            <Box component={'div'} p={'0rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
                                <Typography fontSize={'1rem'} fontWeight={600}>Concession</Typography>
                                <IconButton
                                    onClick={() => setOpenPopup(null)}
                                >
                                    <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1dvw'} width={'1dvw'} />
                                </IconButton>
                            </Box>
                            <Box component={'div'} p={'0.5rem'}>
                                <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                                    <Typography fontSize={'1rem'} fontWeight={600}>Doctor Consultation</Typography>
                                    <Typography fontSize={'1rem'} fontWeight={600}>{`Bill Amount : ${CommonValidation.formatAmount(popupValues?.total_amt)}`}</Typography>
                                </Box>
                                <Box component={'div'} mt={'1rem'}>
                                    <Grid container sx={{ display: 'flex', alignItems: 'center' }} rowGap={2}>
                                        <Grid xs={3}><Typography fontSize={'1rem'} fontWeight={600}>Doctor Concession</Typography></Grid>
                                        <Grid xs={4.5}>
                                            {popupTextBox('doctor_discount_amt', popupValues?.doc_discount_amt, false, 1, `Amount (${CurrencySymbol})`, (popupValues?.is_hospital || billing?.service_data?.membership_discount_percentage))}
                                        </Grid>
                                        <Grid xs={4.5}>
                                            {popupTextBox('doctor_discount_percent', popupValues?.doc_discount_percent_w_r, false, 1, 'Percentage (%)', (popupValues?.is_hospital || billing?.service_data?.membership_discount_percentage))}
                                        </Grid>
                                        <Grid xs={3}><Typography fontSize={'1rem'} fontWeight={600}>Hosptial Concession</Typography></Grid>
                                        <Grid xs={4.5}>
                                            {popupTextBox('hospital_discount_amt', popupValues?.hos_discount_amt, false, 1, `Amount (${CurrencySymbol})`, billing?.service_data?.membership_discount_percentage)}
                                        </Grid>
                                        <Grid xs={4.5}>
                                            {popupTextBox('hospital_discount_percent', popupValues?.hos_discount_percent_w_r, false, 1, 'Percentage (%)', billing?.service_data?.membership_discount_percentage)}
                                        </Grid>
                                    </Grid>
                                </Box>
                                {popupValues?.is_hospital ? <Box><FormHelperText sx={{ color: 'red', fontSize: COMMON_STYLES.FONT_SIZE_SM, textAlign: 'center' }}>Concession Enable Only For Hospital !</FormHelperText></Box> : null}
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: '0.5rem' }}>
                                    <Box>
                                        <Typography fontSize={'0.8dvw'} color={Colors.grayShade}>Doctor Share</Typography>
                                        <Typography fontSize={'1rem'} fontWeight={600}>{`${CommonValidation.formatAmount(popupValues?.old_doctor_amt) || 0} - ${CommonValidation.formatAmount(popupValues?.doc_discount_amt) || 0} = ${CommonValidation.formatAmount(popupValues?.new_doctor_amt) || 0}`}</Typography>
                                    </Box>
                                    <Box mr={'2rem'}>
                                        <Typography fontSize={'0.8dvw'} color={Colors.grayShade}>Hosptial Share</Typography>
                                        <Typography fontSize={'1rem'} fontWeight={600}>{`${CommonValidation.formatAmount(popupValues?.old_hospital_amt) || 0} - ${CommonValidation.formatAmount(popupValues?.hos_discount_amt) || 0} = ${CommonValidation.formatAmount(popupValues?.new_hospital_amt) || 0}`}</Typography>
                                    </Box>
                                </Box>
                                <Box component={'div'} mt={'0.5rem'}>
                                    {popupTextBox('concession_comments', popupValues?.concession_comments, true, 3, 'Concession Comments', (billing?.service_data?.membership_discount_percentage), '37dvw')}
                                </Box>
                            </Box>
                            <Box m={'0.5rem'} display={'flex'} justifyContent={'flex-end'} alignItems={'center'}>
                                <Button variant='outlined' sx={{ textTransform: 'capitalize', mr: '1rem', height: '4dvh' }}
                                    onClick={() => setOpenPopup(null)}
                                >Close</Button>
                                <Button variant='contained' 
                                disabled={billing?.service_data?.membership_discount_percentage}
                                sx={{ textTransform: 'capitalize', mr: '1rem', height: '4dvh' }}
                                    onClick={() => {
                                        onSavePopupHandler('concession')
                                        setOpenPopup(null)
                                    }}
                                >Save</Button>
                            </Box>
                        </Box>
                    </Dialog> :
                    <Dialog open={openPopup === 'time'} maxWidth='sm'>
                        <Box className='com_billing_popup'>
                            <Box component={'div'} p={'0rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
                                <Typography fontSize={'1rem'} fontWeight={600}>Unit</Typography>
                                <IconButton
                                    onClick={() => setOpenPopup(null)}
                                >
                                    <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1dvw'} width={'1dvw'} />
                                </IconButton>
                            </Box>
                            <Box component={'div'} p={'0.5rem'}>
                                <Box component={'div'} display={'flex'} justifyContent={'flex-end'}>
                                    <RadioGroup row
                                        value={selectedRadio}
                                        onChange={(e) => { setSelectedRadio(e.target.value) }}
                                    >
                                        <FormControlLabel value={'input'} control={<Radio size='small' />} label="Based on Input" />
                                        <FormControlLabel value={'time'} control={<Radio size='small' />} label="Based on Time" />
                                    </RadioGroup>
                                </Box>
                                <Box component={'div'}>
                                    <Typography fontSize={COMMON_STYLES.FONT_SIZE_L} fontWeight={COMMON_STYLES.FONT_WEIGHT}>Based On Input</Typography>
                                    <Box component={'div'} mt={'0.5rem'} display={'flex'}>
                                        <TextField size='small' disabled={selectedRadio === 'time'}
                                            value={popupValues?.hours}
                                            onChange={(e) => { onPopupChangeHandler(e, 'hours') }}
                                            label='Hours'
                                            sx={{ width: '15dvw' }}
                                        />
                                        <TextField size='small' disabled={selectedRadio === 'time'}
                                            value={popupValues?.minutes}
                                            onChange={(e) => { onPopupChangeHandler(e, 'minutes') }}
                                            label='Minutes'
                                            sx={{ width: '15dvw', ml: '1rem' }}
                                        />
                                    </Box>
                                </Box>
                                <Box component={'div'} mt={'0.5rem'}>
                                    <Typography fontSize={COMMON_STYLES.FONT_SIZE_L} fontWeight={COMMON_STYLES.FONT_WEIGHT}>Based On Time</Typography>
                                    <Box component={'div'} mt={'0.5rem'} display={'flex'}>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DateTimePicker
                                                disabled={selectedRadio === 'input'}
                                                value={popupValues?.start_date}
                                                name={"datePicker"}
                                                open={billing.startTimeOpen}
                                                onOpen={() => { setBilling((prev) => ({ ...prev, startTimeOpen: true })) }}
                                                onClose={() => { setBilling((prev) => ({ ...prev, startTimeOpen: false })) }}
                                                inputFormat='DD-MM-YYYY hh:mm A'
                                                label={('Start Date & Time')}
                                                minDateTime={appointmentDate}
                                                maxDateTime={currentDate}
                                                onChange={(newDate) => { onChangeTimeHandler(newDate, 'startDate') }}
                                                renderInput={(params) => <TextField
                                                    onClick={() => { setBilling((prev) => ({ ...prev, startTimeOpen: true })) }}
                                                    onKeyDown={(e) => { e.preventDefault() }}
                                                    size='small' {...params} sx={{ width: '15dvw' }}
                                                />}
                                            />
                                        </LocalizationProvider>
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DateTimePicker
                                                disabled={selectedRadio === 'input'}
                                                value={popupValues?.end_date}
                                                name={"datePicker"}
                                                open={billing.endTimeOpen}
                                                onOpen={() => { setBilling((prev) => ({ ...prev, endTimeOpen: true })) }}
                                                onClose={() => { setBilling((prev) => ({ ...prev, endTimeOpen: false })) }}
                                                inputFormat='DD-MM-YYYY hh:mm A'
                                                label={('End Date & Time')}
                                                minDateTime={startDate}
                                                onChange={(newDate) => { onChangeTimeHandler(newDate, 'endDate') }}
                                                renderInput={(params) => <TextField
                                                    onClick={() => { setBilling((prev) => ({ ...prev, endTimeOpen: true })) }}
                                                    onKeyDown={(e) => { e.preventDefault() }}
                                                    sx={{ ml: '1rem', width: '15dvw' }}
                                                    size='small' {...params}
                                                />}
                                            />
                                        </LocalizationProvider>
                                    </Box>
                                    <Box component={'div'} mt={'0.5rem'} display={'flex'} alignItems={'center'} justifyContent={'flex-end'}>
                                        <Button variant='outlined' sx={{ textTransform: 'capitalize', height: '4.5dvh', mr: '1rem' }}
                                            onClick={() => setOpenPopup(null)}
                                        >Close</Button>
                                        <Button variant='contained' sx={{ textTransform: 'capitalize', height: '4.5dvh' }}
                                            onClick={() => {
                                                onSavePopupHandler('time')
                                                setOpenPopup(null)
                                            }}
                                        >Add</Button>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Dialog>
            }</>
        )
    }

    const clearService = () => {
        try {
            setBilling((prev) => ({
                ...prev,
                selected_service: null,
                service_data: {
                    rate_per_unit: '', unit: 1, unit_type: 'Nos', total_amt: '', total_with_discount: '',
                    doctor_amt: '', doctor_percent: '', old_doctor_amt: '', new_doctor_amt: '',
                    hospital_amt: '', hospital_percent: '', old_hospital_amt: '', new_hospital_amt: '',
                    interval_time: '', interval_amount: '', service_name: '', service_head_name: '',
                    service_code: '', service_head_code: '', edit_unit: false, edit_amount: false,
                    edit_discount: false, doctor_name: '', doctor_id: '', start_time: '',
                    end_time: '', doc_discount_amt: '', doc_discount_percent: '',
                    hos_discount_amt: '', hos_discount_percent: '', concession_amt: '',
                    concession_percent: '', gst_percent: 0, hours: '', minutes: '',
                    concession_comments: '', service_details_id: '', doctor_id: '',
                    review_days: '', review_count: '', charge_id: '',
                    gst_amount: '', sgst_amount: '', cgst_amount: '', igst_amount: '',
                    taxable_amount: '', sub_total_amount: '', round_off: '',
                    received_amount: '', net_amount: '', concession_percent_w_r: '',
                    doc_discount_percent_w_r: '', hos_discount_percent_w_r: '',
                    doctor_percent_w_r: '', hospital_percent_w_r: '',
                    module_type: '', start_date: new Date(), end_date: null, is_hospital: false,
                    service_head_id: null, doctor_id: '', op_order_number: '',
                    id: null
                }
            }))
        } catch (error) {
            errorMessage(error.message)
        }
    }

    useEffect(() => {
        if (billing.billingList?.length) {
            let hasDuplicate = hasDuplicateEntries(billing.billingList)
            setHasDuplicate(hasDuplicate)
            updateDuplicateCount()
        }
    }, [billing.billingList])

    useEffect(() => {
        if (billing.billingList?.length) {
            let totalConcession = billing.billingList.reduce((acc, item) => {
                if (item.package_type === 'Package' || item.package_type === 'Assorted') {
                    if (item.billing_display === 'Assorted Package Name' || item.billing_display === 'Package Name') {
                        acc += +item?.concession_amt || 0;
                    } else if (item.billing_display === 'Assorted Service Head') {
                        item?.package_line?.forEach(pack => {
                            acc += +pack?.concession_amt || 0;
                        });
                    } else if (item.billing_display === 'Service Head' || item.billing_display === 'Service Name') {
                        item?.package_line?.forEach(pack => {
                            pack?.service_data?.forEach(service => {
                                acc += +service?.concession_amt || 0;
                            });
                        });
                    }
                } else {
                    if (item?.membership_discount_percentage) {
                        acc += 0
                    } else {
                        acc += +item?.concession_amt || 0;
                    }
                }
                return acc;
            }, 0);

            let hasConcession = totalConcession > 0;

            setRequestState((prev) => ({
                ...prev,
                hasConcession: hasConcession,
                totalConcession: totalConcession
            }));
        }
    }, [billing.billingList]);

    const [duplicateCount, setDuplicateCount] = useState({});

    const updateDuplicateCount = (items = billing.billingList) => {
        const count = {};
        items.forEach(({ package_id, service_details_id, doctor_id }) => {
            const key = package_id ? package_id : `${service_details_id}-${doctor_id}`;
            count[key] = (count[key] || 0) + 1;
        });
        setDuplicateCount(count);
    };

    const handleclosePopover = () => {
        setDialogOpen(false)
    }


    const PopoverBox = () => {
        return(
            <Popover 
                open={dialogOpen}
                anchorEl={anchorEl}
                onClose={handleclosePopover}
                anchorReference="anchorPosition" 
                anchorPosition={{ top: 0, left: 0 }}
                slotProps={{
                    paper:{
                        sx: { 
                        width: '27vw', 
                        borderRadius: '0.4vw', 
                        padding: '1rem', 
                        boxShadow: '0px 0.2vw 1vw rgba(0,0,0,0.1)',
                        position: 'fixed !important',
                        top: '19vw !important',
                        left: getCachevalue('BillType') === 'Cancel'  ? '45vw !important' : '38vw !important',
                        boxShadow: '0vw 0.4vw 1.5vw rgba(0, 0, 0, 0.15)', 
                        border: '1px solid rgba(0, 0, 0, 0.05)', 
                     }
                    }
                }} 
            >
                <Box display='flex' justifyContent='space-between' alignItems='center' mb='0.5rem'>
                    <Typography fontSize='1rem' fontWeight={600}>Membership Card</Typography>
                    {props?.patientData?.membership_expiry_count && (
                        <Box sx={{
                        backgroundColor: '#fee2e2', 
                        color: '#b91c1c', 
                        padding: '2px 12px',
                        borderRadius: '20px',
                        fontSize: '0.75rem',
                        border: '1px solid #fecaca'
                    }}  
                    >
                        {`Expires in ${props?.patientData?.membership_expiry_count} ${Number(props?.patientData?.membership_expiry_count) === 1 ? 'Day' : 'Days'}`}
                    </Box>
                    )}
                </Box>
                    <Divider sx={{ mb:2 }}/>
                    <Grid container spacing={1.5} sx={{width: '26vw' }}>
                    <Grid item  sx={{ flex: '0 0 30%' }}>
                        <Typography color="textSecondary" fontSize="0.9rem">Package Name</Typography>
                    </Grid>
                    <Grid item xs={8.4}>
                        <Tooltip title={props?.patientData?.membership_type || '-'} arrow placement="top">
                        <Typography fontWeight={600} fontSize="0.9rem">{`: ${props?.patientData?.membership_type ?
                            props?.patientData?.membership_type.length > 25
                                ? props?.patientData?.membership_type.slice(0, 35) + '...'
                                : props?.patientData?.membership_type
                            : '-'}`}</Typography>   
                        </Tooltip> 
                    </Grid>

                    <Grid item  sx={{ flex: '0 0 30%' }} >
                        <Typography color="textSecondary" fontSize="0.9rem">Validity Period</Typography>
                    </Grid>
                    <Grid item xs={8.4}>
                        <Typography fontWeight={600} fontSize="0.9rem"> { `: ${props?.patientData?.membership_validity || '-'}` } </Typography>
                    </Grid>
                    <Grid item sx={{ flex: '0 0 30%' }}>
                        <Typography color="textSecondary" fontSize="0.9rem">No.of Visit</Typography>
                    </Grid>
                    <Grid item xs={8.4}>
                        <Typography fontWeight={600} fontSize="0.9rem">{`: ${props?.patientData?.membership_no_of_visit || '0'} / ${props?.patientData?.membership_total_no_of_visit || '-'}`}</Typography>
                    </Grid>
                </Grid>
            </Popover>
        )
    }

    const dialogPopup = () => {
        return(
        <Dialog open={dialogFuture} maxWidth='sm' fullWidth>
            <DialogTitle sx={{ display:'flex', justifyContent: 'space-between', padding:'1vw' }}>
                <Typography fontSize={'1rem'} fontWeight={600}>{'Future Appointment'}</Typography>
                <Button onClick={() => { setDialogFuture(false) }} >
                    <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                </Button>
            </DialogTitle>
            <DialogContent dividers sx={{ padding: '1vw'}} >
                    {hasValiuptoDate?.valid_upto ?<Box
                        sx={{
                            backgroundColor: '#ffedd5', 
                            borderLeft: '4px solid #f97316',
                            color: 'text.primary',
                            p: 1,
                            mb: 2,
                            mt: 2, 
                            borderRadius: '4px',
                            display: 'flex',
                            alignItems: 'center',
                            fontSize: '0.875rem'
                        }}
                    >
                        {/* <Badge isSmall={true} /> */}
                        
                        <Typography component="span" sx={{ fontSize: '0.85rem' }}>
                            {loginInfo?.review_period_based_on === "doctor"
                                ? `An active follow-up exists for the patient with Dr. ${hasValiuptoDate?.doctor_name}, valid upto ${hasValiuptoDate?.valid_upto ? formatDate(hasValiuptoDate?.valid_upto) : ''}.`
                                : loginInfo?.review_period_based_on === "specialization"
                                    ? `An active follow-up exists for the patient under ${hasValiuptoDate?.specialization_name || 'Specialization'}, valid upto ${hasValiuptoDate?.valid_upto ? formatDate(hasValiuptoDate?.valid_upto) : ''}.`
                                    : `An active follow-up exists for the patient, valid upto ${hasValiuptoDate?.valid_upto ? formatDate(hasValiuptoDate?.valid_upto) : ''}.`
                            }
                        </Typography>
                    </Box> : null}
                <TableContainer sx={{maxHeight:'60dvh' }}>
                    { futureAppointments.length > 0 ?  <Table size='small' stickyHeader sx={{ minWidth: 500 }} aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                <TableCell align="center" sx={{ fontWeight: 500, fontSize: '1rem', width: '18%' }}>Date</TableCell>
                                <TableCell align="center" sx={{ fontWeight: 500, fontSize: '1rem', width: '32%' }}>Doctor Name</TableCell>
                                <TableCell align="center" sx={{ fontWeight: 500, fontSize: '1rem', width: '34%' }}>Specialization</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {futureAppointments.map((row, index) => (
                                <TableRow key={index}>
                                    <TableCell align="center">{row.appointment_date ? formatDate(row?.appointment_date) : ''} </TableCell>
                                    {row?.doctor_name.length > 20 ? <Tooltip title={row?.doctor_name} placement='top' arrow>
                                        <TableCell sx={{ width: '5vw' }} >{row?.doctor_name.slice(0,18) + '...'} </TableCell>
                                    </Tooltip> 
                                    : <TableCell align="center">{row?.doctor_name}</TableCell>}
                                    {row?.specialization_name.length > 20  ? <Tooltip title={row?.specialization_name} placement="top-start" arrow>
                                        <TableCell align="center">{row?.specialization_name.slice(0,25) + '...'} </TableCell>
                                    </Tooltip> : <TableCell align="center">{row?.specialization_name} </TableCell>}
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>: <Typography>No Records Found</Typography>}
                </TableContainer>
            </DialogContent>
        </Dialog>
    )
    }


    const renderLftContent = () => {
         const customKey = localGetItem("display_latest_token_number") == "true" ? true : false
        return (
            <Box component={'div'} sx={{ backgroundColor: 'white', position: 'relative' }}>
                 {customKey && loginInfo?.module_name === 'front_office' && loginInfo?.token_gen_type === "Doctor" && (props?.doctorDetails?.selectedDoctor?.doctor_id != undefined || props?.doctorDetails?.selectedDoctor?.doctor_id != null ) && (
                        <Box
                            component="div"
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-start",
                                gap: "0.4rem",
                                padding: "0.2rem 0.6rem",
                                // zIndex: 10
                                 position:'absolute',
                                top:'0.4vw',
                                left:'0.2vw'
                            }}
                        >
                            <Chip
                                label={
                                    <Box fontSize="0.75rem" component="span">
                                        Latest Token:{" "}
                                        <Box component="span" sx={{ color: "#616161", fontSize: "0.75rem", }}>
                                            {props?.doctorToken ?? "-"}
                                        </Box>
                                    </Box>
                                }
                                color="primary"
                                variant="outlined"
                                sx={{ fontSize: "0.75rem", height: "26px" }}
                            />
                            <Tooltip arrow title="Refresh" placement="right">
                                <Button
                                    size="small"
                                    onClick={() => {
                                        try {
                                            props.handleDoctorToken();
                                        } catch (error) {
                                            console.error(error);
                                        }
                                    }}
                                    variant="contained"
                                    id="eMed_Config_btn"
                                    sx={{
                                        minWidth: "28px",
                                        width: "28px",
                                        height: "28px",
                                        padding: 0,
                                        borderRadius: "6px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        '& svg': { fontSize: "16px" }
                                    }}
                                >
                                    {props?.isRefreshing ? (
                                        <CircularProgress
                                            size={13}
                                            sx={{ color: "white" }}
                                        />
                                    ) : (
                                        <RefreshIcon />
                                    )}
                                </Button>
                            </Tooltip>
                        </Box>
                )}
                {(getCachevalue('BillType') === 'Cancel' || (requestState.fromApprover && !requestState.modifyApprover)) && hasMembershipCard ? <Box 
                    sx={{ display:'flex', flexDirection: 'row-reverse', position:'relative', top: '1vw' }}>
                    <IconButton sx={{ height: '1.5vw', width: '1.5vw', marginRight: '1vw' }} onClick={() => { {
                        setAnchorEl(true);
                        setDialogOpen(true);
                    }}}>
                        <img src={ImagePaths.MemberShip.default} alt='help' style={{ height:'1.5vw', width:'1.5vw' }}  />
                        </IconButton>
                </Box> : null}
                <Box component={'div'} mb={'0.5rem'} display={'flex'} justifyContent={'flex-end'} alignItems={'center'} p={'0rem 0.5rem'}
                    visibility={(getCachevalue('BillType') === 'Cancel' || requestState.fromApprover && !requestState.modifyApprover) ? 'hidden' : 'visible'}>
                    {/* {hasDuplicate ? <Box><FormHelperText sx={{ color: 'red', fontSize: '0.85rem', mr: '1rem' }}>{'Delete the duplicate services and create bill'}</FormHelperText></Box> : null} */}
                    {hasMembershipCard ? <IconButton sx={{ height: '1.5vw', width: '1.5vw', marginRight: '1vw' }} onClick={() => { {
                        setAnchorEl(true);
                        setDialogOpen(true);
                    }}}>
                        <img src={ImagePaths.MemberShip.default} alt='help' style={{ height:'1.5vw', width:'1.5vw' }}  />
                        </IconButton> : null}
                    {(futureAppointments.length > 0 || hasValiuptoDate?.valid_upto) && props.fromQuickBill ? 
                        <IconButton sx={{ height: '1.5vw', width: '1.5vw', marginRight:'1vw' }} onClick={() => { {
                        setDialogFuture(true)}}}>
                        <img src={ImagePaths.FutureAppointment.default} alt='help' style={{ height:'1.5vw', width:'1.5vw' }}  />
                        </IconButton> : null}
                        {localGetItem('referred_doctor_billing') === 'true' && !localGetItem('is_investigation_module') ? <Autocomplete
                        freeSolo
                        disabled={((requestState?.fromBillConvert) || requestState?.fromApprover) ? true : (billing.selected_bill_doc && getCachevalue('BillType') !== 'Cancel' && (billing.patientData?.patient_id)) || (requestState?.fromPendingList || requestState?.fromBillConvert) ? false : true}
                        size='small'
                        sx={{ width: '16dvw', pt: '0.2rem', mr: '1vw' }}
                        options={refDocList}
                        getOptionLabel={(option) => typeof (option) === 'string' ? option : (option?.specialization ? `${option?.name} - ${option?.specialization}` : option?.name)}
                        value={selectedRefDoc}
                        inputValue={InputRefDoc}
                        onChange={(e, newValue) => {
                            setselectedRefDoc(newValue)
                        }}
                        onInputChange={(e, newInputValue, reason) => {
                            if (reason === "input" && newInputValue.length > 50) return;
                            setInputRefDoc(newInputValue);
                            if (reason === "input") {
                                setselectedRefDoc(null);
                            }
                        }}
                        renderInput={(params) => <TextField
                            // onChange={(event) => {
                            //     setselectedRefDoc(event.target.value)
                            // }}
                            {...params}
                            label='Select Referred Doctor'
                            InputProps={{
                                ...params.InputProps, emed_tid: 'selec_bill_ref_doc'
                            }}
                        />}
                    /> : null}  
                    <Autocomplete
                        disabled={((requestState?.fromBillConvert) || requestState?.fromApprover) ? true : (billing.selected_bill_doc && getCachevalue('BillType') !== 'Cancel' && (billing.patientData?.patient_id)) || (requestState?.fromPendingList || requestState?.fromBillConvert) ? false : true}
                        size='small'
                        sx={{ width: '16dvw', pt: '0.2rem' }}
                        options={billing.tempPackSugg}
                        getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.template_name ? `${option.template_name} - Template` : option?.package_name ? `${option?.package_name ?? ""} - Package` : `${option?.assorted_package_name ?? ""} - Assorted`}
                        value={billing.selected_temp_pack}
                        onChange={(e, newValue) => {
                            setBilling((prev) => ({
                                ...prev,
                                overallDiscount: { discount_amount: '', discount_percentage: '', discount_percentage_w_r: '' },
                                concessionReason: ''
                            }))
                            getTemplateData(newValue)
                        }}
                        renderInput={(params) => <TextField
                            {...params}
                            label='Search Template/Package'
                            InputProps={{
                                ...params.InputProps, emed_tid: 'ser_temp_pack'
                            }}
                        />}
                        renderOption={(props, option) => (
                            <Box
                                component="li"
                                {...props}
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                    justifyContent: "flex-start",
                                    width: "100%",
                                    textAlign: "left",
                                }}
                            >
                                <Typography fontSize=".9vw" sx={{ width: "100%", textAlign: "left" }} >
                                    {`${option?.template_name || option?.package_name || option?.assorted_package_name || "-"}${(option?.assorted_package_amount || option?.assorted_package_amount === 0 || option?.package_amount || option?.package_amount === 0) ? ` - ${AmountFormat(option?.assorted_package_amount || option?.package_amount || 0)}` : ""}`}
                                </Typography>
                                <Typography
                                    fontSize=".8vw"
                                    fontWeight="bold"
                                    sx={{ width: "100%", textAlign: "left" }}
                                    color={option?.template_name ? "#29B6F6"
                                        : option?.package_name ? "#1E972A"
                                            : option?.assorted_package_name ? "blue"
                                                : "inherit"}
                                >
                                    {option?.template_name ? "Template"
                                        : option?.package_name ? "Package"
                                            : option?.assorted_package_name ? 'Assorted'
                                                : ""}
                                </Typography>
                            </Box>
                        )}
                    />
                    {billing.patientData?.employer_id && billing.corporateServiceList?.length ?
                        <Box component={'div'}>
                            <Autocomplete
                                disabled={((requestState?.fromBillConvert) || requestState?.fromApprover) ? true : (billing.selected_bill_doc && getCachevalue('BillType') !== 'Cancel' && (billing.patientData?.patient_id) ? false : true)}
                                size='small'
                                sx={{ width: '16dvw', pt: '0.2rem', ml: '0.5rem' }}
                                options={billing.corporateServiceList}
                                getOptionLabel={(option) => typeof (option) === 'string' ? option : `${option?.service_head_name || option?.service_head} ${option?.service_head_code ? `(${option?.service_head_code})` : ''} - ${option?.service_name} ${option?.service_code ? `(${option?.service_code})` : ''}`}
                                value={billing.selectedCorporateService}
                                onChange={(e, newValue) => {
                                    let selectedData = [newValue]
                                    let data = setBillingListData(selectedData)
                                    data["doctor_name"] = (newValue.doctor_name || billing?.patientData?.doctor_name)
                                    data["doctor_id"] = (newValue.doctor_id || billing?.patientData?.doctor_id)

                                    setBilling((prev) => ({
                                        ...prev, billingList: [...billing.billingList, ...data],
                                        overallDiscount: { discount_amount: '', discount_percentage: '', discount_percentage_w_r: '' },
                                        concessionReason: ''
                                    }))
                                }}
                                componentsProps={{ popper: { style: { width: '30dvw' } } }}
                                renderInput={(params) => <TextField
                                    {...params}
                                    label='Search Corporate Services'
                                    InputProps={{ ...params.InputProps, emed_tid: 'ser_cor_pack' }}
                                />}
                                renderOption={(props, item) => {
                                    let data = item?.emergency ? item?.emergency : item?.holiday ? item?.holiday : item
                                    const serviceName = data.service_head && data.service_head_code
                                        ? `${data.service_head} (${data.service_head_code})`
                                        : data.service_head || '';
                                    const serName = data.service_name && data.service_code
                                        ? `- ${data.service_name} (${data.service_code})`
                                        : `- ${data.service_name || ''}`;
                                    const fullServiceText = `${serviceName} ${serName}`.trim();
                                    let depart = data?.module_type
                                    return (
                                        <Box {...props} key={data?.id} >
                                            <Box sx={{ display: 'flex', flexDirection: 'column', alignContent: "flex-start" }}>
                                                {loginInfo?.module_name === 'Laboratory' ?
                                                    fullServiceText.length > 80 ? (
                                                        <Tooltip placement="top" title={fullServiceText}>
                                                            <Typography sx={{ fontSize: "0.9vw", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                <span style={{ marginLeft: "0.2vw" }}>
                                                                    {serName.slice(0, 50) + (serName.length > 50 ? '...' : '')}
                                                                </span>
                                                                <span style={{ fontWeight: 600 }}>
                                                                    {serviceName.slice(0, 30) + (serviceName.length > 30 ? '...' : '')}
                                                                </span>
                                                            </Typography>
                                                        </Tooltip>
                                                    ) : (
                                                        <Typography sx={{ fontSize: "0.9vw", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                            <span style={{ marginLeft: "0.2vw" }}>{serName}</span>
                                                            <span style={{ fontWeight: 600 }}>{serviceName}</span>
                                                        </Typography>
                                                    ) :
                                                    fullServiceText.length > 80 ? (
                                                        <Tooltip placement="top" title={fullServiceText}>
                                                            <Typography sx={{ fontSize: "0.9vw", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                <span style={{ fontWeight: 600 }}>
                                                                    {serviceName.slice(0, 50) + (serviceName.length > 30 ? '...' : '')}
                                                                </span>
                                                                <span style={{ marginLeft: "0.2vw" }}>
                                                                    {serName.slice(0, 30) + (serName.length > 10 ? '...' : '')}
                                                                </span>
                                                            </Typography>
                                                        </Tooltip>
                                                    ) : (
                                                        <Typography sx={{ fontSize: "0.9vw", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                            <span style={{ fontWeight: 600 }}>{serviceName}</span>
                                                            <span style={{ marginLeft: "0.2vw" }}>{serName}</span>
                                                        </Typography>
                                                    )}
                                                {depart?.length > 80 ?
                                                    <Tooltip placement='top' title={depart}><Typography sx={{ fontSize: "0.9vw", fontWeight: 600 }}>{depart?.slice(0, 80) + '...'}</Typography>
                                                    </Tooltip> : <Typography sx={{ fontSize: "0.9vw", fontWeight: 600 }}>{depart}</Typography>}
                                            </Box>
                                        </Box>
                                    )
                                }}
                            />
                        </Box> : null
                    }
                </Box>
                <Box component={'div'} height={'47dvh'} border={'1px solid lightgray'} overflow={'auto'}>
                    <Table size='small' stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell className='billing_tbl_head' width={'12%'}>Doctor Name</TableCell>
                                <TableCell className='billing_tbl_head' width={'22%'}>Service Description</TableCell>
                                {/* <TableCell className='billing_tbl_head' width={'12%'}>Order Id</TableCell> */}
                                <TableCell className='billing_tbl_head' width={'5%'}>Units</TableCell>
                                <TableCell className='billing_tbl_head' width={'11%'}>Rate/Unit</TableCell>
                                <TableCell className='billing_tbl_head' width={'11%'}>Concession</TableCell>
                                <TableCell className='billing_tbl_head' width={'11%'}>{`Amount (${CurrencySymbol})`}</TableCell>
                                {loginInfo?.is_gst_enabled ?
                                    <><TableCell className='billing_tbl_head' width={'6.5%'}>GST (%)</TableCell>
                                        <TableCell className='billing_tbl_head' width={'11%'}>{`Net Amount(${CurrencySymbol})`}</TableCell></> : null}
                                <TableCell className='billing_tbl_head' align='center' width={'10.5%'}>
                                    <Box component={'div'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                                        <Typography fontSize={COMMON_STYLES.FONT_SIZE_L} fontWeight={COMMON_STYLES.FONT_WEIGHT}>Action</Typography>
                                        {(requestState.fromApprover || requestState?.fromBillConvert) ? null : <Tooltip placement='top' title='Delete All'>
                                            <IconButton
                                                sx={{ width: '2dvw', height: '2dvw', visibility: getCachevalue('BillType') === 'Cancel' ? "hidden" : "visible" }}
                                                disabled={billing.isEdit ? true : false}
                                                onClick={() => {
                                                    setBilling((prev) => {
                                                        const cancelIds = prev.billingList.map(item => item.id);
                                                        return {
                                                            ...prev,
                                                            billingList: [],
                                                            cancelled_ids: [...prev.cancelled_ids, ...cancelIds],
                                                            overallDiscount: {
                                                                discount_amount: '',
                                                                discount_percentage: '',
                                                                discount_percentage_w_r: ''
                                                            }
                                                        };
                                                    });
                                                    settempDup([]);
                                                    setHasDuplicate(false);
                                                }}
                                            ><DeleteForeverIcon color={billing.isEdit ? 'disabled' : 'error'} sx={{ width: '1.5dvw', height: '1.5dvw' }} /></IconButton>
                                        </Tooltip>}
                                    </Box>
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {billing.billingList?.length > 0 ? billing.billingList?.map((item, index) => {
                                let serviceName = `${item?.service_name && item?.service_code ? `${item?.service_name} (${item?.service_code})` : item?.service_name} - ${item?.service_head_name && item?.service_head_code ? `${item?.service_head_name} (${item?.service_head_code})` : item?.service_head_name}`
                                let doctorName = item?.doctor_name
                                const key = item?.package_id ? item?.package_id : item?.assorted_id ? item?.assorted_id : `${item.service_details_id}-${item.doctor_id}`;
                                const isDuplicate = duplicateCount[key] > 1;
                                if (item?.package_type === 'Assorted' || item?.package_type === 'Package') {
                                    return (
                                        <TableRow key={index} sx={{ backgroundColor: isDuplicate ? '#d2f7f1' : 'white' }}>
                                            <TableCell className='billing_tbl_body'>
                                                <Box visibility={'hidden'}>{'-'}</Box>
                                                {item?.billing_display === 'Package Name' || item?.billing_display === 'Assorted Package Name' ? null : item?.package_line?.length > 0 ? item?.package_line?.map((pack, packIndex) => {
                                                    return (
                                                        <TableRow key={packIndex}>
                                                            <TableCell sx={{ borderBottom: 'none', pl: '0rem', pr: '0rem' }}>
                                                                <Box visibility={'hidden'}>{'-'}</Box>
                                                                {item?.billing_display === 'Assorted Service Head' ? null : pack?.service_data?.length > 0 ? pack?.service_data?.map((service, serviceIndex) => {
                                                                    let serviceDoctorName = service?.doctor_name
                                                                    return (
                                                                        <TableRow key={serviceIndex}>
                                                                            <TableCell sx={{ borderBottom: 'none', paddingLeft: '0rem', paddingRight: '0rem' }}>
                                                                                {serviceDoctorName ? serviceDoctorName?.length > 12 ?
                                                                                    <Tooltip placement='top' title={serviceDoctorName}>
                                                                                        <Typography sx={{ fontSize: COMMON_STYLES.FONT_SIZE_MD }}>{serviceDoctorName?.slice(0, 12) + '...'}</Typography>
                                                                                    </Tooltip> : <Typography sx={{ fontSize: COMMON_STYLES.FONT_SIZE_MD }}>{serviceDoctorName}</Typography> : '-'}
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    )
                                                                }) : null}
                                                            </TableCell>
                                                        </TableRow>
                                                    )
                                                }) : null}
                                            </TableCell>
                                            <TableCell className='billing_tbl_body'>
                                                {item?.package_name ? item?.package_name?.length > 25 ?
                                                    <Tooltip placement='top' title={item?.package_name}>
                                                        <Typography sx={{ fontSize: COMMON_STYLES.FONT_SIZE_MD, fontWeight: '600' }}>{item?.package_name?.slice(0, 25) + '...'}</Typography>
                                                    </Tooltip> : <Typography sx={{ fontSize: COMMON_STYLES.FONT_SIZE_MD, fontWeight: '600' }}>{item?.package_name}</Typography> : '-'}
                                                {item?.billing_display === 'Package Name' || item?.billing_display === 'Assorted Package Name' ? null : item?.package_line?.length > 0 ? item?.package_line?.map((pack, packIndex) => {
                                                    return (
                                                        <TableRow key={packIndex}>
                                                            <TableCell sx={{ borderBottom: 'none', pl: '0.3rem', pr: '0rem' }}>
                                                                {pack?.package_service_head ? pack?.package_service_head?.length > 25 ?
                                                                    <Tooltip placement='top' title={pack?.package_service_head}>
                                                                        <Typography sx={{ fontSize: COMMON_STYLES.FONT_SIZE_MD }}>{pack?.package_service_head?.slice(0, 25) + '...'}</Typography>
                                                                    </Tooltip> : <Typography sx={{ fontSize: COMMON_STYLES.FONT_SIZE_MD }}>{pack?.package_service_head}</Typography> : <Box visibility={'hidden'}>{'-'}</Box>}
                                                                {item?.billing_display === 'Assorted Service Head' ? null : pack?.service_data?.length > 0 ? pack?.service_data?.map((service, serviceIndex) => {
                                                                    let packServiceName = item?.billing_display === 'Service Head' ? `${service?.service_name && service?.service_code ? `${service?.service_name} (${service?.service_code})` : service?.service_name}` : `${service?.service_name && service?.service_code ? `${service?.service_name} (${service?.service_code})` : service?.service_name} - ${service?.service_head_name && service?.service_head_code ? `${service?.service_head_name} (${service?.service_head_code})` : service?.service_head_name}`
                                                                    return (
                                                                        <TableRow key={serviceIndex}>
                                                                            <TableCell sx={{ borderBottom: 'none', pl: '0.3rem', pr: '0rem' }}>
                                                                                {packServiceName ? packServiceName?.length > 25 ?
                                                                                    <Tooltip placement='top' title={packServiceName}>
                                                                                        <Typography sx={{ fontSize: COMMON_STYLES.FONT_SIZE_MD }}>{packServiceName?.slice(0, 25) + '...'}</Typography>
                                                                                    </Tooltip> : <Typography sx={{ fontSize: COMMON_STYLES.FONT_SIZE_MD }}>{packServiceName}</Typography> : '-'}
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    )
                                                                }) : null}
                                                            </TableCell>
                                                        </TableRow>
                                                    )
                                                }) : null}
                                            </TableCell>
                                            <TableCell className='billing_tbl_body'>
                                                <Box visibility={(item?.billing_display === 'Package Name' || item?.billing_display === 'Assorted Package Name') ? 'visible' : 'hidden'}>{item?.unit || 1}</Box>
                                                {item?.billing_display === 'Package Name' || item?.billing_display === 'Assorted Package Name' ? null : item?.package_line?.length > 0 ? item?.package_line?.map((pack, packIndex) => {
                                                    return (
                                                        <TableRow key={packIndex}>
                                                            <TableCell sx={{ borderBottom: 'none', pl: '0rem', pr: '0rem' }}>
                                                                <Box visibility={item?.billing_display === 'Assorted Service Head' ? 'visible' : 'hidden'}>{pack?.unit || 1}</Box>
                                                                {item?.billing_display === 'Assorted Service Head' ? null : pack?.service_data?.length > 0 ? pack?.service_data?.map((service, serviceIndex) => {
                                                                    return (
                                                                        <TableRow key={serviceIndex}>
                                                                            <TableCell sx={{ borderBottom: 'none', pl: '0rem', pr: '0rem' }}>
                                                                                {service?.unit || 1}
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    )
                                                                }) : null}
                                                            </TableCell>
                                                        </TableRow>
                                                    )
                                                }) : null}
                                            </TableCell>
                                            <TableCell className='billing_tbl_body'>
                                                <Box visibility={(item?.billing_display === 'Package Name' || item?.billing_display === 'Assorted Package Name') ? 'visible' : 'hidden'}>{CommonValidation.formatAmount(item?.rate_per_unit || '')}</Box>
                                                {item?.billing_display === 'Package Name' || item?.billing_display === 'Assorted Package Name' ? null : item?.package_line?.length > 0 ? item?.package_line?.map((pack, packIndex) => {
                                                    return (
                                                        <TableRow key={packIndex}>
                                                            <TableCell sx={{ borderBottom: 'none', pl: '0rem', pr: '0rem' }}>
                                                                <Box visibility={item?.billing_display === 'Assorted Service Head' ? 'visible' : 'hidden'}>{CommonValidation.formatAmount(pack?.rate_per_unit || '')}</Box>
                                                                {item?.billing_display === 'Assorted Service Head' ? null : pack?.service_data?.length > 0 ? pack?.service_data?.map((service, serviceIndex) => {
                                                                    return (
                                                                        <TableRow key={serviceIndex}>
                                                                            <TableCell sx={{ borderBottom: 'none', pl: '0rem', pr: '0rem' }}>
                                                                                {CommonValidation.formatAmount(service?.rate_per_unit || '')}
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    )
                                                                }) : null}
                                                            </TableCell>
                                                        </TableRow>
                                                    )
                                                }) : null}
                                            </TableCell>
                                            <TableCell className='billing_tbl_body'>
                                                <Box visibility={(item?.billing_display === 'Package Name' || item?.billing_display === 'Assorted Package Name') ? 'visible' : 'hidden'}>{CommonValidation.formatAmount(item?.concession_amt || '')}</Box>
                                                {item?.billing_display === 'Package Name' || item?.billing_display === 'Assorted Package Name' ? null : item?.package_line?.length > 0 ? item?.package_line?.map((pack, packIndex) => {
                                                    return (
                                                        <TableRow key={packIndex}>
                                                            <TableCell sx={{ borderBottom: 'none', pl: '0rem', pr: '0rem' }}>
                                                                <Box visibility={item?.billing_display === 'Assorted Service Head' ? 'visible' : 'hidden'}>{CommonValidation.formatAmount(pack?.concession_amt || '')}</Box>
                                                                {item?.billing_display === 'Assorted Service Head' ? null : pack?.service_data?.length > 0 ? pack?.service_data?.map((service, serviceIndex) => {
                                                                    return (
                                                                        <TableRow key={serviceIndex}>
                                                                            <TableCell sx={{ borderBottom: 'none', pl: '0rem', pr: '0rem' }}>
                                                                                {CommonValidation.formatAmount(service?.concession_amt || '')}
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    )
                                                                }) : null}
                                                            </TableCell>
                                                        </TableRow>
                                                    )
                                                }) : null}
                                            </TableCell>
                                            <TableCell className='billing_tbl_body'>
                                                {(item?.billing_display === 'Package Name' || item?.billing_display === 'Assorted Package Name') ? <Box>{CommonValidation.formatAmount(item?.total_with_discount || '')}</Box> : <Box visibility={'hidden'}>{'-'}</Box>}
                                                {item?.billing_display === 'Package Name' || item?.billing_display === 'Assorted Package Name' ? null : item?.package_line?.length > 0 ? item?.package_line?.map((pack, packIndex) => {
                                                    return (
                                                        <TableRow key={packIndex}>
                                                            <TableCell sx={{ borderBottom: 'none', pl: '0rem', pr: '0rem' }}>
                                                                {item?.billing_display === 'Assorted Service Head' ? <Box>{CommonValidation.formatAmount(pack?.total_with_discount || '')}</Box> : <Box visibility={'hidden'}>{'-'}</Box>}
                                                                {item?.billing_display === 'Assorted Service Head' ? null : pack?.service_data?.length > 0 ? pack?.service_data?.map((service, serviceIndex) => {
                                                                    return (
                                                                        <TableRow key={serviceIndex}>
                                                                            <TableCell sx={{ borderBottom: 'none', pl: '0rem', pr: '0rem' }}>
                                                                                {CommonValidation.formatAmount(service?.total_with_discount || '')}
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    )
                                                                }) : null}
                                                            </TableCell>
                                                        </TableRow>
                                                    )
                                                }) : null}
                                            </TableCell>
                                            {loginInfo?.is_gst_enabled ?
                                                <><TableCell className='billing_tbl_body'>
                                                    <Box visibility={'hidden'}>{'-'}</Box>
                                                    {item?.billing_display === 'Package Name' || item?.billing_display === 'Assorted Package Name' ? null : item?.package_line?.length > 0 ? item?.package_line?.map((pack, packIndex) => {
                                                        return (
                                                            <TableRow key={packIndex}>
                                                                <TableCell sx={{ borderBottom: 'none', pl: '0rem', pr: '0rem' }}>
                                                                    <Box visibility={'hidden'}>{'-'}</Box>
                                                                    {item?.billing_display === 'Assorted Service Head' ? null : pack?.service_data?.length > 0 ? pack?.service_data?.map((service, serviceIndex) => {
                                                                        return (
                                                                            <TableRow key={serviceIndex}>
                                                                                <TableCell sx={{ borderBottom: 'none', pl: '0rem', pr: '0rem' }}>
                                                                                    {service?.gst_percent}
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        )
                                                                    }) : null}
                                                                </TableCell>
                                                            </TableRow>
                                                        )
                                                    }) : null}
                                                </TableCell>
                                                    <TableCell className='billing_tbl_body'>
                                                        <Box visibility={'hidden'}>{'-'}</Box>
                                                        {item?.billing_display === 'Package Name' || item?.billing_display === 'Assorted Package Name' ? null : item?.package_line?.length > 0 ? item?.package_line?.map((pack, packIndex) => {
                                                            return (
                                                                <TableRow key={packIndex}>
                                                                    <TableCell sx={{ borderBottom: 'none', pl: '0rem', pr: '0rem' }}>
                                                                        <Box visibility={'hidden'}>{'-'}</Box>
                                                                        {item?.billing_display === 'Assorted Service Head' ? null : pack?.service_data?.length > 0 ? pack?.service_data?.map((service, serviceIndex) => {
                                                                            return (
                                                                                <TableRow key={serviceIndex}>
                                                                                    <TableCell sx={{ borderBottom: 'none', pl: '0rem', pr: '0rem' }}>
                                                                                        {CommonValidation.formatAmount(service?.service_with_gst_total_amt || '')}
                                                                                    </TableCell>
                                                                                </TableRow>
                                                                            )
                                                                        }) : null}
                                                                    </TableCell>
                                                                </TableRow>
                                                            )
                                                        }) : null}
                                                    </TableCell>
                                                </> : null}
                                            <TableCell className='billing_tbl_body' align='center'>
                                                <Box display={'flex'} justifyContent={'center'} sx={{ visibility: getCachevalue('BillType') === 'Cancel' ? "hidden" : "visible"}}>
                                                    <IconButton sx={{ height: '1.5dvw', width: '1.5dvw', visibility: getCachevalue('BillType') === 'Cancel' ? "hidden" : (item?.billing_display === 'Package Name' || item?.billing_display === 'Assorted Package Name') ? 'visible' : 'hidden' }}
                                                        onClick={() => { onEditHandler(item, index, null, null) }}
                                                    ><EditIcon color='primary' sx={{ height: '1.3dvw', width: '1.3dvw' }} /></IconButton>
                                                    {(requestState.fromApprover || requestState?.fromBillConvert) ? null : <IconButton sx={{ height: '1.5dvw', width: '1.5dvw' }} disabled={billing.isEdit}
                                                        onClick={() => {
                                                            setBilling((prev) => {
                                                                let billingList = [...prev.billingList]
                                                                let cancelId = [];
                                                                billingList?.map(item => item?.package_line?.map(pack => pack?.service_data?.map(ser => cancelId?.push(ser?.id))))
                                                                billingList?.splice(index, 1)
                                                                return {
                                                                    ...prev, billingList, cancelled_ids: [...billing.cancelled_ids, ...cancelId], overallDiscount: {
                                                                        discount_amount: '', discount_percentage: '', discount_percentage_w_r: ''
                                                                    }
                                                                }
                                                            })
                                                        }}
                                                    ><DeleteForeverIcon color={billing.isEdit ? 'disabled' : 'error'} sx={{ height: '1.3dvw', width: '1.3dvw' }} /></IconButton>}
                                                </Box>
                                                {item?.billing_display === 'Package Name' || item?.billing_display === 'Assorted Package Name' || getCachevalue('BillType') === 'Cancel' ? null : item?.package_line?.length > 0 ? item?.package_line?.map((pack, packIndex) => {
                                                    return (
                                                        <TableRow key={packIndex}>
                                                            <TableCell sx={{ borderBottom: 'none', p: '0.3rem 0rem' }} align='center' width={'10.5%'}>
                                                                <Box display={'flex'} justifyContent={'center'} visibility={item?.package_type === 'Package' || getCachevalue('BillType') === 'Cancel' ? 'hidden' : 'visible'}>
                                                                    <IconButton sx={{ height: '1.5dvw', width: '1.5dvw', visibility: (item?.billing_display === 'Assorted Service Head') ? 'visible' : 'hidden' }}
                                                                        onClick={() => { onEditHandler(pack, index, packIndex, null) }}
                                                                    ><EditIcon color='primary' sx={{ height: '1.3dvw', width: '1.3dvw' }} /></IconButton>
                                                                    {(requestState.fromApprover || requestState?.fromBillConvert) ? null : <IconButton sx={{ height: '1.5dvw', width: '1.5dvw', visibility: item?.package_line?.length === 1 ? 'hidden' : 'visible' }}
                                                                        disabled={billing.isEdit}
                                                                        onClick={() => {
                                                                            setBilling((prev) => {
                                                                                let billingList = [...prev.billingList]
                                                                                let cancelId = [];
                                                                                billingList[index]['package_line'][packIndex]?.service_data?.map(ser => cancelId?.push(ser?.id))
                                                                                billingList[index]['package_line']?.splice(packIndex, 1)
                                                                                return {
                                                                                    ...prev, billingList, cancelled_ids: [...billing.cancelled_ids, ...cancelId], overallDiscount: {
                                                                                        discount_amount: '', discount_percentage: '', discount_percentage_w_r: ''
                                                                                    }
                                                                                }
                                                                            })
                                                                        }}
                                                                    ><DeleteForeverIcon color={billing.isEdit ? 'disabled' : 'error'} sx={{ height: '1.3dvw', width: '1.3dvw' }} /></IconButton>}
                                                                </Box>
                                                                {item?.billing_display === 'Assorted Service Head' ? null : pack?.service_data?.length > 0 ? pack?.service_data?.map((service, serviceIndex) => {
                                                                    return (
                                                                        <TableRow key={serviceIndex}>
                                                                            <TableCell sx={{ borderBottom: 'none', p: '0.3rem 0rem' }} align='center' width={'10.5%'}>
                                                                                <Box display={'flex'} justifyContent={'center'} sx={{ visibility: getCachevalue('BillType') === 'Cancel' ? "hidden" : "visible"}}>
                                                                                    <IconButton sx={{ height: '1.5dvw', width: '1.5dvw' }}
                                                                                        disabled={(requestState?.fromApprover && !requestState.modifyApprover)} onClick={() => onEditHandler(service, index, packIndex, serviceIndex)}
                                                                                    ><EditIcon color={(requestState?.fromApprover && !requestState.modifyApprover) ? 'disabled' : 'primary'} sx={{ height: '1.3dvw', width: '1.3dvw' }} /></IconButton>
                                                                                    {(requestState.fromApprover || requestState?.fromBillConvert) ? null : <IconButton sx={{ height: '1.5dvw', width: '1.5dvw', visibility: pack?.service_data?.length === 1 ? 'hidden' : 'visible' }}
                                                                                        disabled={billing.isEdit || (requestState?.fromApprover && !requestState.modifyApprover)}
                                                                                        onClick={() => {
                                                                                            setBilling((prev) => {
                                                                                                let billingList = [...prev.billingList]
                                                                                                let cancelId = [];
                                                                                                cancelId?.push(billingList[index]['package_line'][packIndex]['service_data'][serviceIndex]?.id)
                                                                                                billingList[index]['package_line'][packIndex]['service_data']?.splice(serviceIndex, 1)
                                                                                                return {
                                                                                                    ...prev, billingList, cancelled_ids: [...billing.cancelled_ids, ...cancelId], overallDiscount: {
                                                                                                        discount_amount: '', discount_percentage: '', discount_percentage_w_r: ''
                                                                                                    }
                                                                                                }
                                                                                            })
                                                                                        }}
                                                                                    ><DeleteForeverIcon color={billing.isEdit || (requestState?.fromApprover && !requestState.modifyApprover) ? 'disabled' : 'error'} sx={{ height: '1.3dvw', width: '1.3dvw' }} /></IconButton>}
                                                                                </Box>
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    )
                                                                }) : null}
                                                            </TableCell>
                                                        </TableRow>
                                                    )
                                                }) : null}
                                            </TableCell>
                                        </TableRow>
                                    )
                                } else {
                                    return (
                                        <TableRow key={index} sx={{ backgroundColor: isDuplicate ? '#d2f7f1' : 'white' }}>
                                            <TableCell className='billing_tbl_body'>
                                                {doctorName ? doctorName?.length > 12 ?
                                                    <Tooltip placement='top' title={doctorName}>
                                                        <Typography sx={{ fontSize: COMMON_STYLES.FONT_SIZE_MD }}>{doctorName?.slice(0, 12) + '...'}</Typography>
                                                    </Tooltip> : <Typography sx={{ fontSize: COMMON_STYLES.FONT_SIZE_MD }}>{doctorName}</Typography> : '-'}
                                            </TableCell>
                                            <TableCell className='billing_tbl_body'>
                                                {serviceName?.length > 25 ?
                                                    <Tooltip placement='top' title={serviceName}>
                                                        <Typography sx={{ fontSize: COMMON_STYLES.FONT_SIZE_MD }}>{serviceName?.slice(0, 25) + '...'}</Typography>
                                                    </Tooltip> : <Typography sx={{ fontSize: COMMON_STYLES.FONT_SIZE_MD }}>{serviceName}</Typography>}
                                                {item?.op_order_number ? item?.op_order_number?.length > 25 ?
                                                    <Tooltip placement='top' title={item?.op_order_number}>
                                                        <Typography sx={{ fontSize: COMMON_STYLES.FONT_SIZE_MD }}>{item?.op_order_number?.slice(0, 25) + '...'}</Typography>
                                                    </Tooltip> : <Typography sx={{ fontSize: COMMON_STYLES.FONT_SIZE_MD }}>{`${item?.op_order_number}`}</Typography> : ''}
                                            </TableCell>
                                            {/* <TableCell className='billing_tbl_body'>{item?.op_order_number || '-'}</TableCell> */}
                                            <TableCell className='billing_tbl_body'>{item?.unit || 1}</TableCell>
                                            <TableCell className='billing_tbl_body'>{CommonValidation.formatAmount(item?.rate_per_unit || '')}</TableCell>
                                            <TableCell className='billing_tbl_body'>{CommonValidation.formatAmount(item?.concession_amt || '')}</TableCell>
                                            <TableCell className='billing_tbl_body'>{CommonValidation.formatAmount(item?.total_with_discount || '')}</TableCell>
                                            {loginInfo?.is_gst_enabled ?
                                                <><TableCell className='billing_tbl_body'>{item?.gst_percent}</TableCell>
                                                    <TableCell className='billing_tbl_body'>{CommonValidation.formatAmount(item?.service_with_gst_total_amt || '')}</TableCell></> : null}
                                            <TableCell align='center' className='billing_tbl_body'>
                                                <Box component={'div'} sx={{ visibility: getCachevalue('BillType') === 'Cancel' ? "hidden" : "visible" }}>
                                                    <IconButton sx={{ width: '2dvw', height: '2dvw' }} disabled={(requestState?.fromApprover && !requestState.modifyApprover)}
                                                        onClick={() => { onEditHandler(item, index) }}
                                                    ><EditIcon
                                                            color={(requestState?.fromApprover && !requestState.modifyApprover) ? 'disabled' : 'primary'}
                                                            sx={{ width: '1.5dvw', height: '1.5dvw' }}
                                                        /></IconButton>
                                                    {(requestState.fromApprover || requestState?.fromBillConvert) ? null : <IconButton sx={{ width: '2dvw', height: '2dvw' }}
                                                        disabled={billing.isEdit || (requestState?.fromApprover && !requestState.modifyApprover) ? true : false}
                                                        onClick={() => {
                                                            setBilling((prev) => ({
                                                                ...prev,
                                                                openDeletePopup: true,
                                                                deleted_service: item,
                                                                deletedIndex: index
                                                            }))
                                                        }}
                                                    ><DeleteForeverIcon
                                                            color={billing.isEdit || (requestState?.fromApprover && !requestState.modifyApprover) ? 'disabled' : 'error'}
                                                            sx={{ width: '1.5dvw', height: '1.5dvw' }}
                                                        /></IconButton>}
                                                </Box>
                                            </TableCell>
                                        </TableRow>
                                    )
                                }
                            }) : <TableRow>
                                <TableCell colSpan={9} align='center'
                                    sx={{ borderBottom: 'none', position: 'relative', top: '10rem' }}
                                >No Records To Be Shown</TableCell>
                            </TableRow>}
                        </TableBody>
                    </Table>
                </Box>
                <Box visibility={(getCachevalue('BillType') === 'Cancel' || !(billing.patientData?.patient_id)) ? 'hidden' : 'visible'}
                    component={'div'} mt={'0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} pb={'0.5rem'}
                    tabIndex={0}
                    data-billing-container
                    sx={{
                        outline: 'none',
                        '&:focus': {
                            outline: 'none',
                        },
                        '&:focus-visible': {
                            outline: 'none',
                        },
                    }}
                    onKeyDownCapture={(e) => {
                        if (e.key === 'Enter' && billing?.selected_service && !(requestState?.fromApprover && !requestState.modifyApprover)) {
                            e.preventDefault();
                            if (billing?.selected_service?.autobilling_type === "yearly") {
                                setAnnualFeeAlert(true)
                            } else {
                                onAddHandler()
                            }
                        }
                    }}
                >
                    <Autocomplete
                        disabled={((Object.keys(billing.patientData)?.length === 0 || billing.isEdit) ? true : false)}
                        size='small'
                        sx={{ width: '12dvw' }}
                        options={billing.billDocSugg}
                        getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.doctor_name}
                        value={billing.selected_bill_doc}
                        onChange={(e, newValue) => {
                            if (newValue) {
                                setBilling((prev) => {
                                    const updatedBilling = { ...prev, selected_bill_doc: newValue };
                                    let module = ''
                                    if (window.location.pathname === '/OPHome/Billing/NewQuickBilling') {
                                        module = loginInfo?.module_name === 'Laboratory' ? 'LAB' : loginInfo?.module_name === 'Radiology' ? 'RADIOLOGY' : loginInfo?.module_name === 'Investigation' ? GetInvestigationName() : 'op'
                                    } else {
                                        module = loginInfo?.module_name === 'Laboratory' ? 'LAB' : loginInfo?.module_name === 'Radiology' ? 'RADIOLOGY' : loginInfo?.module_name === 'Investigation' ? GetInvestigationName() : billing.patientData?.appointment_id ? 'op' : 'self'
                                    }
                                    getServiceListData(newValue?.doctor_id ?? 'all', null, billing.patientData?.appointment_id, module)
                                    if (billing.patientData?.employer_id && newValue?.doctor_id)
                                        getCorporateServiceData(newValue?.doctor_id, billing.patientData?.patient_type, billing.patientData?.employer_id);
                                    return updatedBilling;
                                });
                            } else {
                                setBilling((prev) => ({
                                    ...prev,
                                    serviceSugg: [],
                                    selected_bill_doc: null,
                                    selected_bill_doc_id: null,
                                }))
                                clearService()
                            }
                        }}
                        renderInput={(params) => <TextField
                            {...params}
                            label='Bill Doctor'
                            InputProps={{
                                ...params.InputProps, emed_tid: 'Bl_doc',
                            }}
                        />}
                    />

                    <Autocomplete
                        size='small'
                        sx={{ width: '16dvw' }}
                        disabled={(billing.isEdit ? true : false) || (!!billing.selected_bill_doc ? false : true) || (requestState.fromApprover)}
                        options={billing.serviceSugg}
                        getOptionLabel={(option) => typeof (option) === 'string' ? option : `${(option?.service_head ?? option?.service_head_name) && option?.service_head_code ? `${option?.service_head ?? option?.service_head_name} (${option?.service_head_code})` : option?.service_head ?? option?.service_head_name} - ${option?.service_name && option?.service_code ? `${option?.service_name} (${option?.service_code})` : option?.service_name}`}
                        value={billing.selected_service}
                        onChange={(e, newValue) => {
                            if (newValue) {
                                onSelectServiceHandler(newValue); setsearchKey('');
                            } else {
                                clearService()
                            }
                        }}
                        onInputChange={(event, newInputValue) => {
                            if (newInputValue?.length >= 3) {
                                // Call your API here with the search key
                                setsearchKey(newInputValue);
                            }
                        }}
                        renderInput={(params) => <TextField
                            {...params}
                            label='Search Service'
                            InputProps={{
                                ...params.InputProps, emed_tid: 'ser_sear',
                            }}
                        />}
                        componentsProps={{ popper: { style: { width: '30dvw' } } }}
                        renderOption={(props, item) => {
                            const serviceName = item.service_head && item.service_head_code
                                ? `${item.service_head} (${item.service_head_code})`
                                : item.service_head || '';
                            const serName = item.service_name && item.service_code
                                ? `${item.service_name} (${item.service_code})`
                                : `${item.service_name || ''}`;
                            const displayName = `${serviceName} ${serName}`
                            let depart = item?.module_type === "IP_OP" ? 'IP & OP' : item?.module_type
                            return (
                                <Box {...props} key={item?.id} >
                                    <Box sx={{ display: 'flex', flexDirection: 'column', alignContent: "flex-start" }}>

                                        {(loginInfo?.module_name === 'Laboratory') || (loginInfo?.module_name === 'Radiology') || (loginInfo?.module_name === 'Investigation') ?
                                            <>
                                                <Box display={'flex'}>
                                                    {serName?.length > 80 ?
                                                        <Tooltip placement='top' title={serName}>
                                                            <Typography sx={{ fontSize: "0.9vw", fontWeight: 600 }}>{serName?.slice(0, 77) + '... '}</Typography>
                                                        </Tooltip> : <Typography sx={{ fontSize: "0.9vw", fontWeight: 600 }}>{serName + ' '}</Typography>}
                                                </Box>
                                                {serviceName?.length > 80 ?
                                                    <Tooltip placement='top' title={serviceName}>
                                                        <Typography sx={{ fontSize: "0.8vw" }}>{serviceName?.slice(0, 77) + '...'}</Typography>
                                                    </Tooltip> : <Typography sx={{ fontSize: "0.8vw" }}>{serviceName}</Typography>}
                                            </> :
                                            <>
                                                <Box sx={{ display: 'flex', width: '100%', overflow: 'hidden' }}>
                                                    {/* display Name */}
                                                    <Tooltip title={displayName} arrow>
                                                        <Typography>
                                                            {displayName.length > 58 ? serviceName.length > 58 ?
                                                                (<span
                                                                    style={{
                                                                        fontSize: "0.9vw",
                                                                        fontWeight: 600,
                                                                        whiteSpace: 'nowrap',
                                                                    }}
                                                                >{`${serviceName.slice(0, 55)}...`}</span>) :
                                                                (<><span
                                                                    style={{
                                                                        fontSize: "0.9vw",
                                                                        fontWeight: 600,
                                                                        whiteSpace: 'nowrap',
                                                                    }}
                                                                >{serviceName}</span>
                                                                    <span
                                                                        style={{
                                                                            fontSize: "0.9vw",
                                                                            whiteSpace: 'nowrap',
                                                                        }}
                                                                    >{`- ${serName.slice(0, (55 - (serviceName.length)))}...`}</span></>) :
                                                                (<><span
                                                                    style={{
                                                                        fontSize: "0.9vw",
                                                                        fontWeight: 600,
                                                                        whiteSpace: 'nowrap',
                                                                    }}
                                                                >{serviceName}</span> -
                                                                    <span
                                                                        style={{
                                                                            fontSize: "0.9vw",
                                                                            whiteSpace: 'nowrap',
                                                                        }}
                                                                    >{serName}</span></>)
                                                            }
                                                        </Typography>
                                                    </Tooltip>
                                                </Box>

                                                {/* Department */}
                                                <Tooltip title={depart} arrow>
                                                    <Typography
                                                        sx={{
                                                            fontSize: "0.9vw",
                                                            fontWeight: 600,
                                                            whiteSpace: 'nowrap',
                                                        }}
                                                    >
                                                        {depart}
                                                    </Typography>
                                                </Tooltip>
                                            </>
                                        }
                                    </Box>
                                </Box>
                            )
                        }}
                    />

                    {billing?.service_data?.unit_type === 'Hrs' ?
                    // {billing.service_data?.module_type === 'LAB' || billing.service_data?.module_type === 'RADIOLOGY' || billing.service_data?.module_type === 'Investigation' ? null : billing?.service_data?.unit_type === 'Hrs' ?
                        <Box component={'div'}
                            border={'1px solid lightgray'} borderRadius={'5px'} height={'5.3dvh'}
                            display={'flex'} alignItems={'center'} justifyContent={'space-evenly'} width={'6dvw'}>
                            <Button
                                disabled={!billing?.service_data?.edit_unit || !['OP', 'IP_OP', 'LAB', 'RADIOLOGY']?.includes(billing.service_data?.module_type)}
                                sx={{ textTransform: 'capitalize' }}
                                endIcon={<AccessTimeIcon />}
                                onClick={() => { onOpenPopupHandler('time') }}
                            >{`${billing?.service_data?.unit?.length > 5 ? billing?.service_data.unit?.slice(0, 5) : billing?.service_data?.unit}`}</Button>
                        </Box> :
                        <Box component={'div'}
                            border={'1px solid lightgray'} borderRadius={'5px'} height={'5.3dvh'}
                            display={'flex'} alignItems={'center'} justifyContent={'space-evenly'} width={'6dvw'}>
                            <IconButton
                                sx={{ height: '4.5dvh', width: '2dvw' }}
                                disabled={(+billing?.service_data?.unit === 1) || !billing?.service_data?.edit_unit || !['OP', 'IP_OP', 'LAB', 'RADIOLOGY']?.includes(billing.service_data?.module_type)}
                                onClick={() => onClickUnitHandler('decrease')}
                            ><RemoveIcon color={(billing?.service_data?.unit === 1 || !billing?.service_data?.edit_unit || !['OP', 'IP_OP', 'LAB', 'RADIOLOGY']?.includes(billing.service_data?.module_type)) ? 'disabled' : 'primary'} /></IconButton>
                            <Typography fontSize={COMMON_STYLES.FONT_SIZE_L} fontWeight={COMMON_STYLES.FONT_WEIGHT}>{billing?.service_data?.unit}</Typography>
                            <IconButton
                                disabled={!billing?.service_data?.edit_unit || !['OP', 'IP_OP', 'LAB', 'RADIOLOGY']?.includes(billing.service_data?.module_type)}
                                sx={{ height: '4.5dvh', width: '2dvw' }}
                                onClick={() => onClickUnitHandler('increase')}
                            ><AddIcon color={(!billing?.service_data?.edit_unit || !['OP', 'IP_OP', 'LAB', 'RADIOLOGY']?.includes(billing.service_data?.module_type)) ? 'disabled' : 'primary'} /></IconButton>
                        </Box>}

                    {(!!billing?.service_data?.doctor_amt || !!billing?.service_data?.hospital_amt || !!billing?.service_data?.is_sharable) ?
                        <Button className='Common_Btn_Min_Width' sx={{ textTransform: 'capitalize' }}
                            disabled={!billing?.service_data?.edit_amount}
                            endIcon={`(${CommonValidation.formatAmount(billing?.service_data?.rate_per_unit)})`}
                            onClick={() => onOpenPopupHandler('rate')}
                        >Rate/Unit</Button> :
                        <TextField
                            autoComplete='off'
                            size='small'
                            InputProps={{ emed_tid: 'rte_unit', readOnly: !billing?.service_data?.edit_amount }}
                            sx={{ width: '7dvw' }}
                            label='Rate/Unit'
                            value={billing?.service_data?.rate_per_unit}
                            onChange={(e) => { withOutShareHandler(e, 'rate_per_unit') }}
                        />}

                    <Box component={'div'} display={'flex'}>
                        {!!billing?.service_data?.doctor_amt || !!billing?.service_data?.hospital_amt ?
                            <Button className='Common_Btn_Min_Width' sx={{ textTransform: 'capitalize' }}
                                disabled={!billing?.service_data?.edit_discount}
                                endIcon={`(${CommonValidation.formatAmount(billing?.service_data?.concession_amt)})`}
                                onClick={() => onOpenPopupHandler('concession')}
                            >Concession</Button>
                            :
                            <><TextField
                                disabled={!billing?.service_data?.edit_discount || billing?.service_data?.membership_discount_percentage}
                                autoComplete='off'
                                size='small'
                                InputProps={{ emed_tid: 'con_amt' }}
                                sx={{ width: '7dvw' }}
                                label={`Concession (${CurrencySymbol})`}
                                value={+billing?.service_data?.concession_amt ? billing?.service_data?.concession_amt : ""}
                                onChange={(e) => { withOutShareHandler(e, 'concession_discount_amt') }}
                            />
                                <TextField
                                    disabled={!billing?.service_data?.edit_discount || billing?.service_data?.membership_discount_percentage}
                                    autoComplete='off'
                                    size='small'
                                    InputProps={{ emed_tid: 'con_per' }}
                                    sx={{ width: '7dvw' }}
                                    label={`Concession (%)`}
                                    value={+billing?.service_data?.concession_percent_w_r ? billing?.service_data?.concession_percent_w_r : ""}
                                    onChange={(e) => { withOutShareHandler(e, 'concession_discount_percent') }}
                                /></>}
                    </Box>

                    <Box component={'div'}>
                        <TextField
                            size='small'
                            sx={{ width: '7dvw' }}
                            value={billing?.service_data?.total_amt ? CommonValidation.formatAmount((+billing?.service_data?.total_amt) - (+billing?.service_data?.concession_amt)) : ''}
                            InputProps={{ emed_tid: 'tlt', readOnly: true }}
                            label='Total'
                        />
                    </Box>

                    <IconButton
                        disabled={(billing?.selected_service === null || (requestState?.fromApprover && !requestState.modifyApprover)) ? true : false}
                        sx={{ height: '2dvw', width: '2.5dvw' }}
                        onClick={() => {
                            if (billing?.selected_service?.autobilling_type === "yearly") {
                                setAnnualFeeAlert(true)
                            } else {
                                onAddHandler()
                            }
                        }}
                    ><AddBoxIcon sx={{ height: '2dvw', width: '2.5dvw' }} color={(billing?.selected_service === null || (requestState?.fromApprover && !requestState.modifyApprover)) ? 'disabled' : 'primary'} /></IconButton>
                </Box>
            </Box>
        )
    }

    useEffect(() => {
        let ModuleName = ''
        if (window.location.pathname === '/OPHome/Billing/NewQuickBilling') {
            ModuleName = loginInfo?.module_name === 'Laboratory' ? 'LAB' : loginInfo?.module_name === 'Radiology' ? 'RADIOLOGY' : 'op'
        } else {
            ModuleName = loginInfo?.module_name === 'Laboratory' ? 'LAB' : loginInfo?.module_name === 'Radiology' ? 'RADIOLOGY' :
                props.patientData?.appointment_id ? 'op' : 'self'
        }
        const handler = setTimeout(() => {
            if (ServiceCount && searchKey?.length >= 3) {
                getServiceListData(null, null, null, ModuleName, searchKey);
            } else if (ServiceCount && !searchKey) {
                setBilling((prev) => ({ ...prev, serviceSugg: [] }))
            }
        }, 500); // 500ms debounce

        return () => clearTimeout(handler); // Cleanup on new keystroke
    }, [searchKey, ServiceCount]);

    const cashTextBox = (key, values, label, Icon) => {
        return (
            <TextField
                size='small'
                sx={{ width: '10dvw', mt: '0.5rem' }}
                value={values}
                label={`${label} (${CurrencySymbol})`}
                onChange={(e) => onChangeHandler(e, key)}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <img src={Icon} alt={label} className='eMed_action_img_small' />
                        </InputAdornment>
                    ),
                }}
            />
        )
    }

    const referenceTextBox = (key, values) => {
        return (
            <TextField
                size='small'
                sx={{ width: '13dvw', mt: '0.5rem', ml: '0.5rem' }}
                value={values}
                label={'Reference Number'}
                onChange={(e) => onChangeHandler(e, key)}
                InputProps={{ emed_tid: key }}
            />
        )
    }

    const handleCheckBox = (e, key) => {
        try {
            let checked = e.target.checked
            setBilling((prev) => ({
                ...prev,
                [key]: checked,
                cash_amt: key === "isCash" && !checked ? '' : prev.cash_amt,
                card_amt: key === "isCard" && !checked ? '' : prev.card_amt,
                upi_amt: key === "isUpi" && !checked ? '' : prev.upi_amt,
                bank_amt: key === "isBank" && !checked ? '' : prev.bank_amt,
                cheque_amt: key === "isCheque" && !checked ? '' : prev.cheque_amt,
                card_no: key === "isCard" && !checked ? '' : prev.card_no,
                bank_no: key === "isBank" && !checked ? '' : prev.bank_no,
                cheque_no: key === "isCheque" && !checked ? '' : prev.cheque_no,
                upi_no: key === "isUpi" && !checked ? '' : prev.upi_no
            }))
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const showCashTextBox = () => {
        return (
            <Box component={'div'}>
                <Box component={'div'}>
                    <FormControlLabel control={<Checkbox size='small' checked={billing?.isCash} onChange={(e) => handleCheckBox(e, 'isCash')} />} label={<Typography fontSize={COMMON_STYLES.FONT_SIZE_L}>Cash</Typography>} />
                    <FormControlLabel control={<Checkbox size='small' checked={billing?.isCard} onChange={(e) => handleCheckBox(e, 'isCard')} />} label={<Typography fontSize={COMMON_STYLES.FONT_SIZE_L}>Card</Typography>} />
                    <FormControlLabel control={<Checkbox size='small' checked={billing?.isUPI} onChange={(e) => handleCheckBox(e, 'isUPI')} />} label={<Typography fontSize={COMMON_STYLES.FONT_SIZE_L}>UPI</Typography>} />
                    <FormControlLabel control={<Checkbox size='small' checked={billing?.isBank} onChange={(e) => handleCheckBox(e, 'isBank')} />} label={<Typography fontSize={COMMON_STYLES.FONT_SIZE_L}>Bank</Typography>} />
                    <FormControlLabel control={<Checkbox size='small' checked={billing?.isCheque} onChange={(e) => handleCheckBox(e, 'isCheque')} />} label={<Typography fontSize={COMMON_STYLES.FONT_SIZE_L}>Cheque</Typography>} />
                </Box>
                <Box component={'div'}>
                    {billing?.isCash ? cashTextBox('cash_amt', billing?.cash_amt, 'Cash Amount', ImagePaths.CashIcon.default) : null}
                    {billing?.isCard ?
                        <Box component={'div'} display={'flex'}>
                            {cashTextBox('card_amt', billing?.card_amt, 'Card Amount', ImagePaths.CardIcon.default)}
                            {referenceTextBox('card_no', billing?.card_no)}
                        </Box> : null}
                    {billing?.isUPI ?
                        <Box component={'div'} display={'flex'}>
                            {cashTextBox('upi_amt', billing?.upi_amt, 'UPI Amount', ImagePaths.UPIIcon.default)}
                            {referenceTextBox('upi_no', billing?.upi_no)}
                        </Box> : null}
                    {billing?.isBank ?
                        <Box component={'div'} display={'flex'}>
                            {cashTextBox('bank_amt', billing?.bank_amt, 'Bank Amount', ImagePaths.BankTransferIcon.default)}
                            {referenceTextBox('bank_no', billing?.bank_no)}
                        </Box> : null}
                    {billing?.isCheque ?
                        <Box component={'div'} display={'flex'}>
                            {cashTextBox('cheque_amt', billing?.cheque_amt, 'Cheque Amount', ImagePaths.ChequeIcon.default)}
                            {referenceTextBox('cheque_no', billing?.cheque_no)}
                        </Box> : null}
                </Box>
            </Box>
        )
    }

    const billingCalculation = useCallback((list = billing.billingList) => {
        try {
            const calData = list?.reduce((acc, element) => {
                if (element.package_type === 'Package' || element.package_type === "Assorted") {
                    if (element.billing_display === 'Assorted Package Name' || element.billing_display === 'Package Name') {
                        let { service_with_gst_total_amt, taxable_amount, gst_amount, sgst_amount, cgst_amount, concession_applicable } = element
                        // acc.sub_total += +element.sub_total_amount;
                        acc.sub_total += element.total_with_discount || 0
                        acc.actual_sub_total_amount += +element?.sub_total_amount
                        // acc.sub_total += (service_with_gst_total_amt ? (+service_with_gst_total_amt) : 0);
                        acc.taxable_amount += (taxable_amount ? (+taxable_amount) : 0);
                        acc.gst_amount += (gst_amount ? (+gst_amount) : 0);
                        acc.sgst_amount += (sgst_amount ? (+sgst_amount) : 0);
                        acc.cgst_amount += +(cgst_amount ? (+cgst_amount) : 0);
                        acc.concession_applicable += (+element.concession_applicable);
                        let tax = taxable_amount ? taxable_amount : 0
                        let gst = gst_amount ? gst_amount : 0
                        acc.payable_amt += ((+tax) + (+gst));
                    } else if (element.billing_display === 'Assorted Service Head') {
                        element?.package_line?.forEach(pack => {
                            let { service_with_gst_total_amt, taxable_amount, gst_amount, sgst_amount, cgst_amount, concession_applicable } = pack

                            // acc.sub_total += +element.sub_total_amount;
                            acc.sub_total += pack.total_with_discount || 0
                            acc.actual_sub_total_amount += +pack?.sub_total_amount
                            // acc.sub_total += (service_with_gst_total_amt ? (+service_with_gst_total_amt) : 0);
                            acc.taxable_amount += (taxable_amount ? (+taxable_amount) : 0);
                            acc.gst_amount += (gst_amount ? (+gst_amount) : 0);
                            acc.sgst_amount += (sgst_amount ? (+sgst_amount) : 0);
                            acc.cgst_amount += +(cgst_amount ? (+cgst_amount) : 0);
                            acc.concession_applicable += (+pack.concession_applicable);
                            let tax = taxable_amount ? taxable_amount : 0
                            let gst = gst_amount ? gst_amount : 0
                            acc.payable_amt += ((+tax) + (+gst));
                        })
                    } else if (element.billing_display === 'Service Head' || element.billing_display === 'Service Name') {
                        element?.package_line?.forEach(pack => {
                            pack?.service_data?.forEach(service => {
                                let { service_with_gst_total_amt, taxable_amount, gst_amount, sgst_amount, cgst_amount, concession_applicable } = service
                                // acc.sub_total += +element.sub_total_amount;
                                acc.sub_total += service.total_with_discount || 0
                                acc.actual_sub_total_amount += +service?.sub_total_amount
                                // acc.sub_total += (service_with_gst_total_amt ? (+service_with_gst_total_amt) : 0);
                                acc.taxable_amount += (taxable_amount ? (+taxable_amount) : 0);
                                acc.gst_amount += (gst_amount ? (+gst_amount) : 0);
                                acc.sgst_amount += (sgst_amount ? (+sgst_amount) : 0);
                                acc.cgst_amount += +(cgst_amount ? (+cgst_amount) : 0);
                                acc.concession_applicable += (+concession_applicable);
                                let tax = taxable_amount ? taxable_amount : 0
                                let gst = gst_amount ? gst_amount : 0
                                acc.payable_amt += ((+tax) + (+gst));
                            })
                        })
                    }
                } else {
                    let { service_with_gst_total_amt, taxable_amount, gst_amount, sgst_amount, cgst_amount, concession_applicable } = element
                    // acc.sub_total += +element.sub_total_amount;
                    acc.sub_total += element.total_with_discount || 0
                    acc.actual_sub_total_amount += +element?.sub_total_amount
                    // acc.sub_total += (service_with_gst_total_amt ? (+service_with_gst_total_amt) : 0);
                    acc.taxable_amount += (taxable_amount ? (+taxable_amount) : 0);
                    acc.gst_amount += (gst_amount ? (+gst_amount) : 0);
                    acc.sgst_amount += (sgst_amount ? (+sgst_amount) : 0);
                    acc.cgst_amount += +(cgst_amount ? (+cgst_amount) : 0);
                    acc.concession_applicable += (+element.concession_applicable);
                    let tax = taxable_amount ? taxable_amount : 0
                    let gst = gst_amount ? gst_amount : 0
                    acc.payable_amt += ((+tax) + (+gst));
                }

                return acc;
            }, {
                sub_total: 0,
                round_off: 0, payable_amt: 0, taxable_amount: 0,
                gst_amount: 0, sgst_amount: 0, cgst_amount: 0, net_amount: 0, round_off: 0,
                concession_applicable: 0, actual_sub_total_amount: 0
            }) || {};
            calData.sub_total = +CommonValidation.formatAmount(calData.sub_total) || 0
            calData.taxable_amount = +CommonValidation.formatAmount(calData.taxable_amount)
            calData.gst_amount = +CommonValidation.formatAmount(calData.gst_amount)
            calData.sgst_amount = +CommonValidation.formatAmount(calData.sgst_amount)
            calData.cgst_amount = +CommonValidation.formatAmount(calData.cgst_amount)
            calData.concession_applicable = +CommonValidation.formatAmount(calData.concession_applicable)
            calData.actual_sub_total_amount = +CommonValidation.formatAmount(calData.actual_sub_total_amount)
            let finalPay = (calData.payable_amt - (+billing.overallDiscount.discount_amount))
            calData.round_off = Math.round(finalPay) - finalPay
            calData.payable_amt = Math.round(finalPay)
            if (list?.length) {
                setBilling((prev) => ({ ...prev, overall_data: { ...prev.overall_data, ...calData } }));
            }
            return calData;
        } catch (error) {
            errorMessage(error.message);
        }
    }, [billing.billingList]);

    useEffect(() => {
        if (billing.billingList && billing.billingList?.length > 0) {
            billingCalculation();
        }

        if (billing.billingList?.length === 0) {
            setBilling((prev) => ({
                ...prev,
                overall_data: {
                    ...prev.overall_data,
                    sub_total: 0, round_off: 0, payable_amt: 0, taxable_amount: 0,
                    gst_amount: 0, sgst_amount: 0, cgst_amount: 0, net_amount: 0, round_off: 0,
                    concession_applicable: 0
                }
            }))
        }
    }, [billing.billingList, billingCalculation])

    const onChangeHandler = (e, key) => {
        try {
            let value = e.target.value
            setBilling((prev) => {
                switch (key) {
                    case 'cash_amt':
                    case 'card_amt':
                    case 'upi_amt':
                    case 'bank_amt':
                    case 'cheque_amt':
                        if (CommonValidation.numberOnly(value) && +value <= +billing.overall_data.payable_amt || value === '') {
                            return { ...prev, [key]: value }
                        } else {
                            return { ...prev }
                        }
                    default:
                        return { ...prev, [key]: value }
                }
            })
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const FullAmountEntered = () => {
        try {
            let CashAmt = billing.cash_amt === "" ? 0 : +billing.cash_amt;
            let CardAmt = billing.card_amt === "" ? 0 : +billing.card_amt;
            let UPIAmt = billing.upi_amt === "" ? 0 : +billing.upi_amt;
            let bankTransferAmt = billing.bank_amt === "" ? 0 : +billing.bank_amt;
            let ChequeAmt = billing.cheque_amt === "" ? 0 : +billing.cheque_amt;
            let checkPayMethod = billing.isCash || billing.isCard || billing.isUPI || billing.isBank || billing.isCheque
            if (checkPayMethod && (CashAmt + CardAmt + UPIAmt + bankTransferAmt + ChequeAmt) === +billing.overall_data.payable_amt && (+billing.overall_data.payable_amt !== 0)) {
                let isTxnValid = checkTransationMandatory() ? (
                    (CardAmt === 0 || billing.card_no !== "") &&
                    (UPIAmt === 0 || billing.upi_no !== "") &&
                    (bankTransferAmt === 0 || billing.bank_no !== "") &&
                    (ChequeAmt === 0 || billing.cheque_no !== "")
                ) : true
                return isTxnValid;
                // if (
                //     (CardAmt === 0 || billing.card_no !== "") &&
                //     (UPIAmt === 0 || billing.upi_no !== "") &&
                //     (bankTransferAmt === 0 || billing.bank_no !== "") &&
                //     (ChequeAmt === 0 || billing.cheque_no !== "")
                // ) {
                //     return true
                // }
            } else {
                return false
            }
        }
        catch (e) {
            return false
        }
    }

    const checkButtonDisable = () => {
        if (!hasDuplicate) {
            if ((+billing.overall_data.payable_amt === 0 || (+billing.overallDiscount.discount_percentage === 100 && +billing.overall_data.payable_amt === 0)) && billing.billingList?.length > 0) {
                return false
            } else if (!(FullAmountEntered())) {
                return true
            }
        } else {
            return true
        }
    }

    const checkUserAccess = () => {
        try {
            if (loginInfo?.module_name === 'Laboratory') {
                return CheckAccessFunc("Laboratory", "Lab Billing", "Hospital Billing", null, "Tab")?.editAccess
            } else if (loginInfo?.module_name === 'Radiology') {
                return CheckAccessFunc("Radiology", "Radiology Billing", "Hospital Billing", null, "Tab")?.editAccess
            } else if (loginInfo?.module_name === 'Investigation') {
                return CheckAccessFunc(GetInvestigationName(), "Investigation Billing", "Hospital Billing", null, "Tab")?.editAccess
            } else if (loginInfo?.module_name === 'front_office') {
                return CheckAccessFunc("front_office", "Hospital Billing", "Hospital Billing", null, "Tab")?.editAccess
            }
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const renderPaymentButtons = () => {
        try {
            let payamt = (+billing.cash_amt) + (+billing.card_amt) + (+billing.upi_amt) + (+billing.bank_amt) + (+billing.cheque_amt)
            let CashReceiveAccess = CheckCashCounterAccess()
            let hasPermission = (typeof (loginInfo?.permission_access) === 'string' && loginInfo?.permission_access ? loginInfo?.permission_access?.common?.allow_concession : Object.keys(loginInfo?.permission_access)?.length > 0 ? loginInfo?.permission_access?.common?.allow_concession : true) || loginInfo?.is_super_admin
            const per_access = typeof (loginInfo?.permission_access) === 'string' && loginInfo?.permission_access ? JSON.parse(loginInfo?.permission_access) : loginInfo?.permission_access;
            const enableCreditBtn = (loginInfo?.is_user && loginInfo?.module_name === 'Laboratory') ? per_access?.lab?.is_credit === true : true;
            return (
                <>{loginInfo?.is_doctor ?
                    <Box component={'div'}>
                        <Button variant='outlined' sx={{ height: '4dvh', width: '12dvw', textTransform: 'capitalize', mr: '0.5rem', justifyContent: 'flex-start' }}
                            onClick={() => {
                                const allowPatientCredit = JSON.parse(localGetItem("allow_patient_credit_bills"));

                                let creditType = '';
                                if (billing.patientCreditType === 'patientcredit') {
                                    creditType = allowPatientCredit ? 'Patient credit' : '';
                                } else if (billing.patientCreditType === 'corporatecredit') {
                                    creditType = 'Corporate credit';
                                } else if (billing.patientCreditType === 'insurancecredit'){
                                    creditType = 'Insurance credit';
                                }

                                // No type selected
                                if (!creditType) {
                                    return errorMessage("Please select the Credit Type");
                                }

                                // Patient credit not allowed but selected
                                if (!allowPatientCredit && creditType === "Patient credit") {
                                    return errorMessage("Please select the Credit Type");
                                }

                                setBilling((prev) => {
                                    const updatedBilling = { ...prev, postLoad: true };
                                    if (props?.fromQuickBill) {
                                        if (loginInfo?.module_name === MODULE_NAME.LABORATORY_LOW || loginInfo?.module_name === MODULE_NAME.RADIOLOGY_LOW  || loginInfo?.module_name === "Investigation") {
                                            postBillingData('Credit', null, true);
                                        } else {
                                            appontimentId ? postBillingData('Credit', null, true) : postAppointmentCreate('Credit', true);
                                        }
                                    } else {
                                        postBillingData('Credit', null, true);
                                    }
                                    return updatedBilling;
                                });
                            }}
                            disabled={((payamt < billing.overall_data.payable_amt && billing.overall_data?.payable_amt) ? false : true) || billing.postLoad || hasDuplicate}
                        >Move To Cash Counter</Button>
                        <Button variant='outlined' sx={{ height: '4dvh', width: '9dvw', textTransform: 'capitalize', mr: '0.5rem' }}
                            onClick={() => {
                                const allowPatientCredit = JSON.parse(localGetItem("allow_patient_credit_bills"));

                                let creditType = '';
                                if (billing.patientCreditType === 'patientcredit') {
                                    creditType = allowPatientCredit ? 'Patient credit' : '';
                                } else if (billing.patientCreditType === 'corporatecredit') {
                                    creditType = 'Corporate credit';
                                } else if (billing.patientCreditType === 'insurancecredit'){
                                    creditType = 'Insurance credit';
                                }

                                // No type selected
                                if (!creditType) {
                                    return errorMessage("Please select the Credit Type");
                                }

                                // Patient credit not allowed but selected
                                if (!allowPatientCredit && creditType === "Patient credit") {
                                    return errorMessage("Please select the Credit Type");
                                }

                                setBilling((prev) => {
                                    const updatedBilling = { ...prev, postLoad: true };
                                    if (props?.fromQuickBill) {
                                        if (loginInfo?.module_name === MODULE_NAME.LABORATORY_LOW || loginInfo?.module_name === MODULE_NAME.RADIOLOGY_LOW) {
                                            postBillingData('Credit');
                                        } else {
                                            appontimentId ? postBillingData('Credit') : postAppointmentCreate('Credit');
                                        }
                                    } else {
                                        postBillingData('Credit');
                                    }
                                    return updatedBilling;
                                });
                            }}
                            disabled={((payamt < billing.overall_data.payable_amt && billing.overall_data?.payable_amt) ? false : true) || billing.postLoad || hasDuplicate}
                        >Credit</Button>
                        <Button className='Common_Btn_Min_Width'
                            disabled={((payamt < billing.overall_data.payable_amt && billing.overall_data?.payable_amt) ? false : true) || billing.postLoad || hasDuplicate}
                            onClick={() => { 
                                getCorporateDetails() 
                                getInsuranceDetails() 
                            }}
                        >
                            <Box component={'img'} src={(((payamt < billing.overall_data.payable_amt && billing.overall_data?.payable_amt) ? false : true) || billing.postLoad || hasDuplicate) ? ImagePaths.outlinedEditDis.default : ImagePaths.ChangeCredit.default} width="1.7vw" height="1.7vw" />
                        </Button>
                        <Button variant='outlined' sx={{ height: '4dvh', width: '12dvw', textTransform: 'capitalize', mr: '0.5rem' }}
                            onClick={() => {
                                setBilling((prev) => {
                                    const updatedBilling = { ...prev, postLoad: true };
                                    if (props?.fromQuickBill) {
                                        if (loginInfo?.module_name === MODULE_NAME.LABORATORY_LOW || loginInfo?.module_name === MODULE_NAME.RADIOLOGY_LOW || loginInfo?.module_name === "Investigation") {
                                            postBillingData('Draft');
                                        } else {
                                            appontimentId ? postBillingData('Draft') : postAppointmentCreate('Draft');
                                        }
                                    } else {
                                        postBillingData('Draft');
                                    }
                                    return updatedBilling;
                                });
                            }}
                            disabled={(billing.overall_data?.payable_amt ? false : true) || billing.postLoad || hasDuplicate}
                        >Draft</Button>
                        <Button variant='outlined' sx={{ height: '4dvh', width: '12dvw', textTransform: 'capitalize' }}
                            onClick={() => clearAllData(true)}
                        >Clear</Button>
                    </Box> :
                    checkUserAccess() ?
                        (!hasPermission && !requestState.fromBillConvert && !requestState.fromApprover && !requestState.fromPendingList && (((requestState.hasConcession || +billing.overallDiscount?.discount_amount !== 0) && !history?.location?.state?.fromPatientBills) || (history?.location?.state?.fromPatientBills && (+billing.overallDiscount?.discount_amount != +billing.tempoverallDis || requestState.totalConcession != +billing.temptotalConc)))) ?
                            <Box component={'div'}>
                                <Button variant='outlined' sx={{ height: '4dvh', width: '7dvw', textTransform: 'capitalize', mr: '1rem' }}
                                    onClick={() => clearAllData()}
                                >Clear</Button>
                                <Button variant='contained' sx={{ height: '4dvh', width: '10dvw', textTransform: 'capitalize', mr: '1rem' }}
                                    onClick={() => setRequestState((prev) => {
                                        if (props?.fromQuickBill) {
                                            if (loginInfo?.module_name === MODULE_NAME.LABORATORY_LOW || loginInfo?.module_name === MODULE_NAME.RADIOLOGY_LOW || loginInfo?.module_name === "Investigation") {
                                                postRiseRequestAndAccept('Requested');
                                            } else {
                                                appontimentId ? postRiseRequestAndAccept('Requested') : postAppointmentCreate('Requested');
                                            }
                                        } else {
                                            postRiseRequestAndAccept('Requested');
                                        }
                                        return { ...prev, requestLoad: true }
                                    })}
                                >Raise Request</Button>
                            </Box>
                            : requestState.fromApprover ?
                                requestState.modifyApprover ?
                                    <Box component={'div'}>
                                        <Button variant='outlined' sx={{ height: '4dvh', width: '11.5dvw', textTransform: 'capitalize', mr: '1rem' }}
                                            onClick={() => setRequestState((prev) => ({ ...prev, modifyApprover: false }))}
                                        >Save Changes</Button>
                                    </Box> :
                                    <Box component={'div'}>
                                        <Box component={'div'} mb={'0.5rem'} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                            <Button variant='contained' disableElevation sx={{ height: '4dvh', width: '24dvw', textTransform: 'capitalize' }}
                                                onClick={() => setRequestState((prev) => {
                                                    if (props?.fromQuickBill) {
                                                        if (loginInfo?.module_name === MODULE_NAME.LABORATORY_LOW || loginInfo?.module_name === MODULE_NAME.RADIOLOGY_LOW || loginInfo?.module_name === "Investigation") {
                                                            postRiseRequestAndAccept('Accepted');
                                                        } else {
                                                            appontimentId ? postRiseRequestAndAccept('Accepted') : postAppointmentCreate('Accepted');
                                                        }
                                                    } else {
                                                        postRiseRequestAndAccept('Accepted');
                                                    }
                                                    return { ...prev, requestLoad: true }
                                                })}
                                            >Accept</Button>
                                            {requestState?.RequestComments &&
                                                <Tooltip title={`Request Remarks : ${requestState?.RequestComments}`} placement='top' arrow>
                                                    <CommentIcon sx={{ fontSize: '1.5rem' }} color='primary' />
                                                </Tooltip>}
                                        </Box>
                                        <Box component={'div'}>
                                            <Button variant='outlined' sx={{ height: '4dvh', width: '8dvw', textTransform: 'capitalize', mr: '0.5rem' }}
                                                onClick={() => {
                                                    setRequestState((prev) => ({ ...prev, modifyApprover: false }))
                                                    clearAllData()
                                                }}
                                            >Clear</Button>
                                            <Button variant='outlined' sx={{ height: '4dvh', width: '8dvw', textTransform: 'capitalize', mr: '0.5rem' }}
                                                onClick={() => setRequestState((prev) => ({ ...prev, modifyApprover: true }))}
                                            >Modify</Button>
                                            <Button variant='outlined' color='error' sx={{ height: '4dvh', width: '8dvw', textTransform: 'capitalize', mr: '0.5rem' }}
                                                onClick={() => setIsDelete(true)}
                                            >Reject</Button>
                                        </Box>
                                    </Box>
                                : (requestState.hasConcession || +billing.overallDiscount?.discount_amount !== 0) && (requestState.fromPendingList || requestState.fromBillConvert) ?
                                    <Box component={'div'}>
                                        <Button variant='contained' sx={{ height: '4dvh', width: '10dvw', textTransform: 'capitalize', mr: '1rem' }}
                                            disabled={billing?.billingList?.length > 0 ? false : true}
                                            onClick={() => {
                                                if (props?.fromQuickBill) {
                                                    if (loginInfo?.module_name === MODULE_NAME.LABORATORY_LOW || loginInfo?.module_name === MODULE_NAME.RADIOLOGY_LOW || loginInfo?.module_name === "Investigation") {
                                                        postRiseRequestAndAccept('Requested');
                                                    } else {
                                                        appontimentId ? postRiseRequestAndAccept('Requested') : postAppointmentCreate('Requested');
                                                    }
                                                } else {
                                                    postRiseRequestAndAccept('Requested');
                                                }
                                            }}
                                        >Update Changes</Button>
                                    </Box>
                                    : requestState.fromPendingList && (!requestState.hasConcession || +billing.overallDiscount?.discount_amount === 0) ?
                                        <Box component={'div'}>
                                            <Button variant='contained' sx={{ height: '4dvh', width: '10dvw', textTransform: 'capitalize', mr: '1rem' }}
                                                disabled
                                            // onClick={() => {
                                            //     setRequestState((prev) => ({ ...prev, pendingCancel: true }))
                                            //     setIsDelete(true)
                                            // }}
                                            >Save Changes</Button>
                                        </Box>
                                        : getCachevalue('BillType') === 'Cancel' ?
                                            <Box component={'div'}>
                                                <Button variant='contained' sx={{ height: COMMON_STYLES.HEIGHT, textTransform: 'capitalize', mr: '1rem' }}
                                                    color='error'
                                                    onClick={() => { setBilling((prev) => ({ ...prev, openCancelPopup: true })) }}
                                                >Cancel Bill</Button>
                                            </Box>
                                            : getCachevalue('BillType') === 'Modify' && !requestState?.fromPendingList ?
                                                <Button variant='outlined' sx={{ height: COMMON_STYLES.HEIGHT, textTransform: 'capitalize', mr: '0.5rem' }}
                                                    onClick={() => {
                                                        setBilling((prev) => {
                                                            const updatedBilling = { ...prev, postLoad: true };
                                                            if (props?.fromQuickBill) {
                                                                if (loginInfo?.module_name === MODULE_NAME.LABORATORY_LOW || loginInfo?.module_name === MODULE_NAME.RADIOLOGY_LOW || loginInfo?.module_name === "Investigation") {
                                                                    postBillingData('Credit');
                                                                } else {
                                                                    appontimentId ? postBillingData('Credit') : postAppointmentCreate('Credit');
                                                                }
                                                            } else {
                                                                postBillingData('Credit');
                                                            }
                                                            return updatedBilling;
                                                        });
                                                    }}
                                                    disabled={billing.postLoad}
                                                >Save Changes</Button> :
                                                <Box component={'div'}>
                                                    <Box component={'div'} display={'flex'} gap={'0.6rem'}>
                                                        <Button variant='contained' sx={{ height: '4dvh', width: '12dvw', textTransform: 'capitalize', visibility: (CashReceiveAccess && (billing.patientData?.patient_id)) ? "visible" : "hidden" }}
                                                            onClick={() => {
                                                                setBilling((prev) => {
                                                                    const updatedBilling = { ...prev, postLoad: true };
                                                                    if (props?.fromQuickBill) {
                                                                        if (loginInfo?.module_name === MODULE_NAME.LABORATORY_LOW || loginInfo?.module_name === MODULE_NAME.RADIOLOGY_LOW || loginInfo?.module_name === "Investigation") {
                                                                            postBillingData('Regular');
                                                                        } else {
                                                                            appontimentId ? postBillingData('Regular') : postAppointmentCreate('Regular');
                                                                        }
                                                                    } else {
                                                                        postBillingData('Regular');
                                                                    }
                                                                    return updatedBilling;
                                                                });
                                                            }}
                                                            disabled={checkButtonDisable() || billing.postLoad}
                                                        >Receive Payment</Button>
                                                        <Button variant='outlined' sx={{ height: '4dvh', width: '11.5dvw', textTransform: 'capitalize', mr: '0.5rem', justifyContent: 'flex-start' }}
                                                            onClick={() => {
                                                                const allowPatientCredit = JSON.parse(localGetItem("allow_patient_credit_bills"));

                                                                let creditType = '';
                                                                if (billing.patientCreditType === 'patientcredit') {
                                                                    creditType = allowPatientCredit ? 'Patient credit' : '';
                                                                } else if (billing.patientCreditType === 'corporatecredit') {
                                                                    creditType = 'Corporate credit';
                                                                } else if (billing.patientCreditType === 'insurancecredit') {
                                                                    creditType = 'Insurance credit';
                                                                }

                                                                // No type selected
                                                                if (!creditType) {
                                                                    return errorMessage("Please select the Credit Type");
                                                                }

                                                                // Patient credit not allowed but selected
                                                                if (!allowPatientCredit && creditType === "Patient credit") {
                                                                    return errorMessage("Please select the Credit Type");
                                                                }

                                                                setBilling((prev) => {
                                                                    const updatedBilling = { ...prev, postLoad: true };
                                                                    if (props?.fromQuickBill) {
                                                                        if (loginInfo?.module_name === MODULE_NAME.LABORATORY_LOW || loginInfo?.module_name === MODULE_NAME.RADIOLOGY_LOW || loginInfo?.module_name === "Investigation") {
                                                                            postBillingData('Credit', null, true);
                                                                        } else {
                                                                            appontimentId ? postBillingData('Credit', null, true) : postAppointmentCreate('Credit', true);
                                                                        }
                                                                    } else {
                                                                        postBillingData('Credit', null, true);
                                                                    }
                                                                    return updatedBilling;
                                                                });
                                                            }}
                                                            disabled={((payamt < billing.overall_data.payable_amt && billing.overall_data?.payable_amt) ? false : true) || billing.postLoad || hasDuplicate}
                                                        >Move To Cash Counter</Button>
                                                    </Box>
                                                    <Box component={'div'}>
                                                        <Button variant='outlined' sx={{ height: '4dvh', width: '7dvw', textTransform: 'capitalize' }} onClick={() =>  clearAllData(true)} >Clear</Button>
                                                        <Button className='Common_Btn_Min_Width'
                                                            disabled={((payamt < billing.overall_data.payable_amt && billing.overall_data?.payable_amt) ? false : true) || billing.postLoad || hasDuplicate || !enableCreditBtn}
                                                            onClick={() => { 
                                                                getCorporateDetails()
                                                                getInsuranceDetails()
                                                             }}
                                                        >
                                                            <Box component={'img'} src={(((payamt < billing.overall_data.payable_amt && billing.overall_data?.payable_amt) ? false : true) || billing.postLoad || hasDuplicate || !enableCreditBtn) ? ImagePaths.outlinedEditDis.default : ImagePaths.ChangeCredit.default} width="1.7vw" height="1.7vw" />
                                                        </Button>
                                                        <Button variant='outlined' sx={{ height: '4dvh', width: '7dvw', textTransform: 'capitalize', mr: '0.5rem' }}
                                                            onClick={() => {
                                                                setBilling((prev) => {
                                                                    const updatedBilling = { ...prev, postLoad: true };
                                                                    if (props?.fromQuickBill) {
                                                                        if (loginInfo?.module_name === MODULE_NAME.LABORATORY_LOW || loginInfo?.module_name === MODULE_NAME.RADIOLOGY_LOW || loginInfo?.module_name === "Investigation") {
                                                                            postBillingData('Draft');
                                                                        } else {
                                                                            appontimentId ? postBillingData('Draft') : postAppointmentCreate('Draft');
                                                                        }
                                                                    } else {
                                                                        postBillingData('Draft');
                                                                    }
                                                                    return updatedBilling;
                                                                });
                                                            }}
                                                            disabled={(billing.overall_data?.payable_amt ? false : true) || billing.postLoad || hasDuplicate}
                                                        >Draft</Button>
                                                        <Button variant='outlined' sx={{ height: '4dvh', width: '7dvw', textTransform: 'capitalize', mr: '0.5rem' }}
                                                            onClick={() => {
                                                                const allowPatientCredit = JSON.parse(localGetItem("allow_patient_credit_bills"));

                                                                // Determine credit type
                                                                let creditType = '';
                                                                if (billing.patientCreditType === 'patientcredit') {
                                                                    creditType = allowPatientCredit ? 'Patient credit' : '';
                                                                } else if (billing.patientCreditType === 'corporatecredit') {
                                                                    creditType = 'Corporate credit';
                                                                }else if (billing.patientCreditType === 'insurancecredit'){
                                                                    creditType = 'Insurance credit';
                                                                }

                                                                // Validation: No type selected
                                                                if (!creditType) {
                                                                    return errorMessage("Please select the Credit Type");
                                                                }

                                                                // Validation: Patient credit selected but not allowed
                                                                if (!allowPatientCredit && creditType === "Patient credit") {
                                                                    return errorMessage("Please select the Credit Type");
                                                                }
                                                                if(localGetItem('set_due_date_for_credit_billing') === "true" && billing?.credit_due_date === null){
                                                                     getCorporateDetails();
                                                                } else{
                                                                setBilling((prev) => {
                                                                    const updatedBilling = { ...prev, postLoad: true };
                                                                    if (props?.fromQuickBill) {
                                                                        if (loginInfo?.module_name === MODULE_NAME.LABORATORY_LOW || loginInfo?.module_name === MODULE_NAME.RADIOLOGY_LOW || loginInfo?.module_name === "Investigation") {
                                                                            postBillingData('Credit');
                                                                        } else {
                                                                            appontimentId ? postBillingData('Credit') : postAppointmentCreate('Credit');
                                                                        }
                                                                    } else {
                                                                        postBillingData('Credit');
                                                                    }
                                                                    return updatedBilling;
                                                                });}
                                                            }}
                                                            disabled={((payamt < billing.overall_data.payable_amt && billing.overall_data?.payable_amt) ? false : true) || billing.postLoad || hasDuplicate || !enableCreditBtn}
                                                        >Credit</Button>
                                                    </Box>
                                                </Box> : null}</>

            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const ConcessionPop = () => {
        if (billing.overall_data.concession_applicable !== 0 && billing.overallDiscount.discount_amount && billing.concessionReason === '' && getCachevalue('BillType') !== 'Cancel') {
            setBilling((prev) => ({ ...prev, reasonPopup: true }))
        }
    }

    const renderRgtContent = () => {
        let payamt = (+billing.cash_amt) + (+billing.card_amt) + (+billing.upi_amt) + (+billing.bank_amt) + (+billing.cheque_amt)
        let CashReceiveAccess = CheckCashCounterAccess()
        let hasPermission = typeof (loginInfo?.permission_access) === 'string' && loginInfo?.permission_access ? loginInfo?.permission_access?.common?.allow_concession :
            Object.keys(loginInfo?.permission_access)?.length > 0 ? loginInfo?.permission_access?.common?.allow_concession : true
        return (
            <Box visibility={(billing.patientData?.patient_id) ? 'visible' : 'hidden'} component={'div'} overflow={'auto'}>
                <Box component={'div'} height={'51.5dvh'} overflow={'auto'}>
                    <Grid container rowGap={1}>
                        <Grid xs={12} p={'0.5rem'} sx={{ backgroundColor: 'white' }} rowGap={2}>
                            <Box component={'div'} borderBottom={'2px solid lightgray'}>
                                <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                                    <Typography fontSize={COMMON_STYLES.FONT_SIZE_L}>{`Sub Amount`}</Typography>
                                    <Typography fontSize={COMMON_STYLES.FONT_SIZE_L}>{`${CurrencySymbol} ${CommonValidation.formatAmount(billing?.overall_data?.sub_total)}`}</Typography>
                                </Box>
                                <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                                    <Typography fontSize={COMMON_STYLES.FONT_SIZE_L}>{`Concession Applicable`}</Typography>
                                    <Typography fontSize={COMMON_STYLES.FONT_SIZE_L}>{`${CurrencySymbol} ${CommonValidation.formatAmount(billing?.overall_data?.concession_applicable)}`}</Typography>
                                </Box>
                                <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                                    <Typography fontSize={COMMON_STYLES.FONT_SIZE_L}>{`Overall Concession`}</Typography>
                                    <Box component={'div'} display={'flex'} alignItems={'center'}>
                                        <TextField
                                            autoComplete='off'
                                            size='small'
                                            InputProps={{ emed_tid: 'con_amt', style: { height: '4dvh' } }}
                                            sx={{ width: '6dvw' }}
                                            disabled={(getCachevalue('BillType') === 'Cancel' || billing.isEdit || (requestState.fromApprover && !requestState.modifyApprover)) ? true : false}
                                            placeholder={CurrencySymbol}
                                            value={billing?.overallDiscount?.discount_amount}
                                            onBlur={ConcessionPop}
                                            onChange={(e) => {
                                                let value = e.target.value
                                                if (CommonValidation.DecimalNumber(value) && (value >= 1 && (+value <= +billing.overall_data?.concession_applicable)) || value === '') {
                                                    setBilling((prev) => {
                                                        let overAll = { ...prev.overall_data }
                                                        let newDiscount = { ...prev.overallDiscount }
                                                        newDiscount.discount_amount = value
                                                        newDiscount.discount_percentage = value ? CommonValidation.getDiscountPercentage(value, billing.overall_data.concession_applicable) : ''
                                                        newDiscount.discount_percentage_w_r = value ? CommonValidation.getDiscountPercentageWithRound(value, billing.overall_data.concession_applicable) : ''
                                                        let afterDisAmt = (overAll.taxable_amount + overAll.gst_amount) - (+value)
                                                        overAll.round_off = Math.round(afterDisAmt) - afterDisAmt
                                                        overAll.payable_amt = Math.round(afterDisAmt)
                                                        return {
                                                            ...prev,
                                                            overall_data: { ...prev.overall_data, ...overAll },
                                                            overallDiscount: { ...prev.overallDiscount, ...newDiscount },
                                                            concessionReason: value === '' ? '' : prev.concessionReason
                                                        }
                                                    })
                                                }
                                            }}
                                        />
                                        <TextField
                                            autoComplete='off'
                                            size='small'
                                            InputProps={{ emed_tid: 'con_per', style: { height: '4dvh' } }}
                                            sx={{ width: '6dvw' }}
                                            disabled={(getCachevalue('BillType') === 'Cancel' || billing.isEdit || (requestState.fromApprover && !requestState.modifyApprover)) ? true : false}
                                            placeholder='%'
                                            value={billing?.overallDiscount?.discount_percentage_w_r}
                                            onBlur={ConcessionPop}
                                            onChange={(e) => {
                                                let value = e.target.value
                                                if (CommonValidation.DecimalNumber(value) && (+value >= 1 && +value <= 100 && +billing.overall_data?.concession_applicable !== 0) || value === '') {
                                                    setBilling((prev) => {
                                                        let overAll = { ...prev.overall_data }
                                                        let newDiscount = { ...prev.overallDiscount }
                                                        newDiscount.discount_percentage = value
                                                        newDiscount.discount_percentage_w_r = value
                                                        let findDisAmt = CommonValidation.getDiscountAmountWithRound(value, billing.overall_data.concession_applicable)
                                                        newDiscount.discount_amount = value ? findDisAmt : ''
                                                        let afterDisAmt = (overAll.taxable_amount + overAll.gst_amount) - (findDisAmt)
                                                        overAll.round_off = Math.round(afterDisAmt) - afterDisAmt
                                                        overAll.payable_amt = Math.round(afterDisAmt)
                                                        return {
                                                            ...prev,
                                                            overall_data: { ...prev.overall_data, ...overAll },
                                                            overallDiscount: { ...prev.overallDiscount, ...newDiscount },
                                                            concessionReason: value === '' ? '' : prev.concessionReason
                                                        }
                                                    })
                                                }
                                            }}
                                        />
                                        <IconButton
                                            sx={{ height: '1dvw', width: '1dvw', ml: '0.2rem' }}
                                            disabled={(billing.overallDiscount.discount_amount || billing.concessionReason) ? false : true}
                                            onClick={() => setBilling((prev) => ({ ...prev, reasonPopup: true }))}
                                        ><DescriptionIcon color={(billing.overallDiscount.discount_amount || billing.concessionReason) ? 'primary' : 'disabled'}
                                            sx={{ height: '1.3dvw', width: '1.3dvw' }} /></IconButton>
                                    </Box>
                                </Box>
                                <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                                    <Typography fontSize={COMMON_STYLES.FONT_SIZE_L}>{`Taxable Amount`}</Typography>
                                    <Typography fontSize={COMMON_STYLES.FONT_SIZE_L}>{`${CurrencySymbol} ${CommonValidation.formatAmount(billing?.overall_data?.taxable_amount - (+billing.overallDiscount.discount_amount ? +billing.overallDiscount.discount_amount : 0))}`}</Typography>
                                </Box>
                                {loginInfo?.is_gst_enabled ?
                                    <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                                        <Typography fontSize={COMMON_STYLES.FONT_SIZE_L}>{`GST Amount`}</Typography>
                                        <Typography fontSize={COMMON_STYLES.FONT_SIZE_L}>{`${CurrencySymbol} ${CommonValidation.formatAmount(billing?.overall_data?.gst_amount)}`}</Typography>
                                    </Box> : null}
                                <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} mb={'0.3rem'}>
                                    <Typography fontSize={COMMON_STYLES.FONT_SIZE_L}>{`Round Off`}</Typography>
                                    <Typography fontSize={COMMON_STYLES.FONT_SIZE_L}>{`${CurrencySymbol} ${CommonValidation.formatAmount(billing?.overall_data?.round_off)}`}</Typography>
                                </Box>
                            </Box>
                            <Box component={'div'} mt={'0.3rem'}>
                                {getCachevalue('BillType') === 'Cancel' ?
                                    <>
                                        <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                                            <Typography fontWeight={COMMON_STYLES.FONT_WEIGHT}>{`Billed Amount`}</Typography>
                                            <Typography fontWeight={COMMON_STYLES.FONT_WEIGHT}>{`${CurrencySymbol} ${CommonValidation.formatAmount(billing?.overall_data?.payable_amt)}`}</Typography>
                                        </Box>
                                        <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                                            <Typography fontWeight={COMMON_STYLES.FONT_WEIGHT}>{`Received Amount`}</Typography>
                                            <Typography fontWeight={COMMON_STYLES.FONT_WEIGHT}>{`${CurrencySymbol} ${CommonValidation.formatAmount(billing?.received_amount)}`}</Typography>
                                        </Box>
                                    </> :
                                    getCachevalue('BillType') === 'Modify' ?
                                        <>
                                            <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                                                <Typography fontWeight={COMMON_STYLES.FONT_WEIGHT}>{`Payable Amount`}</Typography>
                                                <Typography fontWeight={COMMON_STYLES.FONT_WEIGHT}>{`${CurrencySymbol} ${CommonValidation.formatAmount(billing?.overall_data?.payable_amt)}`}</Typography>
                                            </Box>
                                        </> : <>
                                            <Box component={'div'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                                                <Typography fontWeight={COMMON_STYLES.FONT_WEIGHT}>{`Payable Amount`}</Typography>
                                                <Typography fontWeight={COMMON_STYLES.FONT_WEIGHT}>{`${CurrencySymbol} ${CommonValidation.formatAmount(billing?.overall_data?.payable_amt)}`}</Typography>
                                            </Box>
                                        </>}
                            </Box>
                        </Grid>
                        {(!hasPermission && !requestState.fromApprover && !requestState.fromBillConvert && !requestState.fromPendingList && (((requestState.hasConcession || +billing.overallDiscount?.discount_amount !== 0) && !history?.location?.state?.fromPatientBills) || (history?.location?.state?.fromPatientBills && (+billing.overallDiscount?.discount_amount != +billing.tempoverallDis || requestState.totalConcession != +billing.temptotalConc)))) ?
                            <Grid xs={12}>
                                <Box component={'div'}>
                                    <Box component={'div'}>
                                        <Autocomplete
                                            size='small'
                                            sx={{ width: '15dvw' }}
                                            options={requestState.approverList}
                                            getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.login_user_name}
                                            value={requestState.selectedApprover}
                                            onChange={(e, newValue) => {
                                                setRequestState((prev) => ({
                                                    ...prev,
                                                    selectedApprover: newValue?.login_user_name,
                                                    selectedApproverId: newValue?.login_user_id
                                                }))
                                            }}
                                            renderInput={(params) => <TextField
                                                {...params}
                                                InputProps={{ ...params.InputProps, emed_tid: 'req_name' }}
                                                label='Select Approver *'
                                            />}
                                        />
                                    </Box>
                                    <Box component={'div'} mt={'0.5rem'}>
                                        <Typography fontSize={'0.9rem'} fontWeight={600} mb={'0.5rem'}>Remarks</Typography>
                                        <TextField
                                            multiline
                                            maxRows={3}
                                            fullWidth
                                            size='small'
                                            value={requestState.remarks}
                                            placeholder='Enter Comments Here'
                                            InputProps={{ emed_tid: 'req_cmts' }}
                                            onChange={(e) => {
                                                let value = e.target.value
                                                if (value?.length <= 250 || value === '') {
                                                    setRequestState((prev) => ({ ...prev, remarks: value }))
                                                } else {
                                                    errorMessage('Allowed Only 250 Characters')
                                                }
                                            }}
                                        />
                                    </Box>
                                    <Box mt={'0.5rem'} border={'1px solid #d32f2f'} display={'flex'} alignItems={'center'}>
                                        <Box component={'div'} mt={'0.2rem'}><ReportGmailerrorredIcon color='error' sx={{ height: '2.5dvw', width: '2.5dvw' }} /></Box>
                                        <Box component={'div'}><Typography fontSize={'0.8rem'} fontWeight={'600'} color={'#d32f2f'}>The Concession has been applied to this bill.Approver need to verify the concession amount to continue</Typography></Box>
                                    </Box>
                                </Box>
                            </Grid> :
                            <Grid xs={12}><Box sx={{ backgroundColor: 'white', mb: '0.5rem', pl: '0.5rem', visibility: (CashReceiveAccess && getCachevalue('BillType') !== 'Cancel' && getCachevalue('BillType') !== 'Modify' && !requestState.fromApprover && (billing.patientData?.patient_id) && !loginInfo?.is_doctor && !((requestState.hasConcession || +billing.overallDiscount?.discount_amount !== 0) && (requestState.fromBillConvert))) ? "visible" : "hidden" }}>{showCashTextBox()}</Box></Grid>}
                    </Grid>
                </Box>
                {renderPaymentButtons()}
            </Box>
        )
    }

    const renderDeletePopup = () => {
        try {
            let text = billing.deleted_service?.bill_type === 'Draft' ? 'Do you want to cancel the' :
                billing.deleted_service?.not_from_order ? `Do you want to remove the` : `Do you want to remove or cancel the`
            let HeaderText = billing.deleted_service?.bill_type === 'Draft' ? 'Cancel Draft' :
                billing.deleted_service?.not_from_order ? `Remove` : `Remove or Cancel Order`
            return (
                <Dialog open={billing.openDeletePopup} maxWidth='sm' fullWidth>
                    <Box component={'div'} className='com_billing_popup'>
                        <Box component={'div'} p={'0rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
                            <Typography fontSize={'1rem'} fontWeight={600} color={'darkRed'}>{HeaderText}</Typography>
                            <IconButton
                                onClick={() => setBilling((prev) => ({ ...prev, deleted_service: null, openDeletePopup: false, cancel_reason: '' }))}
                            >
                                <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1dvw'} width={'1dvw'} />
                            </IconButton>
                        </Box>
                        <Box component={'div'} p='0.5rem'>
                            <Typography fontWeight={COMMON_STYLES.FONT_WEIGHT}>{`${text} ${billing.deleted_service?.service_name || '-'} ?`}</Typography>
                            <Box component={'div'} mt={'1rem'} visibility={billing.deleted_service?.not_from_order ? 'hidden' : 'visible'}>
                                <TextField
                                    multiline
                                    size='small'
                                    fullWidth
                                    maxRows={4}
                                    value={billing.cancel_reason}
                                    label='Cancel Reason *'
                                    onChange={(e) => {
                                        if (e.target.value?.length <= 250 || e.target.value === '') {
                                            setBilling((prev) => ({ ...prev, cancel_reason: e.target.value }))
                                        } else {
                                            errorMessage('Allowed only 250 charcters')
                                        }
                                    }}
                                />
                            </Box>
                        </Box>
                        <Box component={'div'} display={'flex'} justifyContent={'flex-end'} alignItems={'center'} mb={'0.5rem'}>
                            {billing.deleted_service?.not_from_order ? null : <Button variant='contained'
                                color='error'
                                sx={{ textTransform: 'capitalize', mr: '1rem', height: COMMON_STYLES.HEIGHT }}
                                onClick={() => {
                                    if (billing.cancel_reason === '') {
                                        errorMessage('Enter Cancel Reason')
                                    } else {
                                        deleteServiceData(billing.deleted_service)
                                    }
                                }}
                            >Cancel</Button>}
                            {billing.deleted_service?.bill_type === 'Draft' ? null :
                                <Button variant='outlined'
                                    color='error'
                                    sx={{ textTransform: 'capitalize', mr: '1rem', height: COMMON_STYLES.HEIGHT }}
                                    onClick={() => {
                                        setBilling((prev) => {
                                            let billingList = [...prev.billingList]
                                            let cancelId = [];
                                            cancelId?.push(billingList[billing.deletedIndex]?.id)
                                            billingList?.splice(billing.deletedIndex, 1)
                                            let filterDelete = tempDup?.filter(item => item.service_details_id !== billingList[billing.deletedIndex]?.service_details_id)
                                            settempDup(filterDelete)
                                            return {
                                                ...prev, billingList, cancelled_ids: [...billing.cancelled_ids, ...cancelId], overallDiscount: {
                                                    discount_amount: '', discount_percentage: '', discount_percentage_w_r: ''
                                                }
                                            }
                                        })
                                        setTimeout(() => setBilling((prev) => ({
                                            ...prev,
                                            openDeletePopup: false,
                                            deleted_service: null,
                                            deletedIndex: null
                                        })), 50)
                                    }}
                                >Remove</Button>}
                        </Box>
                    </Box>
                </Dialog>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const renderCreditTypePopup = () => {
        try {
            let details = props?.patientData
            let comp_name = details?.company_name ? details?.company_name : (typeof(billing.selectedCorporate) === 'object' ? billing.selectedCorporate?.company_name : billing.selectedCorporate)
            let employee_no = details?.employee_id ? details?.employee_id : details?.id_no ? details?.id_no : (typeof(billing.employeeNo) === 'object' ? billing.employeeNo?.id : billing.employeeNo)
            let policy_no = details?.policy_number ? details?.policy_number : details?.policy_no ? details?.policy_no : (typeof(billing.policyno) === 'object' ? billing.policyno : billing.policyno)
            let insurance_name = details?.insurance_company_name ? details?.insurance_company_name : (typeof(billing.selectedInsurance) === 'object' ? billing.selectedInsurance?.insurance_name : billing.selectedInsurance)
            return (
                <Dialog open={billing.creditType} fullWidth>
                    <Box component={'div'} className="com_billing_popup">
                        <Box component={'div'} p={'0rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
                            <Typography fontSize={'1rem'} fontWeight={600}>Select Credit Type</Typography>
                            <IconButton
                                onClick={() => setBilling((prev) => ({ ...prev, creditType: false, addCoporate: false, addInsurance:false, credit_due_date: null }))}
                            >
                                <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1dvw'} width={'1dvw'} />
                            </IconButton>
                        </Box>
                        <Box component={'div'} p={'0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                            {JSON.parse(localGetItem('allow_patient_credit_bills')) ? <Box component={'div'}>
                                <Typography>Patient Credit</Typography>
                                <FormControlLabel value="patientcredit" control={<Radio size='small' checked={billing.patientCreditType === 'patientcredit'} onClick={(e) => { setBilling((prev) => ({ ...prev, patientCreditType: e.target.value })) }} />} label="Patient Credit" />
                            </Box> : null}
                            <Box>
                                <Box display={'flex'} alignItems={'center'}>
                                    <Typography mr={'1rem'} >Insurance Credit</Typography>
                                    {insurance_name ?
                                        <IconButton
                                            sx={{ height: '1.5vw', width: '1.5vw' }}
                                            onClick={() => setBilling((prev) => ({ ...prev, addInsurance: true, addCoporate:false }))}
                                        ><EditIcon color='primary' sx={{ height: '1.3dvw', width: '1.3dvw' }} /></IconButton>
                                        : null}
                                </Box>
                                {insurance_name ?
                                    <FormControlLabel value={'insurancecredit'} control={<Radio checked={billing.patientCreditType === 'insurancecredit'} size='small' />}
                                        onClick={(e) => {
                                            setBilling((prev) => ({
                                                ...prev,
                                                patientCreditType: e.target.value,
                                                policyno: policy_no,
                                                // selectedInsuranseId: details?.employer_id
                                            }))
                                        }}
                                        label={<Box>
                                            {insurance_name?.length > 18 ?
                                                <Tooltip title={insurance_name} placement='top'><Typography sx={{ fontSize: '0.8vw', fontWeight: 'bold' }}>{insurance_name.slice(0, 18) + '...'}</Typography></Tooltip>
                                                : <Typography sx={{ fontSize: '0.8vw', fontWeight: 'bold' }}>{insurance_name}</Typography>}
                                            {policy_no?.length > 18 ?
                                                <Tooltip title={policy_no} placement='top'><Typography sx={{ fontSize: '0.7vw', color: '#888888' }}>{policy_no.slice(0, 18) + '...'}</Typography></Tooltip>
                                                : <Typography sx={{ fontSize: '0.7vw', color: '#888888' }}>{policy_no}</Typography>}
                                        </Box>} /> :
                                    <Button
                                        variant='contained'
                                        sx={{ textTransform: 'capitalize', height: '4.5dvh' }}
                                        onClick={() => setBilling((prev) => ({ ...prev, patientCreditType: 'insurancecredit', addInsurance: true, addCoporate: false }))}
                                    >Add Insurance</Button>
                                }
                            </Box>
                            <Box component={'div'}>
                                <Box display={'flex'} alignItems={'center'}>
                                    <Typography mr={'1rem'}>Corporate Credit</Typography>
                                    {comp_name ?
                                        <IconButton
                                            sx={{ height: '1.5dvw', width: '1.5dvw' }}
                                            onClick={() => setBilling((prev) => ({ ...prev, addCoporate: true, addInsurance: false }))}
                                        ><EditIcon color='primary' sx={{ height: '1.3dvw', width: '1.3dvw' }} /></IconButton> : null}
                                </Box>
                                {comp_name ?
                                    <FormControlLabel value={'corporatecredit'} control={<Radio checked={billing.patientCreditType === 'corporatecredit'} size='small' />}
                                        onClick={(e) => {
                                            setBilling((prev) => ({
                                                ...prev,
                                                patientCreditType: e.target.value,
                                                employeeNo: employee_no,
                                                selectedCorportateId: details?.employer_id
                                            }))
                                        }}
                                        label={<Box>
                                            {comp_name?.length > 18 ?
                                                <Tooltip title={comp_name} placement='top'><Typography sx={{ fontSize: '0.8vw', fontWeight: 'bold' }}>{comp_name.slice(0, 18) + '...'}</Typography></Tooltip>
                                                : <Typography sx={{ fontSize: '0.8vw', fontWeight: 'bold' }}>{comp_name}</Typography>}
                                            {employee_no?.length > 18 ?
                                                <Tooltip title={employee_no} placement='top'><Typography sx={{ fontSize: '0.7vw', color: '#888888' }}>{employee_no.slice(0, 18) + '...'}</Typography></Tooltip>
                                                : <Typography sx={{ fontSize: '0.7vw', color: '#888888' }}>{employee_no}</Typography>}
                                        </Box>} /> :
                                    <Button
                                        variant='contained'
                                        sx={{ textTransform: 'capitalize', height: '4.5dvh' }}
                                        onClick={() => setBilling((prev) => ({ ...prev, patientCreditType: 'corporatecredit', addCoporate: true, addInsurance: false }))}
                                    >Add Corporate</Button>}
                            </Box>
                        </Box>
                        {billing?.addInsurance ? 
                            <Box component={'div'} display={'flex'} p={'0.5rem'}>
                                <Autocomplete
                                    size='small'
                                    id="combo-box-demo-ins"
                                    options={billing.insuranceData}
                                    getOptionLabel={(options) => typeof (options) === 'string' ? options : options.insurance_name}
                                    onChange={(e, value) => {
                                        setBilling((prev) => ({ ...prev, selectedInsurance: value }))
                                    }}
                                    value={billing.selectedInsurance}
                                    sx={{ width: '13vw', marginRight: '1vw' }}
                                    renderInput={(params) => <TextField {...params} label="Insurance Company Name" />}
                                />
                                <TextField
                                    size='small'
                                    label="Policy Number"
                                    variant="outlined"
                                    sx={{ width: '13vw' }}
                                    value={billing.policyno}
                                    inputProps={{ maxLength: 25 }}
                                    onChange={(e) => {
                                        let alphanum = CommonValidation.alphanumValidation(e.target.value)
                                        if (e.target.value === "" || alphanum) {
                                            setBilling((prev) => ({ ...prev, policyno: e.target.value }))
                                        }
                                    }} />
                            </Box>
                        :null}
                        {billing.addCoporate ?
                            <Box component={'div'} display={'flex'} p={'0.5rem'}>
                                <Autocomplete
                                    size='small'
                                    id="combo-box-demo-ins"
                                    options={billing.corporateData}
                                    getOptionLabel={(options) => typeof (options) === 'string' ? options : options.company_name}
                                    onChange={(e, value) => {
                                        setBilling((prev) => ({ ...prev, selectedCorporate: value }))
                                    }}
                                    value={billing.selectedCorporate}
                                    sx={{ width: '13vw', marginRight: '1vw' }}
                                    renderInput={(params) => <TextField {...params} label="Corporate Company Name" />}
                                />
                                <TextField
                                    size='small'
                                    label="Employee ID"
                                    variant="outlined"
                                    sx={{ width: '13vw' }}
                                    value={billing.employeeNo}
                                    inputProps={{ maxLength: 25 }}
                                    onChange={(e) => {
                                        let alphanum = CommonValidation.alphanumValidation(e.target.value)
                                        if (e.target.value === "" || alphanum) {
                                            setBilling((prev) => ({ ...prev, employeeNo: e.target.value }))
                                        }
                                    }}/>
                            </Box> : null}
                        {localGetItem('set_due_date_for_credit_billing') === 'true' ?
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker
                                    open={billing.creditDueOpen}
                                    onOpen={() => { setBilling((prev) => ({ ...prev, creditDueOpen: true })) }}
                                    onClose={() => { setBilling((prev) => ({ ...prev, creditDueOpen: false })) }}
                                    value={billing?.credit_due_date}
                                    name={"datePicker"}
                                    label={'Credit Follow Up Date *'}
                                    inputFormat='DD-MM-YYYY'
                                    views={["year", "month", "day"]}
                                    minDate={new Date()}
                                    onChange={
                                        (newDate) => {
                                            setBilling((prev) => ({
                                                ...prev,
                                                credit_due_date: newDate
                                            }))
                                        }}
                                    renderInput={(params) => <TextField
                                        onKeyDown={(e) => e.preventDefault()}
                                        style={{ width: '15vw', margin: "0.5vw" }}
                                        size='small' {...params}
                                        onClick={() => { setBilling((prev) => ({ ...prev, creditDueOpen: true })) }} />}
                                />
                            </LocalizationProvider> : null}
                        <Box component={'div'} display={'flex'} justifyContent={'flex-end'} alignItems={'center'} p={'0.5rem'}>
                            <Button variant='outlined'
                                sx={{ textTransform: 'capitalize', height: '4.5dvh', mr: '1rem' }}
                                onClick={() => setBilling((prev) => ({ ...prev, creditType: false, addCoporate: false, credit_due_date: null }))}
                            >Back</Button>
                            <Button variant='contained'
                                sx={{ textTransform: 'capitalize', height: '4.5dvh', mr: '1rem' }}
                                disabled={localGetItem('set_due_date_for_credit_billing') === 'true' ?
                                    (billing.patientCreditType && !billing.credit_due_date) : false}
                                onClick={() => setBilling((prev) => ({
                                    ...prev,
                                    creditType: false,
                                    addCoporate: false,
                                    addInsurance:false,
                                    selectedCorporate: billing.selectedCorporate,
                                    employeeNo: billing.employeeNo,
                                    policyno: billing.policyno,
                                    selectedCorportateId: details?.employer_id,
                                    selectedInsuranseId:details?.employer_id
                                }))}
                            >Submit</Button>
                        </Box>
                    </Box>
                </Dialog>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const concessionReasonPopup = () => {
        try {
            return (
                <Dialog open={billing.reasonPopup} maxWidth='sm' fullWidth>
                    <Box component={'div'} className='com_billing_popup'>
                        <Box component={'div'} p={'0rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
                            <Typography fontSize={'1rem'} fontWeight={600}>Overall Concession Reason</Typography>
                            <IconButton
                                onClick={() => setBilling((prev) => ({ ...prev, reasonPopup: false, concessionReason: billing.concessionReason ? billing.concessionReason : '' }))}
                            >
                                <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1dvw'} width={'1dvw'} />
                            </IconButton>
                        </Box>
                        <Box component={'div'} p={'0.5rem'}>
                            <TextField
                                size='small'
                                fullWidth
                                multiline
                                rows={4}
                                value={billing.concessionReason}
                                onChange={(e) => {
                                    if (e.target.value?.length <= 250 || e.target.value === '') {
                                        setBilling((prev) => ({ ...prev, concessionReason: e.target.value }))
                                    } else {
                                        errorMessage('Allowed Only 250 Characters')
                                    }
                                }}
                                placeholder='Enter Concession Reason *'
                            />
                        </Box>
                        <Box component={'div'} display={'flex'} justifyContent={'flex-end'} alignItems={'center'} p={'0.5rem'}>
                            <Button variant='contained'
                                onClick={() => {
                                    if (billing.concessionReason === '') {
                                        errorMessage('Enter Reason')
                                    } else {
                                        setBilling((prev) => ({ ...prev, reasonPopup: false }))
                                    }
                                }}
                            >Save</Button>
                        </Box>
                    </Box>
                </Dialog>
            )
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const ReasonPopupClose = () => {
        setBilling((prev) => ({ ...prev, openCancelPopup: false }))
    }

    const addCancelComments = (datas) => {
        try {
            let data = {}
            if (CheckCashCounterAccess() || billing?.received_amount == 0) {
                let payment = []
                if (datas?.isCash) {
                    payment.push(1)
                }
                if (datas?.isUPI) {
                    payment.push(3)
                }
                if (datas?.isBankTranfer) {
                    payment.push(5)
                }
                billing.billingList?.forEach((list) => {
                    const baseAmount = billing?.received_amount
                    list.cash_amount = ((+datas?.CashAmount / baseAmount) * list?.received_amount) || 0;
                    list.upi_amount = ((+datas?.UPIAmount / baseAmount) * list?.received_amount) || 0;
                    list.bank_amount = ((+datas?.BankTfrAmount / baseAmount) * list?.received_amount) || 0;
                    list.bank_ref = datas?.BankTfrNumber;
                    list.upi_ref = datas?.UPINumber;
                })

                data = {
                    "bill_id": billing.bill_id,
                    "cancel_reason": datas?.comments || "",
                    "receipt_type": datas?.receiptType === "Cancel" ? "Cancelled" : "Refund",
                    "line_item": billing.billingList,
                    "received_amount": billing?.received_amount || 0,
                    "cash_amount": +datas?.CashAmount || 0,
                    "upi_amount": +datas?.UPIAmount || 0,
                    "bank_amount": +datas?.BankTfrAmount || 0,
                    "payment_mode": payment,
                    "upi_ref": datas?.UPINumber || "",
                    "bank_ref": datas?.BankTfrNumber || ""
                }
            } else {
                data = {
                    "bill_id": billing.bill_id,
                    "cancel_reason": datas?.comments || "",
                    "request_to": datas?.SelectedCashCounter || "",
                    "request_type": datas?.receiptType === "Cancel" ? "Cancelled" : "Refund",
                }
            }
            RestAPIService[CheckCashCounterAccess() || billing?.received_amount == 0 ? "create" : "updateWithOutId"](data, Serviceurls.NEW_BILING_CANCEL_REQUEST)
                .then((response) => {
                    if (response?.data?.status === 'success') {
                        successMessage(response?.data?.message)
                        if (getCachevalue('FromOtherScreen') === 'true') {
                            clearCachevalue('isForCancelBill')
                            clearCachevalue('BillType')
                            clearCachevalue('FromOtherScreen')
                            let path = getCachevalue('path')
                            history?.push({ pathname: path, state: {} })
                            setTimeout(() => clearCachevalue('path'), 50)
                        }
                    }
                }).catch((error) => {
                    setIsCancelFailed("fail");
                    if (error?.response?.data?.message) {
                        errorMessage(error?.response?.data?.message)
                    } else {
                        errorMessage(error.message)
                    }
                })
        }
        catch (error) {
            errorMessage(error.message)
        }
    }

    const renderRefundPop = () => {
        return (
            billing.openCancelPopup ?
                <ReasonPopupWithRefund
                    fromHospBilling={true}
                    title={"Cancel Bill"}
                    AlertPopupClose={ReasonPopupClose.bind(this)}
                    label={"Enter the Cancel Reason"}
                    btntext={'Close'}
                    btnvarient={'outlined'}
                    btncolor={'error'}
                    btntext1={'Confirm'}
                    btnvarient1={'contained'}
                    RefundPost={addCancelComments.bind(this)}
                    payableAmount={billing?.received_amount || 0}
                    enableBtnText1={isCancelFailed}
                /> : null
        )
    }

    const rejectBilProcess = (comments) => {
        setIsLoader(true)
        setBilling((prev) => ({ ...prev, postLoad: false }))
        let data = setConvertBillData(billing?.billingList);
        setBilling((prev) => ({
            ...prev,
            billingList: data,
            overallDiscount: {
                discount_amount: '',
                discount_percentage: '',
                discount_percentage_w_r: '',
            },
            concessionReason: '',
        }))
        setRequestState((prev) => ({
            ...prev,
            rejected_remarks: comments
        }))
        popClose()
        setTimeout(() => {
            setBilling((prev) => ({
                ...prev,
                triggerReject: true
            }))
        }, 2000);
    }

    const ClosePopUp = () => {
        try {
            setSuccessPopup((prev) => ({
                ...prev,
                SuccessInvoice_ID: null,
                bill_receipt_id: null,
                patientId: null,
                isCredit: false,
                successText: '',
                is_issued_drug: false,
            }))
            if (props.fromQuickBill) {
                if (loginInfo?.module_name === MODULE_NAME.FRONT_OFFICE) {
                    //history?.push({ pathname: '/OPHome' })
                    props.clearPatientData(true)
                }
            }
            if (getCachevalue('FromOtherScreen') === 'true' && getCachevalue('FromCreate') === 'false') {
                clearCachevalue('isForCancelBill')
                clearCachevalue('BillType')
                clearCachevalue('FromOtherScreen')
                let path = getCachevalue('path')
                history?.push({ pathname: path, state: {} })
                setTimeout(() => clearCachevalue('path'), 50)
            }
        } catch (error) {
            errorMessage(error.message)
        }
    }

    const popClose = () => {
        setIsWarning(false)
        settempDup([])
        setIsDelete(false)
        setAnnualFeeAlert(false)
        setRequestState((prev) => ({ ...prev, pendingCancel: false }))
        setAnnualFeeList([])
    }

    const confirmRemove = () => {
        if (annualFeeList?.length) {
            let billList = setBillingListData(annualFeeList, "", true)
            setBilling((prev) => ({ ...prev, billingList: [...prev.billingList, ...billList] }))
            setAnnualFeeList([])
        } else if (annualFeeAlert) {
            setAnnualFeeAlert(false)
            onAddHandler()
        } else {
            setIsWarning(false);
            setBilling((prev) => ({
                ...prev,
                billingList: [...prev.billingList, ...tempDup],
            }));
        }
    };

    return (
        <Box component={'div'}>
            <Grid container>
                <Grid xs={8.7}>
                    <Box component={'div'}
                        sx={{ borderRight: '1.5px solid lightgray' }} m={'0.5rem'}>{renderLftContent()}</Box>
                </Grid>
                <Grid xs={3.3}>
                    <Box mt={'0.5rem'}>{renderRgtContent()}</Box>
                </Grid>
            </Grid>
            {ratePerUnitPopup()}
            {renderDeletePopup()}
            {renderCreditTypePopup()}
            {concessionReasonPopup()}
            {renderRefundPop()}
            {console.log(billing)}
            {successPopup.SuccessInvoice_ID !== null ?
                <BillSuccessPoPUp isDirectPrint={true} CloseBtnText={'Close'}
                    isFromOP={((loginInfo?.module_name === "Laboratory") || (loginInfo?.module_name === "Radiology")) ? false : true} 
                    isCredit={successPopup.isCredit} InvoiceId={successPopup.SuccessInvoice_ID}
                    Receipt_id={successPopup.bill_receipt_id} patientID={successPopup.patiendId}
                    ClosePopUp={ClosePopUp} successTxt={successPopup.successText}
                    patientData={billing.dupPatientData}
                    isFromHospitalBilling={((loginInfo?.module_name === "Laboratory") || (loginInfo?.module_name === "Radiology") || (loginInfo?.module_name === "Investigation")) ? false : true}
                    is_issued_drug={successPopup.is_issued_drug}
                /> : null}
            {message.isErrorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={message.isErrorMsgText}
                    msgPop={msgClose}
                />
                : null}
            {message.successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={message.successMsgText}
                    msgPop={msgClose}
                />
                : null}
            {IsWarning ? <ConfirmPopup
                cnfTitle={'Confirmation'}
                cnfContent={"Some services in the template already exist in the Billing list. Do you want to Continue?"}
                cnfAlertPopupClose={popClose.bind(this)}
                cnfData={confirmRemove.bind(this)}
            /> : null}
            {annualFeeAlert ? <ConfirmPopup
                cnfTitle={'Annual Fee Confirmation'}
                cnfContent={"This service is configured for annual auto billing, and proceeding will start the annual period from today."}
                cnfAlertPopupClose={popClose.bind(this)}
                cnfData={confirmRemove.bind(this)}
            /> : null}
            {annualFeeList?.length ? <ConfirmPopup
                cnfTitle={'Annual Fee Confirmation'}
                cnfContent={"Auto billing services include some annual-fee services. Do you still want to proceed ?"}
                cnfAlertPopupClose={popClose.bind(this)}
                cnfData={confirmRemove.bind(this)}
            /> : null}
            {isDelete ?
                <ReasonPopup
                    title={requestState.pendingCancel ? 'Are you sure do you want to cancel the request ?' : "Are you sure you want to reject the request ?"}
                    AlertPopupClose={popClose.bind(this)}
                    label={"Enter the Cancel Reason"}
                    btntext={'Cancel'}
                    btnvarient={'outlined'}
                    btncolor={'error'}
                    btntext1={'Confirm'}
                    btnvarient1={'contained'}
                    note={true}
                    subTitle={requestState.pendingCancel ? '*The system cancels the request if the concession amount is set to zero.' : "*If you reject a concession request, the system will generate a credit bill reflecting the original amount, with no concession applied."}
                    sendCmt={requestState.pendingCancel ? deletePendingListData.bind(this) : rejectBilProcess.bind(this)} />
                : null}
            <Loader loaderOpen={isLoader} />
            {PopoverBox()}
            {dialogPopup()}
        </Box>
    )
}

export default Billling